// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query'

import { client } from '../client.gen'
import {
  acceptCostEstimate,
  acceptOnboardingCostEstimate,
  acknowledgeFinancialAidApproval,
  acknowledgeRedFlagApproval,
  acknowledgeWaitlistMatch,
  actionItemById,
  actionItemReferrerOptions,
  actionItems,
  advanceOnboardingMilestone,
  appointmentAssessmentAdministrations,
  appointmentChartNote,
  archiveWheelhouseNoteTemplate,
  assessmentAssignment,
  assessmentAudienceOptions,
  assessmentDefinitionById,
  assessmentDefinitions,
  assignTask,
  backToSchoolReviewBanner,
  browserCallToken,
  bulkDeleteClinicianAppointments,
  calendarAppointments,
  calendarAppointmentVideoLink,
  callById,
  calls,
  careOpsQaSpotChecks,
  carePrograms,
  chartNoteClinicalQualityScores,
  claimTask,
  clearReferralDraft,
  clientAppointmentSummary,
  clientAppointments,
  clientAssessmentResults,
  clientAssessmentSendOptions,
  clientBrooklineEvaluationConsent,
  clientById,
  clientCareProgramMembership,
  clientCcbhoEncounterAttestation,
  clientChartNotes,
  clientClinicalDigest,
  clientCommunicationRecipients,
  clientCostEstimateCreate,
  clientCostEstimateSendToFamily,
  clientCostEstimateShow,
  clientCostEstimateSyncInsuranceData,
  clientCostEstimateSyncStatus,
  clientCostEstimateUpdate,
  clientEvents,
  clientForthcomingAppointment,
  clientInfoUpdateSchedule,
  clientInsuranceScans,
  clientNotifications,
  clientPayerFormData,
  clientProcessWorkflow,
  clientProcessWorkflows,
  clientProfile,
  clientSessionLimit,
  clientSurveyResults,
  clinicalQualityDashboardScores,
  clinicalQualityDashboardSummary,
  clinicalQualityScore,
  clinicianAppointments,
  clinicianById,
  clinicianCalendarAppointments,
  clinicianChartNotes,
  clinicianMatchDiagnosis,
  clinicianMatchingCandidatePool,
  clinicianMatchingIntakeOutcomes,
  clinicianMatchingOverview,
  clinicianMatchRuns,
  clinicianMatchRunsSummary,
  clinicianReassignmentFormData,
  clinicianSelectedMatches,
  commentOnActionItem,
  commsPlaygroundCommsMap,
  commsPlaygroundEvents,
  commsPlaygroundTriggerEvent,
  commsPlaygroundUserComms,
  completeTask,
  completeWheelhouseNote,
  concernTypes,
  conversationById,
  conversations,
  costEstimate,
  createAppointmentChartNote,
  createAssessmentDefinition,
  createAssessmentManualSend,
  createAutomatedOutreach,
  createClientDirectUpload,
  createClientEligibility,
  createClientEvent,
  createClientInsuranceScan,
  createClientProcessWorkflow,
  createContractUtilizationFeedback,
  createJourneyAvailabilityNote,
  createJourneySchedulingDeferral,
  createMessage,
  createOnboardingInsuranceScan,
  createOnboardingJourneyBooking,
  createOnboardingMatchingJourney,
  createOnboardingPaymentMethodSetupIntent,
  createReassignment,
  createReferral,
  createReferrerTourCompletion,
  createSchedulingBooking,
  createSurvey,
  createTaskNote,
  createWheelhouseDocument,
  createWheelhouseEncounter,
  createWheelhouseGoal,
  createWheelhouseGoalObservation,
  createWheelhouseNote,
  createWheelhouseNoteTemplate,
  currentUser,
  currentUserAhoyEventExists,
  currentUserProfile,
  dashboardContractOverview,
  decideClinicalReauthorization,
  decideReauthorization,
  declineCostEstimate,
  declineInternalReferral,
  deleteSurvey,
  deleteWheelhouseNote,
  dischargeClientFromCareProgram,
  dismissBackToSchoolReviewBanner,
  dismissProductAnnouncement,
  enhanceWheelhouseNote,
  enrollClientInCareProgram,
  familyInterestContext,
  familyInterestDraft,
  familyInterestFeaturedClinicians,
  familyInterestInstitutions,
  getBackToSchoolReviews,
  getBackToSchoolReviewsReferrers,
  getBackToSchoolReviewsSchools,
  getBackToSchoolReviewsSchoolsBySchoolIdGrades,
  getCurrentClient,
  internalReferralById,
  joinClientForthcomingAppointment,
  journeySchedulingInfo,
  journeySlots,
  kustomerProfile,
  meeting,
  messages,
  myTasks,
  type Options,
  onboardingAddress,
  onboardingAvailabilities,
  onboardingById,
  onboardingComplete,
  onboardingConcerns,
  onboardingConsents,
  onboardingContext,
  onboardingCostEstimate,
  onboardingEligibilityStatus,
  onboardingFeaturedClinicians,
  onboardingIdentityPreferences,
  onboardingJointConsents,
  onboardingMatch,
  onboardingMeetingPreference,
  onboardingPayers,
  onboardingServiceLines,
  onboardingSessionHeld,
  onboardingVerificationStatus,
  organizationInstitutions,
  organizationStaff,
  payers,
  pollChartNoteClinicalQualityScore,
  postBackToSchoolReviewsBatchUpdates,
  publishAssessmentVersion,
  publishClientClinicalDigest,
  reassignmentById,
  reassignments,
  reauthorizationEligibility,
  reauthorizationReviewContext,
  reauthorizationReviewSummary,
  recordCarrierLookupView,
  recordClientBrooklineEvaluationConsent,
  recordClientCcbhoEncounterAttestation,
  recordClinicianJoin,
  recordContractUtilizationBadgeImpression,
  recordContractUtilizationBadgeInteraction,
  recordCostConcernsSelection,
  recordCostEstimateView,
  recordFweCompleted,
  recordInsuranceNotVerified,
  recordJointConsentTaskEscalationOutcome,
  recordNoInsuranceSelection,
  recordSessionHeldEndFlow,
  recordTimeslotSelected,
  recordWaitlistEndFlow,
  recordWaitlistRequested,
  referralDraft,
  referralOnboardingProgress,
  rejectWheelhouseClaim,
  releaseTask,
  requestFinancialAid,
  requestReassignmentSchedulingHelp,
  resetOrganizationReferralContacts,
  resolveActionItem,
  resolveClinicianMatchingId,
  respondToSurvey,
  saveOnboardingAddress,
  saveOnboardingAvailabilities,
  saveOnboardingConcerns,
  saveOnboardingConsents,
  saveOnboardingIdentityPreferences,
  saveOnboardingJointConsents,
  saveOnboardingMeetingPreference,
  saveOnboardingServiceLines,
  saveSchedulingIdentityPreferences,
  saveSchedulingMeetingPreference,
  schedulingClinicianMatch,
  schedulingClinicianMatches,
  schedulingContext,
  scoreChartNoteClinicalQuality,
  searchClinicianMatchingClients,
  searchClinicianMatchingClinicians,
  signWheelhouseClaim,
  submitAssessmentResponse,
  submitFamilyInterest,
  submitInsuranceZipCodeLookup,
  submitOnboardingInsurance,
  submitOnboardingInsuranceSelfReport,
  submitOnboardingSelfPay,
  submitSurveyResponseCallback,
  surveyById,
  surveyResponseById,
  surveyResponses,
  surveySchemaById,
  surveySchemas,
  surveys,
  taskById,
  taskEvents,
  taskInsuranceVerificationContext,
  taskReassignmentSchedulingContext,
  taskResolveMedicaidMcoMapping,
  taskResolveVerifyInsurance,
  taskScheduleIntakeContext,
  taskSchedulingContext,
  tasks,
  toggleAssessmentAutoSend,
  trackCurrentUserAhoyEvent,
  triggerClientInfoUpdate,
  unpublishClientClinicalDigest,
  updateAssessmentDefinition,
  updateClientCareProgramMembership,
  updateClientInfoUpdateSchedule,
  updateClientPayer,
  updateClientSecondGuardian,
  updateFamilyInterestDraft,
  updateJourneySlots,
  updateReassignment,
  updateReferralDraft,
  updateSchoolReferralContact,
  updateSurvey,
  updateUserPhoneNumber,
  updateWheelhouseClaim,
  updateWheelhouseDocument,
  updateWheelhouseEncounter,
  updateWheelhouseGoal,
  updateWheelhouseGoalObservation,
  updateWheelhouseNote,
  updateWheelhouseNoteTemplate,
  users,
  verifyClient,
  verifyFamilyIdentity,
  wheelhouseClaim,
  wheelhouseClaims,
  wheelhouseClient,
  wheelhouseClientDocuments,
  wheelhouseClientGoals,
  wheelhouseClients,
  wheelhouseDocument,
  wheelhouseEncounter,
  wheelhouseEncounters,
  wheelhouseGoal,
  wheelhouseGoalObservations,
  wheelhouseNoteTemplates,
  wheelhouseSession,
} from '../sdk.gen'
import type {
  AcceptCostEstimateData,
  AcceptCostEstimateError,
  AcceptCostEstimateResponse,
  AcceptOnboardingCostEstimateData,
  AcceptOnboardingCostEstimateError,
  AcceptOnboardingCostEstimateResponse,
  AcknowledgeFinancialAidApprovalData,
  AcknowledgeFinancialAidApprovalError,
  AcknowledgeFinancialAidApprovalResponse,
  AcknowledgeRedFlagApprovalData,
  AcknowledgeRedFlagApprovalError,
  AcknowledgeRedFlagApprovalResponse,
  AcknowledgeWaitlistMatchData,
  AcknowledgeWaitlistMatchError,
  AcknowledgeWaitlistMatchResponse,
  ActionItemByIdData,
  ActionItemByIdError,
  ActionItemByIdResponse,
  ActionItemReferrerOptionsData,
  ActionItemReferrerOptionsError,
  ActionItemReferrerOptionsResponse,
  ActionItemsData,
  ActionItemsError,
  ActionItemsResponse,
  AdvanceOnboardingMilestoneData,
  AdvanceOnboardingMilestoneError,
  AdvanceOnboardingMilestoneResponse,
  AppointmentAssessmentAdministrationsData,
  AppointmentAssessmentAdministrationsError,
  AppointmentAssessmentAdministrationsResponse,
  AppointmentChartNoteData,
  AppointmentChartNoteError,
  AppointmentChartNoteResponse,
  ArchiveWheelhouseNoteTemplateData,
  ArchiveWheelhouseNoteTemplateResponse,
  AssessmentAssignmentData,
  AssessmentAssignmentError,
  AssessmentAssignmentResponse,
  AssessmentAudienceOptionsData,
  AssessmentAudienceOptionsError,
  AssessmentAudienceOptionsResponse,
  AssessmentDefinitionByIdData,
  AssessmentDefinitionByIdError,
  AssessmentDefinitionByIdResponse,
  AssessmentDefinitionsData,
  AssessmentDefinitionsError,
  AssessmentDefinitionsResponse,
  AssignTaskData,
  AssignTaskError,
  AssignTaskResponse,
  BackToSchoolReviewBannerData,
  BackToSchoolReviewBannerResponse,
  BrowserCallTokenData,
  BrowserCallTokenError,
  BrowserCallTokenResponse2,
  BulkDeleteClinicianAppointmentsData,
  BulkDeleteClinicianAppointmentsError,
  CalendarAppointmentsData,
  CalendarAppointmentsError,
  CalendarAppointmentsResponse,
  CalendarAppointmentVideoLinkData,
  CalendarAppointmentVideoLinkError,
  CalendarAppointmentVideoLinkResponse,
  CallByIdData,
  CallByIdResponse,
  CallsData,
  CallsError,
  CallsResponse,
  CareOpsQaSpotChecksData,
  CareOpsQaSpotChecksError,
  CareOpsQaSpotChecksResponse2,
  CareProgramsData,
  CareProgramsResponse,
  ChartNoteClinicalQualityScoresData,
  ChartNoteClinicalQualityScoresResponse,
  ClaimTaskData,
  ClaimTaskError,
  ClaimTaskResponse,
  ClearReferralDraftData,
  ClearReferralDraftResponse,
  ClientAppointmentSummaryData,
  ClientAppointmentSummaryError,
  ClientAppointmentSummaryResponse,
  ClientAppointmentsData,
  ClientAppointmentsError,
  ClientAppointmentsResponse,
  ClientAssessmentResultsData,
  ClientAssessmentResultsError,
  ClientAssessmentResultsResponse,
  ClientAssessmentSendOptionsData,
  ClientAssessmentSendOptionsError,
  ClientAssessmentSendOptionsResponse,
  ClientBrooklineEvaluationConsentData,
  ClientBrooklineEvaluationConsentError,
  ClientBrooklineEvaluationConsentResponse,
  ClientByIdData,
  ClientByIdError,
  ClientByIdResponse,
  ClientCareProgramMembershipData,
  ClientCareProgramMembershipResponse,
  ClientCcbhoEncounterAttestationData,
  ClientCcbhoEncounterAttestationError,
  ClientCcbhoEncounterAttestationResponse,
  ClientChartNotesData,
  ClientChartNotesError,
  ClientChartNotesResponse,
  ClientClinicalDigestData,
  ClientClinicalDigestError,
  ClientClinicalDigestResponse,
  ClientCommunicationRecipientsData,
  ClientCommunicationRecipientsError,
  ClientCommunicationRecipientsResponse,
  ClientCostEstimateCreateData,
  ClientCostEstimateCreateError,
  ClientCostEstimateCreateResponse,
  ClientCostEstimateSendToFamilyData,
  ClientCostEstimateSendToFamilyError,
  ClientCostEstimateSendToFamilyResponse,
  ClientCostEstimateShowData,
  ClientCostEstimateShowError,
  ClientCostEstimateShowResponse,
  ClientCostEstimateSyncInsuranceDataData,
  ClientCostEstimateSyncInsuranceDataError,
  ClientCostEstimateSyncInsuranceDataResponse,
  ClientCostEstimateSyncStatusData,
  ClientCostEstimateSyncStatusError,
  ClientCostEstimateSyncStatusResponse,
  ClientCostEstimateUpdateData,
  ClientCostEstimateUpdateError,
  ClientCostEstimateUpdateResponse,
  ClientEventsData,
  ClientEventsError,
  ClientEventsResponse,
  ClientForthcomingAppointmentData,
  ClientForthcomingAppointmentError,
  ClientForthcomingAppointmentResponse,
  ClientInfoUpdateScheduleData,
  ClientInfoUpdateScheduleError,
  ClientInfoUpdateScheduleResponse,
  ClientInsuranceScansData,
  ClientInsuranceScansError,
  ClientInsuranceScansResponse,
  ClientNotificationsData,
  ClientNotificationsResponse,
  ClientPayerFormDataData,
  ClientPayerFormDataError,
  ClientPayerFormDataResponse,
  ClientProcessWorkflowData,
  ClientProcessWorkflowError,
  ClientProcessWorkflowResponse,
  ClientProcessWorkflowsData,
  ClientProcessWorkflowsError,
  ClientProcessWorkflowsResponse,
  ClientProfileData,
  ClientProfileError,
  ClientProfileResponse,
  ClientSessionLimitData,
  ClientSessionLimitError,
  ClientSessionLimitResponse,
  ClientSurveyResultsData,
  ClientSurveyResultsResponse,
  ClinicalQualityDashboardScoresData,
  ClinicalQualityDashboardScoresError,
  ClinicalQualityDashboardScoresResponse2,
  ClinicalQualityDashboardSummaryData,
  ClinicalQualityDashboardSummaryError,
  ClinicalQualityDashboardSummaryResponse,
  ClinicalQualityScoreData,
  ClinicalQualityScoreResponse,
  ClinicianAppointmentsData,
  ClinicianAppointmentsError,
  ClinicianAppointmentsResponse,
  ClinicianByIdData,
  ClinicianByIdError,
  ClinicianByIdResponse,
  ClinicianCalendarAppointmentsData,
  ClinicianCalendarAppointmentsError,
  ClinicianCalendarAppointmentsResponse,
  ClinicianChartNotesData,
  ClinicianChartNotesError,
  ClinicianChartNotesResponse,
  ClinicianMatchDiagnosisData,
  ClinicianMatchDiagnosisResponse,
  ClinicianMatchingCandidatePoolData,
  ClinicianMatchingCandidatePoolResponse,
  ClinicianMatchingIntakeOutcomesData,
  ClinicianMatchingIntakeOutcomesResponse,
  ClinicianMatchingOverviewData,
  ClinicianMatchingOverviewResponse,
  ClinicianMatchRunsData,
  ClinicianMatchRunsResponse,
  ClinicianMatchRunsSummaryData,
  ClinicianMatchRunsSummaryResponse,
  ClinicianReassignmentFormDataData,
  ClinicianReassignmentFormDataError,
  ClinicianReassignmentFormDataResponse,
  ClinicianSelectedMatchesData,
  ClinicianSelectedMatchesResponse,
  CommentOnActionItemData,
  CommentOnActionItemError,
  CommentOnActionItemResponse,
  CommsPlaygroundCommsMapData,
  CommsPlaygroundCommsMapResponse,
  CommsPlaygroundEventsData,
  CommsPlaygroundEventsResponse,
  CommsPlaygroundTriggerEventData,
  CommsPlaygroundTriggerEventError,
  CommsPlaygroundTriggerEventResponse,
  CommsPlaygroundUserCommsData,
  CommsPlaygroundUserCommsResponse,
  CompleteTaskData,
  CompleteTaskError,
  CompleteTaskResponse,
  CompleteWheelhouseNoteData,
  CompleteWheelhouseNoteError,
  CompleteWheelhouseNoteResponse,
  ConcernTypesData,
  ConcernTypesResponse,
  ConversationByIdData,
  ConversationByIdResponse,
  ConversationsData,
  ConversationsError,
  ConversationsResponse,
  CostEstimateData,
  CostEstimateError,
  CostEstimateResponse,
  CreateAppointmentChartNoteData,
  CreateAppointmentChartNoteError,
  CreateAppointmentChartNoteResponse,
  CreateAssessmentDefinitionData,
  CreateAssessmentDefinitionError,
  CreateAssessmentDefinitionResponse,
  CreateAssessmentManualSendData,
  CreateAssessmentManualSendError,
  CreateAssessmentManualSendResponse,
  CreateAutomatedOutreachData,
  CreateAutomatedOutreachError,
  CreateAutomatedOutreachResponse,
  CreateClientDirectUploadData,
  CreateClientDirectUploadError,
  CreateClientDirectUploadResponse,
  CreateClientEligibilityData,
  CreateClientEligibilityError,
  CreateClientEligibilityResponse,
  CreateClientEventData,
  CreateClientEventError,
  CreateClientEventResponse,
  CreateClientInsuranceScanData,
  CreateClientInsuranceScanError,
  CreateClientInsuranceScanResponse,
  CreateClientProcessWorkflowData,
  CreateClientProcessWorkflowError,
  CreateContractUtilizationFeedbackData,
  CreateJourneyAvailabilityNoteData,
  CreateJourneyAvailabilityNoteError,
  CreateJourneyAvailabilityNoteResponse,
  CreateJourneySchedulingDeferralData,
  CreateJourneySchedulingDeferralError,
  CreateJourneySchedulingDeferralResponse,
  CreateMessageData,
  CreateMessageError,
  CreateMessageResponse,
  CreateOnboardingInsuranceScanData,
  CreateOnboardingInsuranceScanError,
  CreateOnboardingInsuranceScanResponse,
  CreateOnboardingJourneyBookingData,
  CreateOnboardingJourneyBookingError,
  CreateOnboardingJourneyBookingResponse,
  CreateOnboardingMatchingJourneyData,
  CreateOnboardingMatchingJourneyError,
  CreateOnboardingMatchingJourneyResponse,
  CreateOnboardingPaymentMethodSetupIntentData,
  CreateOnboardingPaymentMethodSetupIntentError,
  CreateOnboardingPaymentMethodSetupIntentResponse,
  CreateReassignmentData,
  CreateReassignmentError,
  CreateReassignmentResponse,
  CreateReferralData,
  CreateReferralError,
  CreateReferrerTourCompletionData,
  CreateSchedulingBookingData,
  CreateSchedulingBookingError,
  CreateSchedulingBookingResponse,
  CreateSurveyData,
  CreateSurveyError,
  CreateSurveyResponse,
  CreateTaskNoteData,
  CreateTaskNoteError,
  CreateTaskNoteResponse,
  CreateWheelhouseDocumentData,
  CreateWheelhouseDocumentError,
  CreateWheelhouseDocumentResponse,
  CreateWheelhouseEncounterData,
  CreateWheelhouseEncounterError,
  CreateWheelhouseEncounterResponse,
  CreateWheelhouseGoalData,
  CreateWheelhouseGoalObservationData,
  CreateWheelhouseGoalObservationError,
  CreateWheelhouseGoalObservationResponse,
  CreateWheelhouseGoalResponse,
  CreateWheelhouseNoteData,
  CreateWheelhouseNoteError,
  CreateWheelhouseNoteResponse,
  CreateWheelhouseNoteTemplateData,
  CreateWheelhouseNoteTemplateError,
  CreateWheelhouseNoteTemplateResponse,
  CurrentUserAhoyEventExistsData,
  CurrentUserAhoyEventExistsError,
  CurrentUserAhoyEventExistsResponse,
  CurrentUserData,
  CurrentUserError,
  CurrentUserProfileData,
  CurrentUserProfileError,
  CurrentUserProfileResponse,
  CurrentUserResponse2,
  DashboardContractOverviewData,
  DashboardContractOverviewError,
  DashboardContractOverviewResponse,
  DecideClinicalReauthorizationData,
  DecideClinicalReauthorizationError,
  DecideClinicalReauthorizationResponse,
  DecideReauthorizationData,
  DecideReauthorizationError,
  DecideReauthorizationResponse,
  DeclineCostEstimateData,
  DeclineCostEstimateError,
  DeclineCostEstimateResponse,
  DeclineInternalReferralData,
  DeclineInternalReferralError,
  DeclineInternalReferralResponse,
  DeleteSurveyData,
  DeleteSurveyResponse,
  DeleteWheelhouseNoteData,
  DeleteWheelhouseNoteResponse,
  DischargeClientFromCareProgramData,
  DischargeClientFromCareProgramError,
  DischargeClientFromCareProgramResponse,
  DismissBackToSchoolReviewBannerData,
  DismissBackToSchoolReviewBannerResponse,
  DismissProductAnnouncementData,
  DismissProductAnnouncementResponse,
  EnhanceWheelhouseNoteData,
  EnhanceWheelhouseNoteError,
  EnhanceWheelhouseNoteResponse,
  EnrollClientInCareProgramData,
  EnrollClientInCareProgramError,
  EnrollClientInCareProgramResponse,
  FamilyInterestContextData,
  FamilyInterestContextError,
  FamilyInterestContextResponse,
  FamilyInterestDraftData,
  FamilyInterestDraftError,
  FamilyInterestDraftResponse,
  FamilyInterestFeaturedCliniciansData,
  FamilyInterestFeaturedCliniciansError,
  FamilyInterestFeaturedCliniciansResponse,
  FamilyInterestInstitutionsData,
  FamilyInterestInstitutionsError,
  FamilyInterestInstitutionsResponse2,
  GetBackToSchoolReviewsData,
  GetBackToSchoolReviewsError,
  GetBackToSchoolReviewsReferrersData,
  GetBackToSchoolReviewsReferrersResponse,
  GetBackToSchoolReviewsResponse,
  GetBackToSchoolReviewsSchoolsBySchoolIdGradesData,
  GetBackToSchoolReviewsSchoolsBySchoolIdGradesResponse,
  GetBackToSchoolReviewsSchoolsData,
  GetBackToSchoolReviewsSchoolsResponse,
  GetCurrentClientData,
  GetCurrentClientError,
  GetCurrentClientResponse,
  InternalReferralByIdData,
  InternalReferralByIdError,
  InternalReferralByIdResponse,
  JoinClientForthcomingAppointmentData,
  JoinClientForthcomingAppointmentError,
  JoinClientForthcomingAppointmentResponse,
  JourneySchedulingInfoData,
  JourneySchedulingInfoError,
  JourneySchedulingInfoResponse,
  JourneySlotsData,
  JourneySlotsError,
  JourneySlotsResponse,
  KustomerProfileData,
  KustomerProfileError,
  KustomerProfileResponse,
  MeetingData,
  MeetingError,
  MeetingResponse,
  MessagesData,
  MessagesError,
  MessagesResponse,
  MyTasksData,
  MyTasksError,
  MyTasksResponse,
  OnboardingAddressData,
  OnboardingAddressError,
  OnboardingAddressResponse2,
  OnboardingAvailabilitiesData,
  OnboardingAvailabilitiesResponse,
  OnboardingByIdData,
  OnboardingByIdError,
  OnboardingByIdResponse,
  OnboardingCompleteData,
  OnboardingCompleteError,
  OnboardingCompleteResponse,
  OnboardingConcernsData,
  OnboardingConcernsResponse2,
  OnboardingConsentsData,
  OnboardingConsentsError,
  OnboardingConsentsResponse,
  OnboardingContextData,
  OnboardingContextError,
  OnboardingContextResponse2,
  OnboardingCostEstimateData,
  OnboardingCostEstimateError,
  OnboardingCostEstimateResponse2,
  OnboardingEligibilityStatusData,
  OnboardingEligibilityStatusError,
  OnboardingEligibilityStatusResponse,
  OnboardingFeaturedCliniciansData,
  OnboardingFeaturedCliniciansError,
  OnboardingFeaturedCliniciansResponse2,
  OnboardingIdentityPreferencesData,
  OnboardingIdentityPreferencesResponse,
  OnboardingJointConsentsData,
  OnboardingJointConsentsError,
  OnboardingJointConsentsResponse,
  OnboardingMatchData,
  OnboardingMatchError,
  OnboardingMatchResponse,
  OnboardingMeetingPreferenceData,
  OnboardingMeetingPreferenceResponse,
  OnboardingPayersData,
  OnboardingPayersError,
  OnboardingPayersResponse,
  OnboardingServiceLinesData,
  OnboardingServiceLinesResponse,
  OnboardingSessionHeldData,
  OnboardingSessionHeldError,
  OnboardingSessionHeldResponse,
  OnboardingVerificationStatusData,
  OnboardingVerificationStatusError,
  OnboardingVerificationStatusResponse,
  OrganizationInstitutionsData,
  OrganizationInstitutionsError,
  OrganizationInstitutionsResponse,
  OrganizationStaffData,
  OrganizationStaffError,
  OrganizationStaffResponse,
  PayersData,
  PayersResponse,
  PollChartNoteClinicalQualityScoreData,
  PollChartNoteClinicalQualityScoreResponse,
  PostBackToSchoolReviewsBatchUpdatesData,
  PostBackToSchoolReviewsBatchUpdatesResponse,
  PublishAssessmentVersionData,
  PublishAssessmentVersionError,
  PublishAssessmentVersionResponse,
  PublishClientClinicalDigestData,
  PublishClientClinicalDigestError,
  PublishClientClinicalDigestResponse,
  ReassignmentByIdData,
  ReassignmentByIdError,
  ReassignmentByIdResponse,
  ReassignmentsData,
  ReassignmentsError,
  ReassignmentsResponse,
  ReauthorizationEligibilityData,
  ReauthorizationEligibilityError,
  ReauthorizationEligibilityResponse,
  ReauthorizationReviewContextData,
  ReauthorizationReviewContextError,
  ReauthorizationReviewContextResponse,
  ReauthorizationReviewSummaryData,
  ReauthorizationReviewSummaryError,
  ReauthorizationReviewSummaryResponse,
  RecordCarrierLookupViewData,
  RecordCarrierLookupViewError,
  RecordCarrierLookupViewResponse,
  RecordClientBrooklineEvaluationConsentData,
  RecordClientBrooklineEvaluationConsentError,
  RecordClientBrooklineEvaluationConsentResponse,
  RecordClientCcbhoEncounterAttestationData,
  RecordClientCcbhoEncounterAttestationError,
  RecordClientCcbhoEncounterAttestationResponse,
  RecordClinicianJoinData,
  RecordClinicianJoinError,
  RecordClinicianJoinResponse,
  RecordContractUtilizationBadgeImpressionData,
  RecordContractUtilizationBadgeInteractionData,
  RecordCostConcernsSelectionData,
  RecordCostConcernsSelectionError,
  RecordCostConcernsSelectionResponse,
  RecordCostEstimateViewData,
  RecordCostEstimateViewError,
  RecordCostEstimateViewResponse,
  RecordFweCompletedData,
  RecordFweCompletedError,
  RecordFweCompletedResponse,
  RecordInsuranceNotVerifiedData,
  RecordInsuranceNotVerifiedError,
  RecordInsuranceNotVerifiedResponse,
  RecordJointConsentTaskEscalationOutcomeData,
  RecordJointConsentTaskEscalationOutcomeError,
  RecordJointConsentTaskEscalationOutcomeResponse,
  RecordNoInsuranceSelectionData,
  RecordNoInsuranceSelectionError,
  RecordNoInsuranceSelectionResponse,
  RecordSessionHeldEndFlowData,
  RecordSessionHeldEndFlowError,
  RecordSessionHeldEndFlowResponse,
  RecordTimeslotSelectedData,
  RecordTimeslotSelectedError,
  RecordTimeslotSelectedResponse,
  RecordWaitlistEndFlowData,
  RecordWaitlistEndFlowError,
  RecordWaitlistEndFlowResponse,
  RecordWaitlistRequestedData,
  RecordWaitlistRequestedError,
  RecordWaitlistRequestedResponse,
  ReferralDraftData,
  ReferralDraftResponse,
  ReferralOnboardingProgressData,
  ReferralOnboardingProgressResponse,
  RejectWheelhouseClaimData,
  RejectWheelhouseClaimResponse,
  ReleaseTaskData,
  ReleaseTaskError,
  ReleaseTaskResponse,
  RequestFinancialAidData,
  RequestFinancialAidError,
  RequestFinancialAidResponse,
  RequestReassignmentSchedulingHelpData,
  RequestReassignmentSchedulingHelpError,
  RequestReassignmentSchedulingHelpResponse,
  ResetOrganizationReferralContactsData,
  ResetOrganizationReferralContactsResponse,
  ResolveActionItemData,
  ResolveActionItemError,
  ResolveActionItemResponse,
  ResolveClinicianMatchingIdData,
  ResolveClinicianMatchingIdResponse,
  RespondToSurveyData,
  RespondToSurveyError,
  RespondToSurveyResponse,
  SaveOnboardingAddressData,
  SaveOnboardingAddressError,
  SaveOnboardingAddressResponse,
  SaveOnboardingAvailabilitiesData,
  SaveOnboardingAvailabilitiesError,
  SaveOnboardingAvailabilitiesResponse,
  SaveOnboardingConcernsData,
  SaveOnboardingConcernsError,
  SaveOnboardingConcernsResponse,
  SaveOnboardingConsentsData,
  SaveOnboardingConsentsError,
  SaveOnboardingConsentsResponse,
  SaveOnboardingIdentityPreferencesData,
  SaveOnboardingIdentityPreferencesError,
  SaveOnboardingIdentityPreferencesResponse,
  SaveOnboardingJointConsentsData,
  SaveOnboardingJointConsentsError,
  SaveOnboardingJointConsentsResponse,
  SaveOnboardingMeetingPreferenceData,
  SaveOnboardingMeetingPreferenceError,
  SaveOnboardingMeetingPreferenceResponse,
  SaveOnboardingServiceLinesData,
  SaveOnboardingServiceLinesError,
  SaveOnboardingServiceLinesResponse,
  SaveSchedulingIdentityPreferencesData,
  SaveSchedulingIdentityPreferencesError,
  SaveSchedulingIdentityPreferencesResponse,
  SaveSchedulingMeetingPreferenceData,
  SaveSchedulingMeetingPreferenceError,
  SaveSchedulingMeetingPreferenceResponse,
  SchedulingClinicianMatchData,
  SchedulingClinicianMatchError,
  SchedulingClinicianMatchesData,
  SchedulingClinicianMatchesError,
  SchedulingClinicianMatchesResponse,
  SchedulingClinicianMatchResponse,
  SchedulingContextData,
  SchedulingContextError,
  SchedulingContextResponse,
  ScoreChartNoteClinicalQualityData,
  SearchClinicianMatchingClientsData,
  SearchClinicianMatchingClientsResponse,
  SearchClinicianMatchingCliniciansData,
  SearchClinicianMatchingCliniciansResponse,
  SignWheelhouseClaimData,
  SignWheelhouseClaimError,
  SignWheelhouseClaimResponse,
  SubmitAssessmentResponseData,
  SubmitAssessmentResponseError,
  SubmitAssessmentResponseResponse,
  SubmitFamilyInterestData,
  SubmitFamilyInterestError,
  SubmitFamilyInterestResponse,
  SubmitInsuranceZipCodeLookupData,
  SubmitInsuranceZipCodeLookupError,
  SubmitInsuranceZipCodeLookupResponse,
  SubmitOnboardingInsuranceData,
  SubmitOnboardingInsuranceError,
  SubmitOnboardingInsuranceResponse,
  SubmitOnboardingInsuranceSelfReportData,
  SubmitOnboardingInsuranceSelfReportError,
  SubmitOnboardingInsuranceSelfReportResponse,
  SubmitOnboardingSelfPayData,
  SubmitOnboardingSelfPayError,
  SubmitOnboardingSelfPayResponse,
  SubmitSurveyResponseCallbackData,
  SubmitSurveyResponseCallbackError,
  SubmitSurveyResponseCallbackResponse,
  SurveyByIdData,
  SurveyByIdError,
  SurveyByIdResponse,
  SurveyResponseByIdData,
  SurveyResponseByIdError,
  SurveyResponseByIdResponse,
  SurveyResponsesData,
  SurveyResponsesResponse,
  SurveySchemaByIdData,
  SurveySchemaByIdError,
  SurveySchemaByIdResponse,
  SurveySchemasData,
  SurveySchemasResponse,
  SurveysData,
  SurveysResponse,
  TaskByIdData,
  TaskByIdResponse,
  TaskEventsData,
  TaskEventsError,
  TaskEventsResponse,
  TaskInsuranceVerificationContextData,
  TaskInsuranceVerificationContextError,
  TaskInsuranceVerificationContextResponse,
  TaskReassignmentSchedulingContextData,
  TaskReassignmentSchedulingContextError,
  TaskReassignmentSchedulingContextResponse,
  TaskResolveMedicaidMcoMappingData,
  TaskResolveMedicaidMcoMappingError,
  TaskResolveMedicaidMcoMappingResponse,
  TaskResolveVerifyInsuranceData,
  TaskResolveVerifyInsuranceError,
  TaskResolveVerifyInsuranceResponse,
  TaskScheduleIntakeContextData,
  TaskScheduleIntakeContextError,
  TaskScheduleIntakeContextResponse,
  TaskSchedulingContextData,
  TaskSchedulingContextError,
  TaskSchedulingContextResponse,
  TasksData,
  TasksResponse2,
  ToggleAssessmentAutoSendData,
  ToggleAssessmentAutoSendError,
  ToggleAssessmentAutoSendResponse,
  TrackCurrentUserAhoyEventData,
  TrackCurrentUserAhoyEventError,
  TrackCurrentUserAhoyEventResponse,
  TriggerClientInfoUpdateData,
  TriggerClientInfoUpdateError,
  TriggerClientInfoUpdateResponse,
  UnpublishClientClinicalDigestData,
  UnpublishClientClinicalDigestError,
  UnpublishClientClinicalDigestResponse,
  UpdateAssessmentDefinitionData,
  UpdateAssessmentDefinitionError,
  UpdateAssessmentDefinitionResponse,
  UpdateClientCareProgramMembershipData,
  UpdateClientCareProgramMembershipError,
  UpdateClientCareProgramMembershipResponse,
  UpdateClientInfoUpdateScheduleData,
  UpdateClientInfoUpdateScheduleError,
  UpdateClientInfoUpdateScheduleResponse,
  UpdateClientPayerData,
  UpdateClientPayerError,
  UpdateClientPayerResponse,
  UpdateClientSecondGuardianData,
  UpdateFamilyInterestDraftData,
  UpdateFamilyInterestDraftError,
  UpdateFamilyInterestDraftResponse,
  UpdateJourneySlotsData,
  UpdateJourneySlotsError,
  UpdateJourneySlotsResponse,
  UpdateReassignmentData,
  UpdateReassignmentError,
  UpdateReassignmentResponse,
  UpdateReferralDraftData,
  UpdateReferralDraftError,
  UpdateReferralDraftResponse,
  UpdateSchoolReferralContactData,
  UpdateSchoolReferralContactError,
  UpdateSchoolReferralContactResponse,
  UpdateSurveyData,
  UpdateSurveyError,
  UpdateSurveyResponse,
  UpdateUserPhoneNumberData,
  UpdateUserPhoneNumberError,
  UpdateUserPhoneNumberResponse,
  UpdateWheelhouseClaimData,
  UpdateWheelhouseClaimResponse,
  UpdateWheelhouseDocumentData,
  UpdateWheelhouseDocumentError,
  UpdateWheelhouseDocumentResponse,
  UpdateWheelhouseEncounterData,
  UpdateWheelhouseEncounterError,
  UpdateWheelhouseEncounterResponse,
  UpdateWheelhouseGoalData,
  UpdateWheelhouseGoalError,
  UpdateWheelhouseGoalObservationData,
  UpdateWheelhouseGoalObservationError,
  UpdateWheelhouseGoalObservationResponse,
  UpdateWheelhouseGoalResponse,
  UpdateWheelhouseNoteData,
  UpdateWheelhouseNoteError,
  UpdateWheelhouseNoteResponse,
  UpdateWheelhouseNoteTemplateData,
  UpdateWheelhouseNoteTemplateError,
  UpdateWheelhouseNoteTemplateResponse,
  UsersData,
  UsersError,
  UsersResponse,
  VerifyClientData,
  VerifyClientError,
  VerifyClientResponse,
  VerifyFamilyIdentityData,
  VerifyFamilyIdentityError,
  VerifyFamilyIdentityResponse,
  WheelhouseClaimData,
  WheelhouseClaimResponse,
  WheelhouseClaimsData,
  WheelhouseClaimsResponse,
  WheelhouseClientData,
  WheelhouseClientDocumentsData,
  WheelhouseClientDocumentsError,
  WheelhouseClientDocumentsResponse,
  WheelhouseClientError,
  WheelhouseClientGoalsData,
  WheelhouseClientGoalsResponse,
  WheelhouseClientResponse,
  WheelhouseClientsData,
  WheelhouseClientsError,
  WheelhouseClientsResponse,
  WheelhouseDocumentData,
  WheelhouseDocumentError,
  WheelhouseDocumentResponse,
  WheelhouseEncounterData,
  WheelhouseEncounterError,
  WheelhouseEncounterResponse,
  WheelhouseEncountersData,
  WheelhouseEncountersError,
  WheelhouseEncountersResponse,
  WheelhouseGoalData,
  WheelhouseGoalError,
  WheelhouseGoalObservationsData,
  WheelhouseGoalObservationsResponse,
  WheelhouseGoalResponse,
  WheelhouseNoteTemplatesData,
  WheelhouseNoteTemplatesError,
  WheelhouseNoteTemplatesResponse,
  WheelhouseSessionData,
  WheelhouseSessionError,
  WheelhouseSessionResponse,
} from '../types.gen'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const actionItemsQueryKey = (options?: Options<ActionItemsData>) =>
  createQueryKey('actionItems', options)

/**
 * Lists action items for the user's organization
 */
export const actionItemsOptions = (options?: Options<ActionItemsData>) =>
  queryOptions<
    ActionItemsResponse,
    ActionItemsError,
    ActionItemsResponse,
    ReturnType<typeof actionItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await actionItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: actionItemsQueryKey(options),
  })

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] }
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    }
  }
  return params as unknown as typeof page
}

export const actionItemsInfiniteQueryKey = (
  options?: Options<ActionItemsData>
): QueryKey<Options<ActionItemsData>> => createQueryKey('actionItems', options, true)

/**
 * Lists action items for the user's organization
 */
export const actionItemsInfiniteOptions = (options?: Options<ActionItemsData>) =>
  infiniteQueryOptions<
    ActionItemsResponse,
    ActionItemsError,
    InfiniteData<ActionItemsResponse>,
    QueryKey<Options<ActionItemsData>>,
    number | Pick<QueryKey<Options<ActionItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ActionItemsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await actionItems({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: actionItemsInfiniteQueryKey(options),
    }
  )

/**
 * Lists action items for the user's organization
 */
export const useActionItemsQuery = (options?: Options<ActionItemsData>) =>
  useQuery(actionItemsOptions(options))

export const actionItemReferrerOptionsQueryKey = (
  options?: Options<ActionItemReferrerOptionsData>
) => createQueryKey('actionItemReferrerOptions', options)

/**
 * Returns referrer filter options for the action items team view
 */
export const actionItemReferrerOptionsOptions = (
  options?: Options<ActionItemReferrerOptionsData>
) =>
  queryOptions<
    ActionItemReferrerOptionsResponse,
    ActionItemReferrerOptionsError,
    ActionItemReferrerOptionsResponse,
    ReturnType<typeof actionItemReferrerOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await actionItemReferrerOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: actionItemReferrerOptionsQueryKey(options),
  })

/**
 * Returns referrer filter options for the action items team view
 */
export const useActionItemReferrerOptionsQuery = (
  options?: Options<ActionItemReferrerOptionsData>
) => useQuery(actionItemReferrerOptionsOptions(options))

export const actionItemByIdQueryKey = (options: Options<ActionItemByIdData>) =>
  createQueryKey('actionItemById', options)

/**
 * Gets an action item by ID
 */
export const actionItemByIdOptions = (options: Options<ActionItemByIdData>) =>
  queryOptions<
    ActionItemByIdResponse,
    ActionItemByIdError,
    ActionItemByIdResponse,
    ReturnType<typeof actionItemByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await actionItemById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: actionItemByIdQueryKey(options),
  })

/**
 * Gets an action item by ID
 */
export const useActionItemByIdQuery = (options: Options<ActionItemByIdData>) =>
  useQuery(actionItemByIdOptions(options))

export type MutationKey<TOptions extends Partial<Options>> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    tags?: ReadonlyArray<string>
  },
]

const createMutationKey = <TOptions extends Partial<Options>>(
  id: string,
  options?: TOptions,
  tags?: ReadonlyArray<string>
): [MutationKey<TOptions>[0]] => {
  const params: MutationKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const resolveActionItemMutationKey = (options?: Partial<Options<ResolveActionItemData>>) =>
  createMutationKey('resolveActionItem', options)

/**
 * Mark action item as resolved
 */
export const resolveActionItemMutation = (
  options?: Partial<Options<ResolveActionItemData>>
): UseMutationOptions<
  ResolveActionItemResponse,
  ResolveActionItemError,
  Options<ResolveActionItemData>
> => {
  const mutationOptions: UseMutationOptions<
    ResolveActionItemResponse,
    ResolveActionItemError,
    Options<ResolveActionItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resolveActionItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: resolveActionItemMutationKey(options),
  }
  return mutationOptions
}

/**
 * Mark action item as resolved
 */
export const useResolveActionItemMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ResolveActionItemResponse,
        ResolveActionItemError,
        Options<ResolveActionItemData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...resolveActionItemMutation(), ...mutationOptions })

export const commentOnActionItemMutationKey = (
  options?: Partial<Options<CommentOnActionItemData>>
) => createMutationKey('commentOnActionItem', options)

/**
 * Add a comment to an action item
 */
export const commentOnActionItemMutation = (
  options?: Partial<Options<CommentOnActionItemData>>
): UseMutationOptions<
  CommentOnActionItemResponse,
  CommentOnActionItemError,
  Options<CommentOnActionItemData>
> => {
  const mutationOptions: UseMutationOptions<
    CommentOnActionItemResponse,
    CommentOnActionItemError,
    Options<CommentOnActionItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commentOnActionItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: commentOnActionItemMutationKey(options),
  }
  return mutationOptions
}

/**
 * Add a comment to an action item
 */
export const useCommentOnActionItemMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CommentOnActionItemResponse,
        CommentOnActionItemError,
        Options<CommentOnActionItemData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...commentOnActionItemMutation(), ...mutationOptions })

export const currentUserAhoyEventExistsQueryKey = (
  options: Options<CurrentUserAhoyEventExistsData>
) => createQueryKey('currentUserAhoyEventExists', options)

/**
 * Checks whether the current user has an Ahoy event
 */
export const currentUserAhoyEventExistsOptions = (
  options: Options<CurrentUserAhoyEventExistsData>
) =>
  queryOptions<
    CurrentUserAhoyEventExistsResponse,
    CurrentUserAhoyEventExistsError,
    CurrentUserAhoyEventExistsResponse,
    ReturnType<typeof currentUserAhoyEventExistsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currentUserAhoyEventExists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: currentUserAhoyEventExistsQueryKey(options),
  })

/**
 * Checks whether the current user has an Ahoy event
 */
export const useCurrentUserAhoyEventExistsQuery = (
  options: Options<CurrentUserAhoyEventExistsData>
) => useQuery(currentUserAhoyEventExistsOptions(options))

export const trackCurrentUserAhoyEventMutationKey = (
  options?: Partial<Options<TrackCurrentUserAhoyEventData>>
) => createMutationKey('trackCurrentUserAhoyEvent', options)

/**
 * Tracks an Ahoy event for the current user
 */
export const trackCurrentUserAhoyEventMutation = (
  options?: Partial<Options<TrackCurrentUserAhoyEventData>>
): UseMutationOptions<
  TrackCurrentUserAhoyEventResponse,
  TrackCurrentUserAhoyEventError,
  Options<TrackCurrentUserAhoyEventData>
> => {
  const mutationOptions: UseMutationOptions<
    TrackCurrentUserAhoyEventResponse,
    TrackCurrentUserAhoyEventError,
    Options<TrackCurrentUserAhoyEventData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await trackCurrentUserAhoyEvent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: trackCurrentUserAhoyEventMutationKey(options),
  }
  return mutationOptions
}

/**
 * Tracks an Ahoy event for the current user
 */
export const useTrackCurrentUserAhoyEventMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        TrackCurrentUserAhoyEventResponse,
        TrackCurrentUserAhoyEventError,
        Options<TrackCurrentUserAhoyEventData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...trackCurrentUserAhoyEventMutation(), ...mutationOptions })

export const appointmentAssessmentAdministrationsQueryKey = (
  options: Options<AppointmentAssessmentAdministrationsData>
) => createQueryKey('appointmentAssessmentAdministrations', options)

/**
 * List assessments due and administerable for the appointment's client
 */
export const appointmentAssessmentAdministrationsOptions = (
  options: Options<AppointmentAssessmentAdministrationsData>
) =>
  queryOptions<
    AppointmentAssessmentAdministrationsResponse,
    AppointmentAssessmentAdministrationsError,
    AppointmentAssessmentAdministrationsResponse,
    ReturnType<typeof appointmentAssessmentAdministrationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appointmentAssessmentAdministrations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: appointmentAssessmentAdministrationsQueryKey(options),
  })

/**
 * List assessments due and administerable for the appointment's client
 */
export const useAppointmentAssessmentAdministrationsQuery = (
  options: Options<AppointmentAssessmentAdministrationsData>
) => useQuery(appointmentAssessmentAdministrationsOptions(options))

export const appointmentChartNoteQueryKey = (options: Options<AppointmentChartNoteData>) =>
  createQueryKey('appointmentChartNote', options)

/**
 * Fetch the chart-note resource (template + existing FAG, if any) for an appointment
 */
export const appointmentChartNoteOptions = (options: Options<AppointmentChartNoteData>) =>
  queryOptions<
    AppointmentChartNoteResponse,
    AppointmentChartNoteError,
    AppointmentChartNoteResponse,
    ReturnType<typeof appointmentChartNoteQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await appointmentChartNote({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: appointmentChartNoteQueryKey(options),
  })

/**
 * Fetch the chart-note resource (template + existing FAG, if any) for an appointment
 */
export const useAppointmentChartNoteQuery = (options: Options<AppointmentChartNoteData>) =>
  useQuery(appointmentChartNoteOptions(options))

export const createAppointmentChartNoteMutationKey = (
  options?: Partial<Options<CreateAppointmentChartNoteData>>
) => createMutationKey('createAppointmentChartNote', options)

/**
 * Create (or reuse) a Healthie chart note for an appointment
 */
export const createAppointmentChartNoteMutation = (
  options?: Partial<Options<CreateAppointmentChartNoteData>>
): UseMutationOptions<
  CreateAppointmentChartNoteResponse,
  CreateAppointmentChartNoteError,
  Options<CreateAppointmentChartNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAppointmentChartNoteResponse,
    CreateAppointmentChartNoteError,
    Options<CreateAppointmentChartNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAppointmentChartNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createAppointmentChartNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * Create (or reuse) a Healthie chart note for an appointment
 */
export const useCreateAppointmentChartNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateAppointmentChartNoteResponse,
        CreateAppointmentChartNoteError,
        Options<CreateAppointmentChartNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createAppointmentChartNoteMutation(), ...mutationOptions })

export const meetingQueryKey = (options: Options<MeetingData>) => createQueryKey('meeting', options)

/**
 * Returns meeting data (session URLs, client Upheal id, eligibility)
 */
export const meetingOptions = (options: Options<MeetingData>) =>
  queryOptions<MeetingResponse, MeetingError, MeetingResponse, ReturnType<typeof meetingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meeting({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: meetingQueryKey(options),
  })

/**
 * Returns meeting data (session URLs, client Upheal id, eligibility)
 */
export const useMeetingQuery = (options: Options<MeetingData>) => useQuery(meetingOptions(options))

export const recordClinicianJoinMutationKey = (
  options?: Partial<Options<RecordClinicianJoinData>>
) => createMutationKey('recordClinicianJoin', options)

/**
 * Records that the host clinician joined the native (pop-out) meeting
 */
export const recordClinicianJoinMutation = (
  options?: Partial<Options<RecordClinicianJoinData>>
): UseMutationOptions<
  RecordClinicianJoinResponse,
  RecordClinicianJoinError,
  Options<RecordClinicianJoinData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordClinicianJoinResponse,
    RecordClinicianJoinError,
    Options<RecordClinicianJoinData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordClinicianJoin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordClinicianJoinMutationKey(options),
  }
  return mutationOptions
}

/**
 * Records that the host clinician joined the native (pop-out) meeting
 */
export const useRecordClinicianJoinMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordClinicianJoinResponse,
        RecordClinicianJoinError,
        Options<RecordClinicianJoinData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordClinicianJoinMutation(), ...mutationOptions })

export const assessmentAssignmentQueryKey = (options: Options<AssessmentAssignmentData>) =>
  createQueryKey('assessmentAssignment', options)

/**
 * Fetch a version-pinned assessment assignment
 */
export const assessmentAssignmentOptions = (options: Options<AssessmentAssignmentData>) =>
  queryOptions<
    AssessmentAssignmentResponse,
    AssessmentAssignmentError,
    AssessmentAssignmentResponse,
    ReturnType<typeof assessmentAssignmentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await assessmentAssignment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: assessmentAssignmentQueryKey(options),
  })

/**
 * Fetch a version-pinned assessment assignment
 */
export const useAssessmentAssignmentQuery = (options: Options<AssessmentAssignmentData>) =>
  useQuery(assessmentAssignmentOptions(options))

export const assessmentAudienceOptionsQueryKey = (
  options?: Options<AssessmentAudienceOptionsData>
) => createQueryKey('assessmentAudienceOptions', options)

/**
 * list assessment audience options
 */
export const assessmentAudienceOptionsOptions = (
  options?: Options<AssessmentAudienceOptionsData>
) =>
  queryOptions<
    AssessmentAudienceOptionsResponse,
    AssessmentAudienceOptionsError,
    AssessmentAudienceOptionsResponse,
    ReturnType<typeof assessmentAudienceOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await assessmentAudienceOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: assessmentAudienceOptionsQueryKey(options),
  })

/**
 * list assessment audience options
 */
export const useAssessmentAudienceOptionsQuery = (
  options?: Options<AssessmentAudienceOptionsData>
) => useQuery(assessmentAudienceOptionsOptions(options))

export const assessmentDefinitionsQueryKey = (options?: Options<AssessmentDefinitionsData>) =>
  createQueryKey('assessmentDefinitions', options)

/**
 * list assessment definitions
 */
export const assessmentDefinitionsOptions = (options?: Options<AssessmentDefinitionsData>) =>
  queryOptions<
    AssessmentDefinitionsResponse,
    AssessmentDefinitionsError,
    AssessmentDefinitionsResponse,
    ReturnType<typeof assessmentDefinitionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await assessmentDefinitions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: assessmentDefinitionsQueryKey(options),
  })

/**
 * list assessment definitions
 */
export const useAssessmentDefinitionsQuery = (options?: Options<AssessmentDefinitionsData>) =>
  useQuery(assessmentDefinitionsOptions(options))

export const createAssessmentDefinitionMutationKey = (
  options?: Partial<Options<CreateAssessmentDefinitionData>>
) => createMutationKey('createAssessmentDefinition', options)

/**
 * create an assessment definition
 */
export const createAssessmentDefinitionMutation = (
  options?: Partial<Options<CreateAssessmentDefinitionData>>
): UseMutationOptions<
  CreateAssessmentDefinitionResponse,
  CreateAssessmentDefinitionError,
  Options<CreateAssessmentDefinitionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAssessmentDefinitionResponse,
    CreateAssessmentDefinitionError,
    Options<CreateAssessmentDefinitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAssessmentDefinition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createAssessmentDefinitionMutationKey(options),
  }
  return mutationOptions
}

/**
 * create an assessment definition
 */
export const useCreateAssessmentDefinitionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateAssessmentDefinitionResponse,
        CreateAssessmentDefinitionError,
        Options<CreateAssessmentDefinitionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createAssessmentDefinitionMutation(), ...mutationOptions })

export const assessmentDefinitionByIdQueryKey = (options: Options<AssessmentDefinitionByIdData>) =>
  createQueryKey('assessmentDefinitionById', options)

/**
 * get an assessment definition by ID
 */
export const assessmentDefinitionByIdOptions = (options: Options<AssessmentDefinitionByIdData>) =>
  queryOptions<
    AssessmentDefinitionByIdResponse,
    AssessmentDefinitionByIdError,
    AssessmentDefinitionByIdResponse,
    ReturnType<typeof assessmentDefinitionByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await assessmentDefinitionById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: assessmentDefinitionByIdQueryKey(options),
  })

/**
 * get an assessment definition by ID
 */
export const useAssessmentDefinitionByIdQuery = (options: Options<AssessmentDefinitionByIdData>) =>
  useQuery(assessmentDefinitionByIdOptions(options))

export const updateAssessmentDefinitionMutationKey = (
  options?: Partial<Options<UpdateAssessmentDefinitionData>>
) => createMutationKey('updateAssessmentDefinition', options)

/**
 * update an assessment definition
 */
export const updateAssessmentDefinitionMutation = (
  options?: Partial<Options<UpdateAssessmentDefinitionData>>
): UseMutationOptions<
  UpdateAssessmentDefinitionResponse,
  UpdateAssessmentDefinitionError,
  Options<UpdateAssessmentDefinitionData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssessmentDefinitionResponse,
    UpdateAssessmentDefinitionError,
    Options<UpdateAssessmentDefinitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAssessmentDefinition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateAssessmentDefinitionMutationKey(options),
  }
  return mutationOptions
}

/**
 * update an assessment definition
 */
export const useUpdateAssessmentDefinitionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateAssessmentDefinitionResponse,
        UpdateAssessmentDefinitionError,
        Options<UpdateAssessmentDefinitionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateAssessmentDefinitionMutation(), ...mutationOptions })

export const createAssessmentManualSendMutationKey = (
  options?: Partial<Options<CreateAssessmentManualSendData>>
) => createMutationKey('createAssessmentManualSend', options)

/**
 * send an assessment on request
 */
export const createAssessmentManualSendMutation = (
  options?: Partial<Options<CreateAssessmentManualSendData>>
): UseMutationOptions<
  CreateAssessmentManualSendResponse,
  CreateAssessmentManualSendError,
  Options<CreateAssessmentManualSendData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAssessmentManualSendResponse,
    CreateAssessmentManualSendError,
    Options<CreateAssessmentManualSendData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAssessmentManualSend({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createAssessmentManualSendMutationKey(options),
  }
  return mutationOptions
}

/**
 * send an assessment on request
 */
export const useCreateAssessmentManualSendMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateAssessmentManualSendResponse,
        CreateAssessmentManualSendError,
        Options<CreateAssessmentManualSendData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createAssessmentManualSendMutation(), ...mutationOptions })

export const submitAssessmentResponseMutationKey = (
  options?: Partial<Options<SubmitAssessmentResponseData>>
) => createMutationKey('submitAssessmentResponse', options)

/**
 * Submit an assessment response
 */
export const submitAssessmentResponseMutation = (
  options?: Partial<Options<SubmitAssessmentResponseData>>
): UseMutationOptions<
  SubmitAssessmentResponseResponse,
  SubmitAssessmentResponseError,
  Options<SubmitAssessmentResponseData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitAssessmentResponseResponse,
    SubmitAssessmentResponseError,
    Options<SubmitAssessmentResponseData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitAssessmentResponse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitAssessmentResponseMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit an assessment response
 */
export const useSubmitAssessmentResponseMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitAssessmentResponseResponse,
        SubmitAssessmentResponseError,
        Options<SubmitAssessmentResponseData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitAssessmentResponseMutation(), ...mutationOptions })

export const publishAssessmentVersionMutationKey = (
  options?: Partial<Options<PublishAssessmentVersionData>>
) => createMutationKey('publishAssessmentVersion', options)

/**
 * publish a new assessment version
 */
export const publishAssessmentVersionMutation = (
  options?: Partial<Options<PublishAssessmentVersionData>>
): UseMutationOptions<
  PublishAssessmentVersionResponse,
  PublishAssessmentVersionError,
  Options<PublishAssessmentVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    PublishAssessmentVersionResponse,
    PublishAssessmentVersionError,
    Options<PublishAssessmentVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishAssessmentVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: publishAssessmentVersionMutationKey(options),
  }
  return mutationOptions
}

/**
 * publish a new assessment version
 */
export const usePublishAssessmentVersionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        PublishAssessmentVersionResponse,
        PublishAssessmentVersionError,
        Options<PublishAssessmentVersionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...publishAssessmentVersionMutation(), ...mutationOptions })

export const createAutomatedOutreachMutationKey = (
  options?: Partial<Options<CreateAutomatedOutreachData>>
) => createMutationKey('createAutomatedOutreach', options)

/**
 * Starts automated outreach for a referral
 */
export const createAutomatedOutreachMutation = (
  options?: Partial<Options<CreateAutomatedOutreachData>>
): UseMutationOptions<
  CreateAutomatedOutreachResponse,
  CreateAutomatedOutreachError,
  Options<CreateAutomatedOutreachData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAutomatedOutreachResponse,
    CreateAutomatedOutreachError,
    Options<CreateAutomatedOutreachData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAutomatedOutreach({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createAutomatedOutreachMutationKey(options),
  }
  return mutationOptions
}

/**
 * Starts automated outreach for a referral
 */
export const useCreateAutomatedOutreachMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateAutomatedOutreachResponse,
        CreateAutomatedOutreachError,
        Options<CreateAutomatedOutreachData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createAutomatedOutreachMutation(), ...mutationOptions })

export const getBackToSchoolReviewsQueryKey = (options?: Options<GetBackToSchoolReviewsData>) =>
  createQueryKey('getBackToSchoolReviews', options)

/**
 * Lists back-to-school review rows
 */
export const getBackToSchoolReviewsOptions = (options?: Options<GetBackToSchoolReviewsData>) =>
  queryOptions<
    GetBackToSchoolReviewsResponse,
    GetBackToSchoolReviewsError,
    GetBackToSchoolReviewsResponse,
    ReturnType<typeof getBackToSchoolReviewsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBackToSchoolReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBackToSchoolReviewsQueryKey(options),
  })

/**
 * Lists back-to-school review rows
 */
export const useGetBackToSchoolReviewsQuery = (options?: Options<GetBackToSchoolReviewsData>) =>
  useQuery(getBackToSchoolReviewsOptions(options))

export const getBackToSchoolReviewsSchoolsQueryKey = (
  options?: Options<GetBackToSchoolReviewsSchoolsData>
) => createQueryKey('getBackToSchoolReviewsSchools', options)

/**
 * Lists schools for back-to-school review
 */
export const getBackToSchoolReviewsSchoolsOptions = (
  options?: Options<GetBackToSchoolReviewsSchoolsData>
) =>
  queryOptions<
    GetBackToSchoolReviewsSchoolsResponse,
    DefaultError,
    GetBackToSchoolReviewsSchoolsResponse,
    ReturnType<typeof getBackToSchoolReviewsSchoolsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBackToSchoolReviewsSchools({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBackToSchoolReviewsSchoolsQueryKey(options),
  })

/**
 * Lists schools for back-to-school review
 */
export const useGetBackToSchoolReviewsSchoolsQuery = (
  options?: Options<GetBackToSchoolReviewsSchoolsData>
) => useQuery(getBackToSchoolReviewsSchoolsOptions(options))

export const getBackToSchoolReviewsSchoolsBySchoolIdGradesQueryKey = (
  options: Options<GetBackToSchoolReviewsSchoolsBySchoolIdGradesData>
) => createQueryKey('getBackToSchoolReviewsSchoolsBySchoolIdGrades', options)

/**
 * Lists grades offered at a school
 */
export const getBackToSchoolReviewsSchoolsBySchoolIdGradesOptions = (
  options: Options<GetBackToSchoolReviewsSchoolsBySchoolIdGradesData>
) =>
  queryOptions<
    GetBackToSchoolReviewsSchoolsBySchoolIdGradesResponse,
    DefaultError,
    GetBackToSchoolReviewsSchoolsBySchoolIdGradesResponse,
    ReturnType<typeof getBackToSchoolReviewsSchoolsBySchoolIdGradesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBackToSchoolReviewsSchoolsBySchoolIdGrades({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBackToSchoolReviewsSchoolsBySchoolIdGradesQueryKey(options),
  })

/**
 * Lists grades offered at a school
 */
export const useGetBackToSchoolReviewsSchoolsBySchoolIdGradesQuery = (
  options: Options<GetBackToSchoolReviewsSchoolsBySchoolIdGradesData>
) => useQuery(getBackToSchoolReviewsSchoolsBySchoolIdGradesOptions(options))

export const getBackToSchoolReviewsReferrersQueryKey = (
  options?: Options<GetBackToSchoolReviewsReferrersData>
) => createQueryKey('getBackToSchoolReviewsReferrers', options)

/**
 * Lists referrers for back-to-school review
 */
export const getBackToSchoolReviewsReferrersOptions = (
  options?: Options<GetBackToSchoolReviewsReferrersData>
) =>
  queryOptions<
    GetBackToSchoolReviewsReferrersResponse,
    DefaultError,
    GetBackToSchoolReviewsReferrersResponse,
    ReturnType<typeof getBackToSchoolReviewsReferrersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBackToSchoolReviewsReferrers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBackToSchoolReviewsReferrersQueryKey(options),
  })

/**
 * Lists referrers for back-to-school review
 */
export const useGetBackToSchoolReviewsReferrersQuery = (
  options?: Options<GetBackToSchoolReviewsReferrersData>
) => useQuery(getBackToSchoolReviewsReferrersOptions(options))

export const backToSchoolReviewBannerQueryKey = (options?: Options<BackToSchoolReviewBannerData>) =>
  createQueryKey('backToSchoolReviewBanner', options)

/**
 * Returns back-to-school review banner status
 */
export const backToSchoolReviewBannerOptions = (options?: Options<BackToSchoolReviewBannerData>) =>
  queryOptions<
    BackToSchoolReviewBannerResponse,
    DefaultError,
    BackToSchoolReviewBannerResponse,
    ReturnType<typeof backToSchoolReviewBannerQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await backToSchoolReviewBanner({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: backToSchoolReviewBannerQueryKey(options),
  })

/**
 * Returns back-to-school review banner status
 */
export const useBackToSchoolReviewBannerQuery = (options?: Options<BackToSchoolReviewBannerData>) =>
  useQuery(backToSchoolReviewBannerOptions(options))

export const dismissBackToSchoolReviewBannerMutationKey = (
  options?: Partial<Options<DismissBackToSchoolReviewBannerData>>
) => createMutationKey('dismissBackToSchoolReviewBanner', options)

/**
 * Dismisses the back-to-school review banner
 */
export const dismissBackToSchoolReviewBannerMutation = (
  options?: Partial<Options<DismissBackToSchoolReviewBannerData>>
): UseMutationOptions<
  DismissBackToSchoolReviewBannerResponse,
  DefaultError,
  Options<DismissBackToSchoolReviewBannerData>
> => {
  const mutationOptions: UseMutationOptions<
    DismissBackToSchoolReviewBannerResponse,
    DefaultError,
    Options<DismissBackToSchoolReviewBannerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dismissBackToSchoolReviewBanner({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: dismissBackToSchoolReviewBannerMutationKey(options),
  }
  return mutationOptions
}

/**
 * Dismisses the back-to-school review banner
 */
export const useDismissBackToSchoolReviewBannerMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DismissBackToSchoolReviewBannerResponse,
        DefaultError,
        Options<DismissBackToSchoolReviewBannerData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...dismissBackToSchoolReviewBannerMutation(), ...mutationOptions })

export const postBackToSchoolReviewsBatchUpdatesMutationKey = (
  options?: Partial<Options<PostBackToSchoolReviewsBatchUpdatesData>>
) => createMutationKey('postBackToSchoolReviewsBatchUpdates', options)

/**
 * Batch updates back-to-school review rows
 */
export const postBackToSchoolReviewsBatchUpdatesMutation = (
  options?: Partial<Options<PostBackToSchoolReviewsBatchUpdatesData>>
): UseMutationOptions<
  PostBackToSchoolReviewsBatchUpdatesResponse,
  DefaultError,
  Options<PostBackToSchoolReviewsBatchUpdatesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostBackToSchoolReviewsBatchUpdatesResponse,
    DefaultError,
    Options<PostBackToSchoolReviewsBatchUpdatesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postBackToSchoolReviewsBatchUpdates({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: postBackToSchoolReviewsBatchUpdatesMutationKey(options),
  }
  return mutationOptions
}

/**
 * Batch updates back-to-school review rows
 */
export const usePostBackToSchoolReviewsBatchUpdatesMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        PostBackToSchoolReviewsBatchUpdatesResponse,
        DefaultError,
        Options<PostBackToSchoolReviewsBatchUpdatesData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...postBackToSchoolReviewsBatchUpdatesMutation(), ...mutationOptions })

export const calendarAppointmentVideoLinkQueryKey = (
  options: Options<CalendarAppointmentVideoLinkData>
) => createQueryKey('calendarAppointmentVideoLink', options)

/**
 * Fetches the video call link for an appointment
 */
export const calendarAppointmentVideoLinkOptions = (
  options: Options<CalendarAppointmentVideoLinkData>
) =>
  queryOptions<
    CalendarAppointmentVideoLinkResponse,
    CalendarAppointmentVideoLinkError,
    CalendarAppointmentVideoLinkResponse,
    ReturnType<typeof calendarAppointmentVideoLinkQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await calendarAppointmentVideoLink({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: calendarAppointmentVideoLinkQueryKey(options),
  })

/**
 * Fetches the video call link for an appointment
 */
export const useCalendarAppointmentVideoLinkQuery = (
  options: Options<CalendarAppointmentVideoLinkData>
) => useQuery(calendarAppointmentVideoLinkOptions(options))

export const calendarAppointmentsQueryKey = (options?: Options<CalendarAppointmentsData>) =>
  createQueryKey('calendarAppointments', options)

/**
 * Lists appointments for the month
 */
export const calendarAppointmentsOptions = (options?: Options<CalendarAppointmentsData>) =>
  queryOptions<
    CalendarAppointmentsResponse,
    CalendarAppointmentsError,
    CalendarAppointmentsResponse,
    ReturnType<typeof calendarAppointmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await calendarAppointments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: calendarAppointmentsQueryKey(options),
  })

/**
 * Lists appointments for the month
 */
export const useCalendarAppointmentsQuery = (options?: Options<CalendarAppointmentsData>) =>
  useQuery(calendarAppointmentsOptions(options))

export const callsQueryKey = (options?: Options<CallsData>) => createQueryKey('calls', options)

/**
 * list calls
 */
export const callsOptions = (options?: Options<CallsData>) =>
  queryOptions<CallsResponse, CallsError, CallsResponse, ReturnType<typeof callsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await calls({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: callsQueryKey(options),
  })

export const callsInfiniteQueryKey = (options?: Options<CallsData>): QueryKey<Options<CallsData>> =>
  createQueryKey('calls', options, true)

/**
 * list calls
 */
export const callsInfiniteOptions = (options?: Options<CallsData>) =>
  infiniteQueryOptions<
    CallsResponse,
    CallsError,
    InfiniteData<CallsResponse>,
    QueryKey<Options<CallsData>>,
    number | Pick<QueryKey<Options<CallsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<QueryKey<Options<CallsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await calls({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: callsInfiniteQueryKey(options),
    }
  )

/**
 * list calls
 */
export const useCallsQuery = (options?: Options<CallsData>) => useQuery(callsOptions(options))

export const browserCallTokenMutationKey = (options?: Partial<Options<BrowserCallTokenData>>) =>
  createMutationKey('browserCallToken', options)

/**
 * create browser call token
 */
export const browserCallTokenMutation = (
  options?: Partial<Options<BrowserCallTokenData>>
): UseMutationOptions<
  BrowserCallTokenResponse2,
  BrowserCallTokenError,
  Options<BrowserCallTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    BrowserCallTokenResponse2,
    BrowserCallTokenError,
    Options<BrowserCallTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await browserCallToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: browserCallTokenMutationKey(options),
  }
  return mutationOptions
}

/**
 * create browser call token
 */
export const useBrowserCallTokenMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        BrowserCallTokenResponse2,
        BrowserCallTokenError,
        Options<BrowserCallTokenData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...browserCallTokenMutation(), ...mutationOptions })

export const callByIdQueryKey = (options: Options<CallByIdData>) =>
  createQueryKey('callById', options)

/**
 * show call
 */
export const callByIdOptions = (options: Options<CallByIdData>) =>
  queryOptions<
    CallByIdResponse,
    DefaultError,
    CallByIdResponse,
    ReturnType<typeof callByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: callByIdQueryKey(options),
  })

/**
 * show call
 */
export const useCallByIdQuery = (options: Options<CallByIdData>) =>
  useQuery(callByIdOptions(options))

export const careOpsQaSpotChecksQueryKey = (options?: Options<CareOpsQaSpotChecksData>) =>
  createQueryKey('careOpsQaSpotChecks', options)

/**
 * list team-wide flagged referrals for admin review
 */
export const careOpsQaSpotChecksOptions = (options?: Options<CareOpsQaSpotChecksData>) =>
  queryOptions<
    CareOpsQaSpotChecksResponse2,
    CareOpsQaSpotChecksError,
    CareOpsQaSpotChecksResponse2,
    ReturnType<typeof careOpsQaSpotChecksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await careOpsQaSpotChecks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: careOpsQaSpotChecksQueryKey(options),
  })

export const careOpsQaSpotChecksInfiniteQueryKey = (
  options?: Options<CareOpsQaSpotChecksData>
): QueryKey<Options<CareOpsQaSpotChecksData>> =>
  createQueryKey('careOpsQaSpotChecks', options, true)

/**
 * list team-wide flagged referrals for admin review
 */
export const careOpsQaSpotChecksInfiniteOptions = (options?: Options<CareOpsQaSpotChecksData>) =>
  infiniteQueryOptions<
    CareOpsQaSpotChecksResponse2,
    CareOpsQaSpotChecksError,
    InfiniteData<CareOpsQaSpotChecksResponse2>,
    QueryKey<Options<CareOpsQaSpotChecksData>>,
    | number
    | Pick<QueryKey<Options<CareOpsQaSpotChecksData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<CareOpsQaSpotChecksData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await careOpsQaSpotChecks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: careOpsQaSpotChecksInfiniteQueryKey(options),
    }
  )

/**
 * list team-wide flagged referrals for admin review
 */
export const useCareOpsQaSpotChecksQuery = (options?: Options<CareOpsQaSpotChecksData>) =>
  useQuery(careOpsQaSpotChecksOptions(options))

export const careProgramsQueryKey = (options: Options<CareProgramsData>) =>
  createQueryKey('carePrograms', options)

/**
 * list the care programs an organization can refer into
 *
 * Returns the active, enabled programs from the care program registry, ordered by name. Returns an empty list when :care_programs_platform_SEP_2026 is off for the organization, so callers can treat "out of cohort" and "nothing provisioned" identically.
 */
export const careProgramsOptions = (options: Options<CareProgramsData>) =>
  queryOptions<
    CareProgramsResponse,
    DefaultError,
    CareProgramsResponse,
    ReturnType<typeof careProgramsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await carePrograms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: careProgramsQueryKey(options),
  })

/**
 * list the care programs an organization can refer into
 *
 * Returns the active, enabled programs from the care program registry, ordered by name. Returns an empty list when :care_programs_platform_SEP_2026 is off for the organization, so callers can treat "out of cohort" and "nothing provisioned" identically.
 */
export const useCareProgramsQuery = (options: Options<CareProgramsData>) =>
  useQuery(careProgramsOptions(options))

export const chartNoteClinicalQualityScoresQueryKey = (
  options: Options<ChartNoteClinicalQualityScoresData>
) => createQueryKey('chartNoteClinicalQualityScores', options)

/**
 * list clinical quality scores for a chart note
 */
export const chartNoteClinicalQualityScoresOptions = (
  options: Options<ChartNoteClinicalQualityScoresData>
) =>
  queryOptions<
    ChartNoteClinicalQualityScoresResponse,
    DefaultError,
    ChartNoteClinicalQualityScoresResponse,
    ReturnType<typeof chartNoteClinicalQualityScoresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await chartNoteClinicalQualityScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: chartNoteClinicalQualityScoresQueryKey(options),
  })

/**
 * list clinical quality scores for a chart note
 */
export const useChartNoteClinicalQualityScoresQuery = (
  options: Options<ChartNoteClinicalQualityScoresData>
) => useQuery(chartNoteClinicalQualityScoresOptions(options))

export const scoreChartNoteClinicalQualityMutationKey = (
  options?: Partial<Options<ScoreChartNoteClinicalQualityData>>
) => createMutationKey('scoreChartNoteClinicalQuality', options)

/**
 * enqueue clinical quality score job
 */
export const scoreChartNoteClinicalQualityMutation = (
  options?: Partial<Options<ScoreChartNoteClinicalQualityData>>
): UseMutationOptions<unknown, DefaultError, Options<ScoreChartNoteClinicalQualityData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<ScoreChartNoteClinicalQualityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await scoreChartNoteClinicalQuality({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: scoreChartNoteClinicalQualityMutationKey(options),
  }
  return mutationOptions
}

/**
 * enqueue clinical quality score job
 */
export const useScoreChartNoteClinicalQualityMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<unknown, DefaultError, Options<ScoreChartNoteClinicalQualityData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...scoreChartNoteClinicalQualityMutation(), ...mutationOptions })

export const pollChartNoteClinicalQualityScoreQueryKey = (
  options: Options<PollChartNoteClinicalQualityScoreData>
) => createQueryKey('pollChartNoteClinicalQualityScore', options)

/**
 * poll scoring job status
 */
export const pollChartNoteClinicalQualityScoreOptions = (
  options: Options<PollChartNoteClinicalQualityScoreData>
) =>
  queryOptions<
    PollChartNoteClinicalQualityScoreResponse,
    DefaultError,
    PollChartNoteClinicalQualityScoreResponse,
    ReturnType<typeof pollChartNoteClinicalQualityScoreQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pollChartNoteClinicalQualityScore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: pollChartNoteClinicalQualityScoreQueryKey(options),
  })

/**
 * poll scoring job status
 */
export const usePollChartNoteClinicalQualityScoreQuery = (
  options: Options<PollChartNoteClinicalQualityScoreData>
) => useQuery(pollChartNoteClinicalQualityScoreOptions(options))

export const clientAppointmentsQueryKey = (options: Options<ClientAppointmentsData>) =>
  createQueryKey('clientAppointments', options)

/**
 * list appointments for client
 */
export const clientAppointmentsOptions = (options: Options<ClientAppointmentsData>) =>
  queryOptions<
    ClientAppointmentsResponse,
    ClientAppointmentsError,
    ClientAppointmentsResponse,
    ReturnType<typeof clientAppointmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientAppointments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientAppointmentsQueryKey(options),
  })

/**
 * list appointments for client
 */
export const useClientAppointmentsQuery = (options: Options<ClientAppointmentsData>) =>
  useQuery(clientAppointmentsOptions(options))

export const clientAppointmentSummaryQueryKey = (options: Options<ClientAppointmentSummaryData>) =>
  createQueryKey('clientAppointmentSummary', options)

/**
 * fetch appointments summary for client
 */
export const clientAppointmentSummaryOptions = (options: Options<ClientAppointmentSummaryData>) =>
  queryOptions<
    ClientAppointmentSummaryResponse,
    ClientAppointmentSummaryError,
    ClientAppointmentSummaryResponse,
    ReturnType<typeof clientAppointmentSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientAppointmentSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientAppointmentSummaryQueryKey(options),
  })

/**
 * fetch appointments summary for client
 */
export const useClientAppointmentSummaryQuery = (options: Options<ClientAppointmentSummaryData>) =>
  useQuery(clientAppointmentSummaryOptions(options))

export const clientAssessmentResultsQueryKey = (options: Options<ClientAssessmentResultsData>) =>
  createQueryKey('clientAssessmentResults', options)

/**
 * list completed assessment results for client
 */
export const clientAssessmentResultsOptions = (options: Options<ClientAssessmentResultsData>) =>
  queryOptions<
    ClientAssessmentResultsResponse,
    ClientAssessmentResultsError,
    ClientAssessmentResultsResponse,
    ReturnType<typeof clientAssessmentResultsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientAssessmentResults({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientAssessmentResultsQueryKey(options),
  })

/**
 * list completed assessment results for client
 */
export const useClientAssessmentResultsQuery = (options: Options<ClientAssessmentResultsData>) =>
  useQuery(clientAssessmentResultsOptions(options))

export const clientAssessmentSendOptionsQueryKey = (
  options: Options<ClientAssessmentSendOptionsData>
) => createQueryKey('clientAssessmentSendOptions', options)

/**
 * list sendable assessments and auto-send opt-out state for a client
 */
export const clientAssessmentSendOptionsOptions = (
  options: Options<ClientAssessmentSendOptionsData>
) =>
  queryOptions<
    ClientAssessmentSendOptionsResponse,
    ClientAssessmentSendOptionsError,
    ClientAssessmentSendOptionsResponse,
    ReturnType<typeof clientAssessmentSendOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientAssessmentSendOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientAssessmentSendOptionsQueryKey(options),
  })

/**
 * list sendable assessments and auto-send opt-out state for a client
 */
export const useClientAssessmentSendOptionsQuery = (
  options: Options<ClientAssessmentSendOptionsData>
) => useQuery(clientAssessmentSendOptionsOptions(options))

export const toggleAssessmentAutoSendMutationKey = (
  options?: Partial<Options<ToggleAssessmentAutoSendData>>
) => createMutationKey('toggleAssessmentAutoSend', options)

/**
 * toggle assessment auto-send opt-out for a client
 */
export const toggleAssessmentAutoSendMutation = (
  options?: Partial<Options<ToggleAssessmentAutoSendData>>
): UseMutationOptions<
  ToggleAssessmentAutoSendResponse,
  ToggleAssessmentAutoSendError,
  Options<ToggleAssessmentAutoSendData>
> => {
  const mutationOptions: UseMutationOptions<
    ToggleAssessmentAutoSendResponse,
    ToggleAssessmentAutoSendError,
    Options<ToggleAssessmentAutoSendData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await toggleAssessmentAutoSend({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: toggleAssessmentAutoSendMutationKey(options),
  }
  return mutationOptions
}

/**
 * toggle assessment auto-send opt-out for a client
 */
export const useToggleAssessmentAutoSendMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ToggleAssessmentAutoSendResponse,
        ToggleAssessmentAutoSendError,
        Options<ToggleAssessmentAutoSendData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...toggleAssessmentAutoSendMutation(), ...mutationOptions })

export const clientBrooklineEvaluationConsentQueryKey = (
  options: Options<ClientBrooklineEvaluationConsentData>
) => createQueryKey('clientBrooklineEvaluationConsent', options)

/**
 * Get Brookline evaluation consent eligibility and current value
 */
export const clientBrooklineEvaluationConsentOptions = (
  options: Options<ClientBrooklineEvaluationConsentData>
) =>
  queryOptions<
    ClientBrooklineEvaluationConsentResponse,
    ClientBrooklineEvaluationConsentError,
    ClientBrooklineEvaluationConsentResponse,
    ReturnType<typeof clientBrooklineEvaluationConsentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientBrooklineEvaluationConsent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientBrooklineEvaluationConsentQueryKey(options),
  })

/**
 * Get Brookline evaluation consent eligibility and current value
 */
export const useClientBrooklineEvaluationConsentQuery = (
  options: Options<ClientBrooklineEvaluationConsentData>
) => useQuery(clientBrooklineEvaluationConsentOptions(options))

export const recordClientBrooklineEvaluationConsentMutationKey = (
  options?: Partial<Options<RecordClientBrooklineEvaluationConsentData>>
) => createMutationKey('recordClientBrooklineEvaluationConsent', options)

/**
 * Submit Brookline evaluation consent decision
 */
export const recordClientBrooklineEvaluationConsentMutation = (
  options?: Partial<Options<RecordClientBrooklineEvaluationConsentData>>
): UseMutationOptions<
  RecordClientBrooklineEvaluationConsentResponse,
  RecordClientBrooklineEvaluationConsentError,
  Options<RecordClientBrooklineEvaluationConsentData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordClientBrooklineEvaluationConsentResponse,
    RecordClientBrooklineEvaluationConsentError,
    Options<RecordClientBrooklineEvaluationConsentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordClientBrooklineEvaluationConsent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordClientBrooklineEvaluationConsentMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit Brookline evaluation consent decision
 */
export const useRecordClientBrooklineEvaluationConsentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordClientBrooklineEvaluationConsentResponse,
        RecordClientBrooklineEvaluationConsentError,
        Options<RecordClientBrooklineEvaluationConsentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordClientBrooklineEvaluationConsentMutation(), ...mutationOptions })

export const enrollClientInCareProgramMutationKey = (
  options?: Partial<Options<EnrollClientInCareProgramData>>
) => createMutationKey('enrollClientInCareProgram', options)

/**
 * enroll a student in a care program
 *
 * Manually opens a care program episode from the student details page. Enrollment is exclusive: a student live in another program, or holding an active School Avoidance marker, is refused.
 */
export const enrollClientInCareProgramMutation = (
  options?: Partial<Options<EnrollClientInCareProgramData>>
): UseMutationOptions<
  EnrollClientInCareProgramResponse,
  EnrollClientInCareProgramError,
  Options<EnrollClientInCareProgramData>
> => {
  const mutationOptions: UseMutationOptions<
    EnrollClientInCareProgramResponse,
    EnrollClientInCareProgramError,
    Options<EnrollClientInCareProgramData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await enrollClientInCareProgram({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: enrollClientInCareProgramMutationKey(options),
  }
  return mutationOptions
}

/**
 * enroll a student in a care program
 *
 * Manually opens a care program episode from the student details page. Enrollment is exclusive: a student live in another program, or holding an active School Avoidance marker, is refused.
 */
export const useEnrollClientInCareProgramMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        EnrollClientInCareProgramResponse,
        EnrollClientInCareProgramError,
        Options<EnrollClientInCareProgramData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...enrollClientInCareProgramMutation(), ...mutationOptions })

export const dischargeClientFromCareProgramMutationKey = (
  options?: Partial<Options<DischargeClientFromCareProgramData>>
) => createMutationKey('dischargeClientFromCareProgram', options)

/**
 * end a student's care program episode
 *
 * Closes the student's live episode. The optional free-text note stays in Postgres and is never emitted on an event or returned here.
 */
export const dischargeClientFromCareProgramMutation = (
  options?: Partial<Options<DischargeClientFromCareProgramData>>
): UseMutationOptions<
  DischargeClientFromCareProgramResponse,
  DischargeClientFromCareProgramError,
  Options<DischargeClientFromCareProgramData>
> => {
  const mutationOptions: UseMutationOptions<
    DischargeClientFromCareProgramResponse,
    DischargeClientFromCareProgramError,
    Options<DischargeClientFromCareProgramData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dischargeClientFromCareProgram({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: dischargeClientFromCareProgramMutationKey(options),
  }
  return mutationOptions
}

/**
 * end a student's care program episode
 *
 * Closes the student's live episode. The optional free-text note stays in Postgres and is never emitted on an event or returned here.
 */
export const useDischargeClientFromCareProgramMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DischargeClientFromCareProgramResponse,
        DischargeClientFromCareProgramError,
        Options<DischargeClientFromCareProgramData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...dischargeClientFromCareProgramMutation(), ...mutationOptions })

export const clientCareProgramMembershipQueryKey = (
  options: Options<ClientCareProgramMembershipData>
) => createQueryKey('clientCareProgramMembership', options)

/**
 * read a student's care program membership
 *
 * Membership is a single slot: a registry care program, the School Avoidance marker, or nothing. Districts outside the :care_programs_platform_SEP_2026 cohort get an empty membership with no options and a 200, so a surface that opens on every appointment renders no control rather than an error.
 */
export const clientCareProgramMembershipOptions = (
  options: Options<ClientCareProgramMembershipData>
) =>
  queryOptions<
    ClientCareProgramMembershipResponse,
    DefaultError,
    ClientCareProgramMembershipResponse,
    ReturnType<typeof clientCareProgramMembershipQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientCareProgramMembership({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientCareProgramMembershipQueryKey(options),
  })

/**
 * read a student's care program membership
 *
 * Membership is a single slot: a registry care program, the School Avoidance marker, or nothing. Districts outside the :care_programs_platform_SEP_2026 cohort get an empty membership with no options and a 200, so a surface that opens on every appointment renders no control rather than an error.
 */
export const useClientCareProgramMembershipQuery = (
  options: Options<ClientCareProgramMembershipData>
) => useQuery(clientCareProgramMembershipOptions(options))

export const updateClientCareProgramMembershipMutationKey = (
  options?: Partial<Options<UpdateClientCareProgramMembershipData>>
) => createMutationKey('updateClientCareProgramMembership', options)

/**
 * change a student's care program membership
 *
 * Sets the student's single membership slot. Switching between a registry program and School Avoidance is one atomic swap — the incumbent slot is vacated and the target taken inside one transaction, so either half failing leaves the student where they started. Re-selecting the slot the student already holds is a no-op.
 */
export const updateClientCareProgramMembershipMutation = (
  options?: Partial<Options<UpdateClientCareProgramMembershipData>>
): UseMutationOptions<
  UpdateClientCareProgramMembershipResponse,
  UpdateClientCareProgramMembershipError,
  Options<UpdateClientCareProgramMembershipData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateClientCareProgramMembershipResponse,
    UpdateClientCareProgramMembershipError,
    Options<UpdateClientCareProgramMembershipData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateClientCareProgramMembership({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateClientCareProgramMembershipMutationKey(options),
  }
  return mutationOptions
}

/**
 * change a student's care program membership
 *
 * Sets the student's single membership slot. Switching between a registry program and School Avoidance is one atomic swap — the incumbent slot is vacated and the target taken inside one transaction, so either half failing leaves the student where they started. Re-selecting the slot the student already holds is a no-op.
 */
export const useUpdateClientCareProgramMembershipMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateClientCareProgramMembershipResponse,
        UpdateClientCareProgramMembershipError,
        Options<UpdateClientCareProgramMembershipData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateClientCareProgramMembershipMutation(), ...mutationOptions })

export const clientCcbhoEncounterAttestationQueryKey = (
  options: Options<ClientCcbhoEncounterAttestationData>
) => createQueryKey('clientCcbhoEncounterAttestation', options)

/**
 * Get CCBHO encounter attestation appointment context and signature status
 */
export const clientCcbhoEncounterAttestationOptions = (
  options: Options<ClientCcbhoEncounterAttestationData>
) =>
  queryOptions<
    ClientCcbhoEncounterAttestationResponse,
    ClientCcbhoEncounterAttestationError,
    ClientCcbhoEncounterAttestationResponse,
    ReturnType<typeof clientCcbhoEncounterAttestationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientCcbhoEncounterAttestation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientCcbhoEncounterAttestationQueryKey(options),
  })

/**
 * Get CCBHO encounter attestation appointment context and signature status
 */
export const useClientCcbhoEncounterAttestationQuery = (
  options: Options<ClientCcbhoEncounterAttestationData>
) => useQuery(clientCcbhoEncounterAttestationOptions(options))

export const recordClientCcbhoEncounterAttestationMutationKey = (
  options?: Partial<Options<RecordClientCcbhoEncounterAttestationData>>
) => createMutationKey('recordClientCcbhoEncounterAttestation', options)

/**
 * Submit a CCBHO encounter attestation signature
 */
export const recordClientCcbhoEncounterAttestationMutation = (
  options?: Partial<Options<RecordClientCcbhoEncounterAttestationData>>
): UseMutationOptions<
  RecordClientCcbhoEncounterAttestationResponse,
  RecordClientCcbhoEncounterAttestationError,
  Options<RecordClientCcbhoEncounterAttestationData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordClientCcbhoEncounterAttestationResponse,
    RecordClientCcbhoEncounterAttestationError,
    Options<RecordClientCcbhoEncounterAttestationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordClientCcbhoEncounterAttestation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordClientCcbhoEncounterAttestationMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit a CCBHO encounter attestation signature
 */
export const useRecordClientCcbhoEncounterAttestationMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordClientCcbhoEncounterAttestationResponse,
        RecordClientCcbhoEncounterAttestationError,
        Options<RecordClientCcbhoEncounterAttestationData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordClientCcbhoEncounterAttestationMutation(), ...mutationOptions })

export const clientChartNotesQueryKey = (options: Options<ClientChartNotesData>) =>
  createQueryKey('clientChartNotes', options)

/**
 * list chart notes for client
 */
export const clientChartNotesOptions = (options: Options<ClientChartNotesData>) =>
  queryOptions<
    ClientChartNotesResponse,
    ClientChartNotesError,
    ClientChartNotesResponse,
    ReturnType<typeof clientChartNotesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientChartNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientChartNotesQueryKey(options),
  })

export const clientChartNotesInfiniteQueryKey = (
  options: Options<ClientChartNotesData>
): QueryKey<Options<ClientChartNotesData>> => createQueryKey('clientChartNotes', options, true)

/**
 * list chart notes for client
 */
export const clientChartNotesInfiniteOptions = (options: Options<ClientChartNotesData>) =>
  infiniteQueryOptions<
    ClientChartNotesResponse,
    ClientChartNotesError,
    InfiniteData<ClientChartNotesResponse>,
    QueryKey<Options<ClientChartNotesData>>,
    number | Pick<QueryKey<Options<ClientChartNotesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClientChartNotesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientChartNotes({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clientChartNotesInfiniteQueryKey(options),
    }
  )

/**
 * list chart notes for client
 */
export const useClientChartNotesQuery = (options: Options<ClientChartNotesData>) =>
  useQuery(clientChartNotesOptions(options))

export const clientClinicalDigestQueryKey = (options: Options<ClientClinicalDigestData>) =>
  createQueryKey('clientClinicalDigest', options)

/**
 * fetch clinical digest for client
 */
export const clientClinicalDigestOptions = (options: Options<ClientClinicalDigestData>) =>
  queryOptions<
    ClientClinicalDigestResponse,
    ClientClinicalDigestError,
    ClientClinicalDigestResponse,
    ReturnType<typeof clientClinicalDigestQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientClinicalDigest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientClinicalDigestQueryKey(options),
  })

/**
 * fetch clinical digest for client
 */
export const useClientClinicalDigestQuery = (options: Options<ClientClinicalDigestData>) =>
  useQuery(clientClinicalDigestOptions(options))

export const publishClientClinicalDigestMutationKey = (
  options?: Partial<Options<PublishClientClinicalDigestData>>
) => createMutationKey('publishClientClinicalDigest', options)

/**
 * publish clinical digest
 */
export const publishClientClinicalDigestMutation = (
  options?: Partial<Options<PublishClientClinicalDigestData>>
): UseMutationOptions<
  PublishClientClinicalDigestResponse,
  PublishClientClinicalDigestError,
  Options<PublishClientClinicalDigestData>
> => {
  const mutationOptions: UseMutationOptions<
    PublishClientClinicalDigestResponse,
    PublishClientClinicalDigestError,
    Options<PublishClientClinicalDigestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishClientClinicalDigest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: publishClientClinicalDigestMutationKey(options),
  }
  return mutationOptions
}

/**
 * publish clinical digest
 */
export const usePublishClientClinicalDigestMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        PublishClientClinicalDigestResponse,
        PublishClientClinicalDigestError,
        Options<PublishClientClinicalDigestData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...publishClientClinicalDigestMutation(), ...mutationOptions })

export const unpublishClientClinicalDigestMutationKey = (
  options?: Partial<Options<UnpublishClientClinicalDigestData>>
) => createMutationKey('unpublishClientClinicalDigest', options)

/**
 * unpublish clinical digest
 */
export const unpublishClientClinicalDigestMutation = (
  options?: Partial<Options<UnpublishClientClinicalDigestData>>
): UseMutationOptions<
  UnpublishClientClinicalDigestResponse,
  UnpublishClientClinicalDigestError,
  Options<UnpublishClientClinicalDigestData>
> => {
  const mutationOptions: UseMutationOptions<
    UnpublishClientClinicalDigestResponse,
    UnpublishClientClinicalDigestError,
    Options<UnpublishClientClinicalDigestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishClientClinicalDigest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: unpublishClientClinicalDigestMutationKey(options),
  }
  return mutationOptions
}

/**
 * unpublish clinical digest
 */
export const useUnpublishClientClinicalDigestMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UnpublishClientClinicalDigestResponse,
        UnpublishClientClinicalDigestError,
        Options<UnpublishClientClinicalDigestData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...unpublishClientClinicalDigestMutation(), ...mutationOptions })

export const clientCommunicationRecipientsQueryKey = (
  options: Options<ClientCommunicationRecipientsData>
) => createQueryKey('clientCommunicationRecipients', options)

/**
 * list client communication recipients
 */
export const clientCommunicationRecipientsOptions = (
  options: Options<ClientCommunicationRecipientsData>
) =>
  queryOptions<
    ClientCommunicationRecipientsResponse,
    ClientCommunicationRecipientsError,
    ClientCommunicationRecipientsResponse,
    ReturnType<typeof clientCommunicationRecipientsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientCommunicationRecipients({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientCommunicationRecipientsQueryKey(options),
  })

/**
 * list client communication recipients
 */
export const useClientCommunicationRecipientsQuery = (
  options: Options<ClientCommunicationRecipientsData>
) => useQuery(clientCommunicationRecipientsOptions(options))

export const clientCostEstimateShowQueryKey = (options: Options<ClientCostEstimateShowData>) =>
  createQueryKey('clientCostEstimateShow', options)

/**
 * get the latest cost estimate for a client
 */
export const clientCostEstimateShowOptions = (options: Options<ClientCostEstimateShowData>) =>
  queryOptions<
    ClientCostEstimateShowResponse,
    ClientCostEstimateShowError,
    ClientCostEstimateShowResponse,
    ReturnType<typeof clientCostEstimateShowQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientCostEstimateShow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientCostEstimateShowQueryKey(options),
  })

/**
 * get the latest cost estimate for a client
 */
export const useClientCostEstimateShowQuery = (options: Options<ClientCostEstimateShowData>) =>
  useQuery(clientCostEstimateShowOptions(options))

export const clientCostEstimateCreateMutationKey = (
  options?: Partial<Options<ClientCostEstimateCreateData>>
) => createMutationKey('clientCostEstimateCreate', options)

/**
 * create a cost estimate for a client
 */
export const clientCostEstimateCreateMutation = (
  options?: Partial<Options<ClientCostEstimateCreateData>>
): UseMutationOptions<
  ClientCostEstimateCreateResponse,
  ClientCostEstimateCreateError,
  Options<ClientCostEstimateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientCostEstimateCreateResponse,
    ClientCostEstimateCreateError,
    Options<ClientCostEstimateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clientCostEstimateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: clientCostEstimateCreateMutationKey(options),
  }
  return mutationOptions
}

/**
 * create a cost estimate for a client
 */
export const useClientCostEstimateCreateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ClientCostEstimateCreateResponse,
        ClientCostEstimateCreateError,
        Options<ClientCostEstimateCreateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...clientCostEstimateCreateMutation(), ...mutationOptions })

export const clientCostEstimateUpdateMutationKey = (
  options?: Partial<Options<ClientCostEstimateUpdateData>>
) => createMutationKey('clientCostEstimateUpdate', options)

/**
 * update an existing cost estimate
 */
export const clientCostEstimateUpdateMutation = (
  options?: Partial<Options<ClientCostEstimateUpdateData>>
): UseMutationOptions<
  ClientCostEstimateUpdateResponse,
  ClientCostEstimateUpdateError,
  Options<ClientCostEstimateUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientCostEstimateUpdateResponse,
    ClientCostEstimateUpdateError,
    Options<ClientCostEstimateUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clientCostEstimateUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: clientCostEstimateUpdateMutationKey(options),
  }
  return mutationOptions
}

/**
 * update an existing cost estimate
 */
export const useClientCostEstimateUpdateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ClientCostEstimateUpdateResponse,
        ClientCostEstimateUpdateError,
        Options<ClientCostEstimateUpdateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...clientCostEstimateUpdateMutation(), ...mutationOptions })

export const clientCostEstimateSendToFamilyMutationKey = (
  options?: Partial<Options<ClientCostEstimateSendToFamilyData>>
) => createMutationKey('clientCostEstimateSendToFamily', options)

/**
 * send the cost estimate to the family via SMS
 */
export const clientCostEstimateSendToFamilyMutation = (
  options?: Partial<Options<ClientCostEstimateSendToFamilyData>>
): UseMutationOptions<
  ClientCostEstimateSendToFamilyResponse,
  ClientCostEstimateSendToFamilyError,
  Options<ClientCostEstimateSendToFamilyData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientCostEstimateSendToFamilyResponse,
    ClientCostEstimateSendToFamilyError,
    Options<ClientCostEstimateSendToFamilyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clientCostEstimateSendToFamily({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: clientCostEstimateSendToFamilyMutationKey(options),
  }
  return mutationOptions
}

/**
 * send the cost estimate to the family via SMS
 */
export const useClientCostEstimateSendToFamilyMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ClientCostEstimateSendToFamilyResponse,
        ClientCostEstimateSendToFamilyError,
        Options<ClientCostEstimateSendToFamilyData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...clientCostEstimateSendToFamilyMutation(), ...mutationOptions })

export const clientCostEstimateSyncInsuranceDataMutationKey = (
  options?: Partial<Options<ClientCostEstimateSyncInsuranceDataData>>
) => createMutationKey('clientCostEstimateSyncInsuranceData', options)

/**
 * enqueue an insurance-data sync job
 */
export const clientCostEstimateSyncInsuranceDataMutation = (
  options?: Partial<Options<ClientCostEstimateSyncInsuranceDataData>>
): UseMutationOptions<
  ClientCostEstimateSyncInsuranceDataResponse,
  ClientCostEstimateSyncInsuranceDataError,
  Options<ClientCostEstimateSyncInsuranceDataData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientCostEstimateSyncInsuranceDataResponse,
    ClientCostEstimateSyncInsuranceDataError,
    Options<ClientCostEstimateSyncInsuranceDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clientCostEstimateSyncInsuranceData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: clientCostEstimateSyncInsuranceDataMutationKey(options),
  }
  return mutationOptions
}

/**
 * enqueue an insurance-data sync job
 */
export const useClientCostEstimateSyncInsuranceDataMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ClientCostEstimateSyncInsuranceDataResponse,
        ClientCostEstimateSyncInsuranceDataError,
        Options<ClientCostEstimateSyncInsuranceDataData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...clientCostEstimateSyncInsuranceDataMutation(), ...mutationOptions })

export const clientCostEstimateSyncStatusQueryKey = (
  options: Options<ClientCostEstimateSyncStatusData>
) => createQueryKey('clientCostEstimateSyncStatus', options)

/**
 * poll the insurance-data sync job status
 */
export const clientCostEstimateSyncStatusOptions = (
  options: Options<ClientCostEstimateSyncStatusData>
) =>
  queryOptions<
    ClientCostEstimateSyncStatusResponse,
    ClientCostEstimateSyncStatusError,
    ClientCostEstimateSyncStatusResponse,
    ReturnType<typeof clientCostEstimateSyncStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientCostEstimateSyncStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientCostEstimateSyncStatusQueryKey(options),
  })

/**
 * poll the insurance-data sync job status
 */
export const useClientCostEstimateSyncStatusQuery = (
  options: Options<ClientCostEstimateSyncStatusData>
) => useQuery(clientCostEstimateSyncStatusOptions(options))

export const createClientDirectUploadMutationKey = (
  options?: Partial<Options<CreateClientDirectUploadData>>
) => createMutationKey('createClientDirectUpload', options)

/**
 * Create a direct upload
 */
export const createClientDirectUploadMutation = (
  options?: Partial<Options<CreateClientDirectUploadData>>
): UseMutationOptions<
  CreateClientDirectUploadResponse,
  CreateClientDirectUploadError,
  Options<CreateClientDirectUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateClientDirectUploadResponse,
    CreateClientDirectUploadError,
    Options<CreateClientDirectUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClientDirectUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createClientDirectUploadMutationKey(options),
  }
  return mutationOptions
}

/**
 * Create a direct upload
 */
export const useCreateClientDirectUploadMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateClientDirectUploadResponse,
        CreateClientDirectUploadError,
        Options<CreateClientDirectUploadData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createClientDirectUploadMutation(), ...mutationOptions })

export const createClientEligibilityMutationKey = (
  options?: Partial<Options<CreateClientEligibilityData>>
) => createMutationKey('createClientEligibility', options)

/**
 * Create an eligibility check
 */
export const createClientEligibilityMutation = (
  options?: Partial<Options<CreateClientEligibilityData>>
): UseMutationOptions<
  CreateClientEligibilityResponse,
  CreateClientEligibilityError,
  Options<CreateClientEligibilityData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateClientEligibilityResponse,
    CreateClientEligibilityError,
    Options<CreateClientEligibilityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClientEligibility({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createClientEligibilityMutationKey(options),
  }
  return mutationOptions
}

/**
 * Create an eligibility check
 */
export const useCreateClientEligibilityMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateClientEligibilityResponse,
        CreateClientEligibilityError,
        Options<CreateClientEligibilityData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createClientEligibilityMutation(), ...mutationOptions })

export const clientEventsQueryKey = (options: Options<ClientEventsData>) =>
  createQueryKey('clientEvents', options)

/**
 * List client events
 */
export const clientEventsOptions = (options: Options<ClientEventsData>) =>
  queryOptions<
    ClientEventsResponse,
    ClientEventsError,
    ClientEventsResponse,
    ReturnType<typeof clientEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientEventsQueryKey(options),
  })

/**
 * List client events
 */
export const useClientEventsQuery = (options: Options<ClientEventsData>) =>
  useQuery(clientEventsOptions(options))

export const createClientEventMutationKey = (options?: Partial<Options<CreateClientEventData>>) =>
  createMutationKey('createClientEvent', options)

/**
 * Create a client event
 */
export const createClientEventMutation = (
  options?: Partial<Options<CreateClientEventData>>
): UseMutationOptions<
  CreateClientEventResponse,
  CreateClientEventError,
  Options<CreateClientEventData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateClientEventResponse,
    CreateClientEventError,
    Options<CreateClientEventData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClientEvent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createClientEventMutationKey(options),
  }
  return mutationOptions
}

/**
 * Create a client event
 */
export const useCreateClientEventMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateClientEventResponse,
        CreateClientEventError,
        Options<CreateClientEventData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createClientEventMutation(), ...mutationOptions })

export const clientForthcomingAppointmentQueryKey = (
  options: Options<ClientForthcomingAppointmentData>
) => createQueryKey('clientForthcomingAppointment', options)

/**
 * Returns appointment info for a client across all journeys
 */
export const clientForthcomingAppointmentOptions = (
  options: Options<ClientForthcomingAppointmentData>
) =>
  queryOptions<
    ClientForthcomingAppointmentResponse,
    ClientForthcomingAppointmentError,
    ClientForthcomingAppointmentResponse,
    ReturnType<typeof clientForthcomingAppointmentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientForthcomingAppointment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientForthcomingAppointmentQueryKey(options),
  })

/**
 * Returns appointment info for a client across all journeys
 */
export const useClientForthcomingAppointmentQuery = (
  options: Options<ClientForthcomingAppointmentData>
) => useQuery(clientForthcomingAppointmentOptions(options))

export const joinClientForthcomingAppointmentMutationKey = (
  options?: Partial<Options<JoinClientForthcomingAppointmentData>>
) => createMutationKey('joinClientForthcomingAppointment', options)

/**
 * Records client join and returns session URL
 */
export const joinClientForthcomingAppointmentMutation = (
  options?: Partial<Options<JoinClientForthcomingAppointmentData>>
): UseMutationOptions<
  JoinClientForthcomingAppointmentResponse,
  JoinClientForthcomingAppointmentError,
  Options<JoinClientForthcomingAppointmentData>
> => {
  const mutationOptions: UseMutationOptions<
    JoinClientForthcomingAppointmentResponse,
    JoinClientForthcomingAppointmentError,
    Options<JoinClientForthcomingAppointmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await joinClientForthcomingAppointment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: joinClientForthcomingAppointmentMutationKey(options),
  }
  return mutationOptions
}

/**
 * Records client join and returns session URL
 */
export const useJoinClientForthcomingAppointmentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        JoinClientForthcomingAppointmentResponse,
        JoinClientForthcomingAppointmentError,
        Options<JoinClientForthcomingAppointmentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...joinClientForthcomingAppointmentMutation(), ...mutationOptions })

export const clientInsuranceScansQueryKey = (options: Options<ClientInsuranceScansData>) =>
  createQueryKey('clientInsuranceScans', options)

/**
 * Get the latest recent insurance scan
 */
export const clientInsuranceScansOptions = (options: Options<ClientInsuranceScansData>) =>
  queryOptions<
    ClientInsuranceScansResponse,
    ClientInsuranceScansError,
    ClientInsuranceScansResponse,
    ReturnType<typeof clientInsuranceScansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientInsuranceScans({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientInsuranceScansQueryKey(options),
  })

/**
 * Get the latest recent insurance scan
 */
export const useClientInsuranceScansQuery = (options: Options<ClientInsuranceScansData>) =>
  useQuery(clientInsuranceScansOptions(options))

export const createClientInsuranceScanMutationKey = (
  options?: Partial<Options<CreateClientInsuranceScanData>>
) => createMutationKey('createClientInsuranceScan', options)

/**
 * Create an insurance scan
 */
export const createClientInsuranceScanMutation = (
  options?: Partial<Options<CreateClientInsuranceScanData>>
): UseMutationOptions<
  CreateClientInsuranceScanResponse,
  CreateClientInsuranceScanError,
  Options<CreateClientInsuranceScanData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateClientInsuranceScanResponse,
    CreateClientInsuranceScanError,
    Options<CreateClientInsuranceScanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClientInsuranceScan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createClientInsuranceScanMutationKey(options),
  }
  return mutationOptions
}

/**
 * Create an insurance scan
 */
export const useCreateClientInsuranceScanMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateClientInsuranceScanResponse,
        CreateClientInsuranceScanError,
        Options<CreateClientInsuranceScanData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createClientInsuranceScanMutation(), ...mutationOptions })

export const clientNotificationsQueryKey = (options: Options<ClientNotificationsData>) =>
  createQueryKey('clientNotifications', options)

/**
 * list recent client notifications
 */
export const clientNotificationsOptions = (options: Options<ClientNotificationsData>) =>
  queryOptions<
    ClientNotificationsResponse,
    DefaultError,
    ClientNotificationsResponse,
    ReturnType<typeof clientNotificationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientNotifications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientNotificationsQueryKey(options),
  })

/**
 * list recent client notifications
 */
export const useClientNotificationsQuery = (options: Options<ClientNotificationsData>) =>
  useQuery(clientNotificationsOptions(options))

export const clientPayerFormDataQueryKey = (options: Options<ClientPayerFormDataData>) =>
  createQueryKey('clientPayerFormData', options)

/**
 * get form data for client payers
 */
export const clientPayerFormDataOptions = (options: Options<ClientPayerFormDataData>) =>
  queryOptions<
    ClientPayerFormDataResponse,
    ClientPayerFormDataError,
    ClientPayerFormDataResponse,
    ReturnType<typeof clientPayerFormDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientPayerFormData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientPayerFormDataQueryKey(options),
  })

/**
 * get form data for client payers
 */
export const useClientPayerFormDataQuery = (options: Options<ClientPayerFormDataData>) =>
  useQuery(clientPayerFormDataOptions(options))

export const updateClientPayerMutationKey = (options?: Partial<Options<UpdateClientPayerData>>) =>
  createMutationKey('updateClientPayer', options)

/**
 * update client payer
 */
export const updateClientPayerMutation = (
  options?: Partial<Options<UpdateClientPayerData>>
): UseMutationOptions<
  UpdateClientPayerResponse,
  UpdateClientPayerError,
  Options<UpdateClientPayerData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateClientPayerResponse,
    UpdateClientPayerError,
    Options<UpdateClientPayerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateClientPayer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateClientPayerMutationKey(options),
  }
  return mutationOptions
}

/**
 * update client payer
 */
export const useUpdateClientPayerMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateClientPayerResponse,
        UpdateClientPayerError,
        Options<UpdateClientPayerData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateClientPayerMutation(), ...mutationOptions })

export const clientProcessWorkflowsQueryKey = (options: Options<ClientProcessWorkflowsData>) =>
  createQueryKey('clientProcessWorkflows', options)

/**
 * list process workflows for client
 */
export const clientProcessWorkflowsOptions = (options: Options<ClientProcessWorkflowsData>) =>
  queryOptions<
    ClientProcessWorkflowsResponse,
    ClientProcessWorkflowsError,
    ClientProcessWorkflowsResponse,
    ReturnType<typeof clientProcessWorkflowsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientProcessWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientProcessWorkflowsQueryKey(options),
  })

export const clientProcessWorkflowsInfiniteQueryKey = (
  options: Options<ClientProcessWorkflowsData>
): QueryKey<Options<ClientProcessWorkflowsData>> =>
  createQueryKey('clientProcessWorkflows', options, true)

/**
 * list process workflows for client
 */
export const clientProcessWorkflowsInfiniteOptions = (
  options: Options<ClientProcessWorkflowsData>
) =>
  infiniteQueryOptions<
    ClientProcessWorkflowsResponse,
    ClientProcessWorkflowsError,
    InfiniteData<ClientProcessWorkflowsResponse>,
    QueryKey<Options<ClientProcessWorkflowsData>>,
    | number
    | Pick<QueryKey<Options<ClientProcessWorkflowsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClientProcessWorkflowsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientProcessWorkflows({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clientProcessWorkflowsInfiniteQueryKey(options),
    }
  )

/**
 * list process workflows for client
 */
export const useClientProcessWorkflowsQuery = (options: Options<ClientProcessWorkflowsData>) =>
  useQuery(clientProcessWorkflowsOptions(options))

export const createClientProcessWorkflowMutationKey = (
  options?: Partial<Options<CreateClientProcessWorkflowData>>
) => createMutationKey('createClientProcessWorkflow', options)

/**
 * start a new workflow for the client
 */
export const createClientProcessWorkflowMutation = (
  options?: Partial<Options<CreateClientProcessWorkflowData>>
): UseMutationOptions<
  unknown,
  CreateClientProcessWorkflowError,
  Options<CreateClientProcessWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    CreateClientProcessWorkflowError,
    Options<CreateClientProcessWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClientProcessWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createClientProcessWorkflowMutationKey(options),
  }
  return mutationOptions
}

/**
 * start a new workflow for the client
 */
export const useCreateClientProcessWorkflowMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        unknown,
        CreateClientProcessWorkflowError,
        Options<CreateClientProcessWorkflowData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createClientProcessWorkflowMutation(), ...mutationOptions })

export const clientProcessWorkflowQueryKey = (options: Options<ClientProcessWorkflowData>) =>
  createQueryKey('clientProcessWorkflow', options)

/**
 * get a single process workflow with Temporal detail
 */
export const clientProcessWorkflowOptions = (options: Options<ClientProcessWorkflowData>) =>
  queryOptions<
    ClientProcessWorkflowResponse,
    ClientProcessWorkflowError,
    ClientProcessWorkflowResponse,
    ReturnType<typeof clientProcessWorkflowQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientProcessWorkflow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientProcessWorkflowQueryKey(options),
  })

/**
 * get a single process workflow with Temporal detail
 */
export const useClientProcessWorkflowQuery = (options: Options<ClientProcessWorkflowData>) =>
  useQuery(clientProcessWorkflowOptions(options))

export const updateClientSecondGuardianMutationKey = (
  options?: Partial<Options<UpdateClientSecondGuardianData>>
) => createMutationKey('updateClientSecondGuardian', options)

/**
 * update second guardian information for a client
 */
export const updateClientSecondGuardianMutation = (
  options?: Partial<Options<UpdateClientSecondGuardianData>>
): UseMutationOptions<unknown, DefaultError, Options<UpdateClientSecondGuardianData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UpdateClientSecondGuardianData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateClientSecondGuardian({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateClientSecondGuardianMutationKey(options),
  }
  return mutationOptions
}

/**
 * update second guardian information for a client
 */
export const useUpdateClientSecondGuardianMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<unknown, DefaultError, Options<UpdateClientSecondGuardianData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...updateClientSecondGuardianMutation(), ...mutationOptions })

export const clientSessionLimitQueryKey = (options: Options<ClientSessionLimitData>) =>
  createQueryKey('clientSessionLimit', options)

/**
 * Get active session limit for a client
 */
export const clientSessionLimitOptions = (options: Options<ClientSessionLimitData>) =>
  queryOptions<
    ClientSessionLimitResponse,
    ClientSessionLimitError,
    ClientSessionLimitResponse,
    ReturnType<typeof clientSessionLimitQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientSessionLimit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientSessionLimitQueryKey(options),
  })

/**
 * Get active session limit for a client
 */
export const useClientSessionLimitQuery = (options: Options<ClientSessionLimitData>) =>
  useQuery(clientSessionLimitOptions(options))

export const clientSurveyResultsQueryKey = (options: Options<ClientSurveyResultsData>) =>
  createQueryKey('clientSurveyResults', options)

/**
 * show clinical survey results for a client
 */
export const clientSurveyResultsOptions = (options: Options<ClientSurveyResultsData>) =>
  queryOptions<
    ClientSurveyResultsResponse,
    DefaultError,
    ClientSurveyResultsResponse,
    ReturnType<typeof clientSurveyResultsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientSurveyResults({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientSurveyResultsQueryKey(options),
  })

/**
 * show clinical survey results for a client
 */
export const useClientSurveyResultsQuery = (options: Options<ClientSurveyResultsData>) =>
  useQuery(clientSurveyResultsOptions(options))

export const clientByIdQueryKey = (options: Options<ClientByIdData>) =>
  createQueryKey('clientById', options)

/**
 * get client details
 */
export const clientByIdOptions = (options: Options<ClientByIdData>) =>
  queryOptions<
    ClientByIdResponse,
    ClientByIdError,
    ClientByIdResponse,
    ReturnType<typeof clientByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientByIdQueryKey(options),
  })

/**
 * get client details
 */
export const useClientByIdQuery = (options: Options<ClientByIdData>) =>
  useQuery(clientByIdOptions(options))

export const clientProfileQueryKey = (options: Options<ClientProfileData>) =>
  createQueryKey('clientProfile', options)

/**
 * get client profile
 */
export const clientProfileOptions = (options: Options<ClientProfileData>) =>
  queryOptions<
    ClientProfileResponse,
    ClientProfileError,
    ClientProfileResponse,
    ReturnType<typeof clientProfileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientProfile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientProfileQueryKey(options),
  })

/**
 * get client profile
 */
export const useClientProfileQuery = (options: Options<ClientProfileData>) =>
  useQuery(clientProfileOptions(options))

export const clinicalQualityDashboardScoresQueryKey = (
  options?: Options<ClinicalQualityDashboardScoresData>
) => createQueryKey('clinicalQualityDashboardScores', options)

/**
 * returns paginated per-note Clinical Quality scores
 */
export const clinicalQualityDashboardScoresOptions = (
  options?: Options<ClinicalQualityDashboardScoresData>
) =>
  queryOptions<
    ClinicalQualityDashboardScoresResponse2,
    ClinicalQualityDashboardScoresError,
    ClinicalQualityDashboardScoresResponse2,
    ReturnType<typeof clinicalQualityDashboardScoresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicalQualityDashboardScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicalQualityDashboardScoresQueryKey(options),
  })

export const clinicalQualityDashboardScoresInfiniteQueryKey = (
  options?: Options<ClinicalQualityDashboardScoresData>
): QueryKey<Options<ClinicalQualityDashboardScoresData>> =>
  createQueryKey('clinicalQualityDashboardScores', options, true)

/**
 * returns paginated per-note Clinical Quality scores
 */
export const clinicalQualityDashboardScoresInfiniteOptions = (
  options?: Options<ClinicalQualityDashboardScoresData>
) =>
  infiniteQueryOptions<
    ClinicalQualityDashboardScoresResponse2,
    ClinicalQualityDashboardScoresError,
    InfiniteData<ClinicalQualityDashboardScoresResponse2>,
    QueryKey<Options<ClinicalQualityDashboardScoresData>>,
    | number
    | Pick<
        QueryKey<Options<ClinicalQualityDashboardScoresData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClinicalQualityDashboardScoresData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clinicalQualityDashboardScores({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clinicalQualityDashboardScoresInfiniteQueryKey(options),
    }
  )

/**
 * returns paginated per-note Clinical Quality scores
 */
export const useClinicalQualityDashboardScoresQuery = (
  options?: Options<ClinicalQualityDashboardScoresData>
) => useQuery(clinicalQualityDashboardScoresOptions(options))

export const clinicalQualityDashboardSummaryQueryKey = (
  options?: Options<ClinicalQualityDashboardSummaryData>
) => createQueryKey('clinicalQualityDashboardSummary', options)

/**
 * returns aggregate Clinical Quality summary for the dashboard
 */
export const clinicalQualityDashboardSummaryOptions = (
  options?: Options<ClinicalQualityDashboardSummaryData>
) =>
  queryOptions<
    ClinicalQualityDashboardSummaryResponse,
    ClinicalQualityDashboardSummaryError,
    ClinicalQualityDashboardSummaryResponse,
    ReturnType<typeof clinicalQualityDashboardSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicalQualityDashboardSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicalQualityDashboardSummaryQueryKey(options),
  })

/**
 * returns aggregate Clinical Quality summary for the dashboard
 */
export const useClinicalQualityDashboardSummaryQuery = (
  options?: Options<ClinicalQualityDashboardSummaryData>
) => useQuery(clinicalQualityDashboardSummaryOptions(options))

export const clinicalQualityScoreQueryKey = (options: Options<ClinicalQualityScoreData>) =>
  createQueryKey('clinicalQualityScore', options)

/**
 * show a clinical quality score report
 */
export const clinicalQualityScoreOptions = (options: Options<ClinicalQualityScoreData>) =>
  queryOptions<
    ClinicalQualityScoreResponse,
    DefaultError,
    ClinicalQualityScoreResponse,
    ReturnType<typeof clinicalQualityScoreQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicalQualityScore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicalQualityScoreQueryKey(options),
  })

/**
 * show a clinical quality score report
 */
export const useClinicalQualityScoreQuery = (options: Options<ClinicalQualityScoreData>) =>
  useQuery(clinicalQualityScoreOptions(options))

export const searchClinicianMatchingClientsQueryKey = (
  options: Options<SearchClinicianMatchingClientsData>
) => createQueryKey('searchClinicianMatchingClients', options)

/**
 * search families by name
 */
export const searchClinicianMatchingClientsOptions = (
  options: Options<SearchClinicianMatchingClientsData>
) =>
  queryOptions<
    SearchClinicianMatchingClientsResponse,
    DefaultError,
    SearchClinicianMatchingClientsResponse,
    ReturnType<typeof searchClinicianMatchingClientsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchClinicianMatchingClients({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: searchClinicianMatchingClientsQueryKey(options),
  })

/**
 * search families by name
 */
export const useSearchClinicianMatchingClientsQuery = (
  options: Options<SearchClinicianMatchingClientsData>
) => useQuery(searchClinicianMatchingClientsOptions(options))

export const resolveClinicianMatchingIdQueryKey = (
  options: Options<ResolveClinicianMatchingIdData>
) => createQueryKey('resolveClinicianMatchingId', options)

/**
 * resolve a bare UUID to a journey or client
 */
export const resolveClinicianMatchingIdOptions = (
  options: Options<ResolveClinicianMatchingIdData>
) =>
  queryOptions<
    ResolveClinicianMatchingIdResponse,
    DefaultError,
    ResolveClinicianMatchingIdResponse,
    ReturnType<typeof resolveClinicianMatchingIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resolveClinicianMatchingId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: resolveClinicianMatchingIdQueryKey(options),
  })

/**
 * resolve a bare UUID to a journey or client
 */
export const useResolveClinicianMatchingIdQuery = (
  options: Options<ResolveClinicianMatchingIdData>
) => useQuery(resolveClinicianMatchingIdOptions(options))

export const searchClinicianMatchingCliniciansQueryKey = (
  options: Options<SearchClinicianMatchingCliniciansData>
) => createQueryKey('searchClinicianMatchingClinicians', options)

/**
 * search clinicians by name
 */
export const searchClinicianMatchingCliniciansOptions = (
  options: Options<SearchClinicianMatchingCliniciansData>
) =>
  queryOptions<
    SearchClinicianMatchingCliniciansResponse,
    DefaultError,
    SearchClinicianMatchingCliniciansResponse,
    ReturnType<typeof searchClinicianMatchingCliniciansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchClinicianMatchingClinicians({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: searchClinicianMatchingCliniciansQueryKey(options),
  })

/**
 * search clinicians by name
 */
export const useSearchClinicianMatchingCliniciansQuery = (
  options: Options<SearchClinicianMatchingCliniciansData>
) => useQuery(searchClinicianMatchingCliniciansOptions(options))

export const clinicianMatchRunsSummaryQueryKey = (
  options?: Options<ClinicianMatchRunsSummaryData>
) => createQueryKey('clinicianMatchRunsSummary', options)

/**
 * aggregate health summary over recent match runs
 */
export const clinicianMatchRunsSummaryOptions = (
  options?: Options<ClinicianMatchRunsSummaryData>
) =>
  queryOptions<
    ClinicianMatchRunsSummaryResponse,
    DefaultError,
    ClinicianMatchRunsSummaryResponse,
    ReturnType<typeof clinicianMatchRunsSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianMatchRunsSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianMatchRunsSummaryQueryKey(options),
  })

/**
 * aggregate health summary over recent match runs
 */
export const useClinicianMatchRunsSummaryQuery = (
  options?: Options<ClinicianMatchRunsSummaryData>
) => useQuery(clinicianMatchRunsSummaryOptions(options))

export const clinicianMatchingIntakeOutcomesQueryKey = (
  options?: Options<ClinicianMatchingIntakeOutcomesData>
) => createQueryKey('clinicianMatchingIntakeOutcomes', options)

/**
 * intake outcomes for matched journeys over a recent window
 */
export const clinicianMatchingIntakeOutcomesOptions = (
  options?: Options<ClinicianMatchingIntakeOutcomesData>
) =>
  queryOptions<
    ClinicianMatchingIntakeOutcomesResponse,
    DefaultError,
    ClinicianMatchingIntakeOutcomesResponse,
    ReturnType<typeof clinicianMatchingIntakeOutcomesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianMatchingIntakeOutcomes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianMatchingIntakeOutcomesQueryKey(options),
  })

/**
 * intake outcomes for matched journeys over a recent window
 */
export const useClinicianMatchingIntakeOutcomesQuery = (
  options?: Options<ClinicianMatchingIntakeOutcomesData>
) => useQuery(clinicianMatchingIntakeOutcomesOptions(options))

export const clinicianMatchRunsQueryKey = (options?: Options<ClinicianMatchRunsData>) =>
  createQueryKey('clinicianMatchRuns', options)

/**
 * paginated history of matching-screen renders
 */
export const clinicianMatchRunsOptions = (options?: Options<ClinicianMatchRunsData>) =>
  queryOptions<
    ClinicianMatchRunsResponse,
    DefaultError,
    ClinicianMatchRunsResponse,
    ReturnType<typeof clinicianMatchRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianMatchRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianMatchRunsQueryKey(options),
  })

export const clinicianMatchRunsInfiniteQueryKey = (
  options?: Options<ClinicianMatchRunsData>
): QueryKey<Options<ClinicianMatchRunsData>> => createQueryKey('clinicianMatchRuns', options, true)

/**
 * paginated history of matching-screen renders
 */
export const clinicianMatchRunsInfiniteOptions = (options?: Options<ClinicianMatchRunsData>) =>
  infiniteQueryOptions<
    ClinicianMatchRunsResponse,
    DefaultError,
    InfiniteData<ClinicianMatchRunsResponse>,
    QueryKey<Options<ClinicianMatchRunsData>>,
    | number
    | Pick<QueryKey<Options<ClinicianMatchRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClinicianMatchRunsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clinicianMatchRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clinicianMatchRunsInfiniteQueryKey(options),
    }
  )

/**
 * paginated history of matching-screen renders
 */
export const useClinicianMatchRunsQuery = (options?: Options<ClinicianMatchRunsData>) =>
  useQuery(clinicianMatchRunsOptions(options))

export const clinicianSelectedMatchesQueryKey = (options?: Options<ClinicianSelectedMatchesData>) =>
  createQueryKey('clinicianSelectedMatches', options)

/**
 * paginated history of clinician selections
 */
export const clinicianSelectedMatchesOptions = (options?: Options<ClinicianSelectedMatchesData>) =>
  queryOptions<
    ClinicianSelectedMatchesResponse,
    DefaultError,
    ClinicianSelectedMatchesResponse,
    ReturnType<typeof clinicianSelectedMatchesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianSelectedMatches({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianSelectedMatchesQueryKey(options),
  })

export const clinicianSelectedMatchesInfiniteQueryKey = (
  options?: Options<ClinicianSelectedMatchesData>
): QueryKey<Options<ClinicianSelectedMatchesData>> =>
  createQueryKey('clinicianSelectedMatches', options, true)

/**
 * paginated history of clinician selections
 */
export const clinicianSelectedMatchesInfiniteOptions = (
  options?: Options<ClinicianSelectedMatchesData>
) =>
  infiniteQueryOptions<
    ClinicianSelectedMatchesResponse,
    DefaultError,
    InfiniteData<ClinicianSelectedMatchesResponse>,
    QueryKey<Options<ClinicianSelectedMatchesData>>,
    | number
    | Pick<
        QueryKey<Options<ClinicianSelectedMatchesData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClinicianSelectedMatchesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clinicianSelectedMatches({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clinicianSelectedMatchesInfiniteQueryKey(options),
    }
  )

/**
 * paginated history of clinician selections
 */
export const useClinicianSelectedMatchesQuery = (options?: Options<ClinicianSelectedMatchesData>) =>
  useQuery(clinicianSelectedMatchesOptions(options))

export const clinicianMatchingOverviewQueryKey = (
  options: Options<ClinicianMatchingOverviewData>
) => createQueryKey('clinicianMatchingOverview', options)

/**
 * matching overview for a journey
 */
export const clinicianMatchingOverviewOptions = (options: Options<ClinicianMatchingOverviewData>) =>
  queryOptions<
    ClinicianMatchingOverviewResponse,
    DefaultError,
    ClinicianMatchingOverviewResponse,
    ReturnType<typeof clinicianMatchingOverviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianMatchingOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianMatchingOverviewQueryKey(options),
  })

/**
 * matching overview for a journey
 */
export const useClinicianMatchingOverviewQuery = (
  options: Options<ClinicianMatchingOverviewData>
) => useQuery(clinicianMatchingOverviewOptions(options))

export const clinicianMatchDiagnosisQueryKey = (options: Options<ClinicianMatchDiagnosisData>) =>
  createQueryKey('clinicianMatchDiagnosis', options)

/**
 * diagnose why a clinician did or didn't match
 */
export const clinicianMatchDiagnosisOptions = (options: Options<ClinicianMatchDiagnosisData>) =>
  queryOptions<
    ClinicianMatchDiagnosisResponse,
    DefaultError,
    ClinicianMatchDiagnosisResponse,
    ReturnType<typeof clinicianMatchDiagnosisQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianMatchDiagnosis({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianMatchDiagnosisQueryKey(options),
  })

/**
 * diagnose why a clinician did or didn't match
 */
export const useClinicianMatchDiagnosisQuery = (options: Options<ClinicianMatchDiagnosisData>) =>
  useQuery(clinicianMatchDiagnosisOptions(options))

export const clinicianMatchingCandidatePoolQueryKey = (
  options: Options<ClinicianMatchingCandidatePoolData>
) => createQueryKey('clinicianMatchingCandidatePool', options)

/**
 * diagnose the whole in-state candidate pool
 */
export const clinicianMatchingCandidatePoolOptions = (
  options: Options<ClinicianMatchingCandidatePoolData>
) =>
  queryOptions<
    ClinicianMatchingCandidatePoolResponse,
    DefaultError,
    ClinicianMatchingCandidatePoolResponse,
    ReturnType<typeof clinicianMatchingCandidatePoolQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianMatchingCandidatePool({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianMatchingCandidatePoolQueryKey(options),
  })

/**
 * diagnose the whole in-state candidate pool
 */
export const useClinicianMatchingCandidatePoolQuery = (
  options: Options<ClinicianMatchingCandidatePoolData>
) => useQuery(clinicianMatchingCandidatePoolOptions(options))

export const clinicianAppointmentsQueryKey = (options: Options<ClinicianAppointmentsData>) =>
  createQueryKey('clinicianAppointments', options)

/**
 * list appointments for clinician
 */
export const clinicianAppointmentsOptions = (options: Options<ClinicianAppointmentsData>) =>
  queryOptions<
    ClinicianAppointmentsResponse,
    ClinicianAppointmentsError,
    ClinicianAppointmentsResponse,
    ReturnType<typeof clinicianAppointmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianAppointments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianAppointmentsQueryKey(options),
  })

export const clinicianAppointmentsInfiniteQueryKey = (
  options: Options<ClinicianAppointmentsData>
): QueryKey<Options<ClinicianAppointmentsData>> =>
  createQueryKey('clinicianAppointments', options, true)

/**
 * list appointments for clinician
 */
export const clinicianAppointmentsInfiniteOptions = (options: Options<ClinicianAppointmentsData>) =>
  infiniteQueryOptions<
    ClinicianAppointmentsResponse,
    ClinicianAppointmentsError,
    InfiniteData<ClinicianAppointmentsResponse>,
    QueryKey<Options<ClinicianAppointmentsData>>,
    | number
    | Pick<QueryKey<Options<ClinicianAppointmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClinicianAppointmentsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clinicianAppointments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clinicianAppointmentsInfiniteQueryKey(options),
    }
  )

/**
 * list appointments for clinician
 */
export const useClinicianAppointmentsQuery = (options: Options<ClinicianAppointmentsData>) =>
  useQuery(clinicianAppointmentsOptions(options))

export const bulkDeleteClinicianAppointmentsMutationKey = (
  options?: Partial<Options<BulkDeleteClinicianAppointmentsData>>
) => createMutationKey('bulkDeleteClinicianAppointments', options)

/**
 * cancel all appointments for a clinician on a specific day
 */
export const bulkDeleteClinicianAppointmentsMutation = (
  options?: Partial<Options<BulkDeleteClinicianAppointmentsData>>
): UseMutationOptions<
  unknown,
  BulkDeleteClinicianAppointmentsError,
  Options<BulkDeleteClinicianAppointmentsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    BulkDeleteClinicianAppointmentsError,
    Options<BulkDeleteClinicianAppointmentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkDeleteClinicianAppointments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: bulkDeleteClinicianAppointmentsMutationKey(options),
  }
  return mutationOptions
}

/**
 * cancel all appointments for a clinician on a specific day
 */
export const useBulkDeleteClinicianAppointmentsMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        unknown,
        BulkDeleteClinicianAppointmentsError,
        Options<BulkDeleteClinicianAppointmentsData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...bulkDeleteClinicianAppointmentsMutation(), ...mutationOptions })

export const clinicianCalendarAppointmentsQueryKey = (
  options: Options<ClinicianCalendarAppointmentsData>
) => createQueryKey('clinicianCalendarAppointments', options)

/**
 * Lists the assigned clinician's appointments for a date range
 */
export const clinicianCalendarAppointmentsOptions = (
  options: Options<ClinicianCalendarAppointmentsData>
) =>
  queryOptions<
    ClinicianCalendarAppointmentsResponse,
    ClinicianCalendarAppointmentsError,
    ClinicianCalendarAppointmentsResponse,
    ReturnType<typeof clinicianCalendarAppointmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianCalendarAppointments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianCalendarAppointmentsQueryKey(options),
  })

/**
 * Lists the assigned clinician's appointments for a date range
 */
export const useClinicianCalendarAppointmentsQuery = (
  options: Options<ClinicianCalendarAppointmentsData>
) => useQuery(clinicianCalendarAppointmentsOptions(options))

export const clinicianChartNotesQueryKey = (options: Options<ClinicianChartNotesData>) =>
  createQueryKey('clinicianChartNotes', options)

/**
 * list chart notes for clinician
 */
export const clinicianChartNotesOptions = (options: Options<ClinicianChartNotesData>) =>
  queryOptions<
    ClinicianChartNotesResponse,
    ClinicianChartNotesError,
    ClinicianChartNotesResponse,
    ReturnType<typeof clinicianChartNotesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianChartNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianChartNotesQueryKey(options),
  })

export const clinicianChartNotesInfiniteQueryKey = (
  options: Options<ClinicianChartNotesData>
): QueryKey<Options<ClinicianChartNotesData>> =>
  createQueryKey('clinicianChartNotes', options, true)

/**
 * list chart notes for clinician
 */
export const clinicianChartNotesInfiniteOptions = (options: Options<ClinicianChartNotesData>) =>
  infiniteQueryOptions<
    ClinicianChartNotesResponse,
    ClinicianChartNotesError,
    InfiniteData<ClinicianChartNotesResponse>,
    QueryKey<Options<ClinicianChartNotesData>>,
    | number
    | Pick<QueryKey<Options<ClinicianChartNotesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ClinicianChartNotesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clinicianChartNotes({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: clinicianChartNotesInfiniteQueryKey(options),
    }
  )

/**
 * list chart notes for clinician
 */
export const useClinicianChartNotesQuery = (options: Options<ClinicianChartNotesData>) =>
  useQuery(clinicianChartNotesOptions(options))

export const clinicianReassignmentFormDataQueryKey = (
  options: Options<ClinicianReassignmentFormDataData>
) => createQueryKey('clinicianReassignmentFormData', options)

/**
 * get reassignment form data
 */
export const clinicianReassignmentFormDataOptions = (
  options: Options<ClinicianReassignmentFormDataData>
) =>
  queryOptions<
    ClinicianReassignmentFormDataResponse,
    ClinicianReassignmentFormDataError,
    ClinicianReassignmentFormDataResponse,
    ReturnType<typeof clinicianReassignmentFormDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianReassignmentFormData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianReassignmentFormDataQueryKey(options),
  })

/**
 * get reassignment form data
 */
export const useClinicianReassignmentFormDataQuery = (
  options: Options<ClinicianReassignmentFormDataData>
) => useQuery(clinicianReassignmentFormDataOptions(options))

export const clinicianByIdQueryKey = (options: Options<ClinicianByIdData>) =>
  createQueryKey('clinicianById', options)

/**
 * get clinician details
 */
export const clinicianByIdOptions = (options: Options<ClinicianByIdData>) =>
  queryOptions<
    ClinicianByIdResponse,
    ClinicianByIdError,
    ClinicianByIdResponse,
    ReturnType<typeof clinicianByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clinicianById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clinicianByIdQueryKey(options),
  })

/**
 * get clinician details
 */
export const useClinicianByIdQuery = (options: Options<ClinicianByIdData>) =>
  useQuery(clinicianByIdOptions(options))

export const commsPlaygroundEventsQueryKey = (options?: Options<CommsPlaygroundEventsData>) =>
  createQueryKey('commsPlaygroundEvents', options)

/**
 * event & comms catalog
 */
export const commsPlaygroundEventsOptions = (options?: Options<CommsPlaygroundEventsData>) =>
  queryOptions<
    CommsPlaygroundEventsResponse,
    DefaultError,
    CommsPlaygroundEventsResponse,
    ReturnType<typeof commsPlaygroundEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commsPlaygroundEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: commsPlaygroundEventsQueryKey(options),
  })

/**
 * event & comms catalog
 */
export const useCommsPlaygroundEventsQuery = (options?: Options<CommsPlaygroundEventsData>) =>
  useQuery(commsPlaygroundEventsOptions(options))

export const commsPlaygroundTriggerEventMutationKey = (
  options?: Partial<Options<CommsPlaygroundTriggerEventData>>
) => createMutationKey('commsPlaygroundTriggerEvent', options)

/**
 * fire a CDP event to Iterable (synthetic profile)
 */
export const commsPlaygroundTriggerEventMutation = (
  options?: Partial<Options<CommsPlaygroundTriggerEventData>>
): UseMutationOptions<
  CommsPlaygroundTriggerEventResponse,
  CommsPlaygroundTriggerEventError,
  Options<CommsPlaygroundTriggerEventData>
> => {
  const mutationOptions: UseMutationOptions<
    CommsPlaygroundTriggerEventResponse,
    CommsPlaygroundTriggerEventError,
    Options<CommsPlaygroundTriggerEventData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await commsPlaygroundTriggerEvent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: commsPlaygroundTriggerEventMutationKey(options),
  }
  return mutationOptions
}

/**
 * fire a CDP event to Iterable (synthetic profile)
 */
export const useCommsPlaygroundTriggerEventMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CommsPlaygroundTriggerEventResponse,
        CommsPlaygroundTriggerEventError,
        Options<CommsPlaygroundTriggerEventData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...commsPlaygroundTriggerEventMutation(), ...mutationOptions })

export const commsPlaygroundCommsMapQueryKey = (options?: Options<CommsPlaygroundCommsMapData>) =>
  createQueryKey('commsPlaygroundCommsMap', options)

/**
 * unified CDP event -> comm map
 */
export const commsPlaygroundCommsMapOptions = (options?: Options<CommsPlaygroundCommsMapData>) =>
  queryOptions<
    CommsPlaygroundCommsMapResponse,
    DefaultError,
    CommsPlaygroundCommsMapResponse,
    ReturnType<typeof commsPlaygroundCommsMapQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commsPlaygroundCommsMap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: commsPlaygroundCommsMapQueryKey(options),
  })

/**
 * unified CDP event -> comm map
 */
export const useCommsPlaygroundCommsMapQuery = (options?: Options<CommsPlaygroundCommsMapData>) =>
  useQuery(commsPlaygroundCommsMapOptions(options))

export const commsPlaygroundUserCommsQueryKey = (options: Options<CommsPlaygroundUserCommsData>) =>
  createQueryKey('commsPlaygroundUserComms', options)

/**
 * merged comms timeline for a user
 */
export const commsPlaygroundUserCommsOptions = (options: Options<CommsPlaygroundUserCommsData>) =>
  queryOptions<
    CommsPlaygroundUserCommsResponse,
    DefaultError,
    CommsPlaygroundUserCommsResponse,
    ReturnType<typeof commsPlaygroundUserCommsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commsPlaygroundUserComms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: commsPlaygroundUserCommsQueryKey(options),
  })

/**
 * merged comms timeline for a user
 */
export const useCommsPlaygroundUserCommsQuery = (options: Options<CommsPlaygroundUserCommsData>) =>
  useQuery(commsPlaygroundUserCommsOptions(options))

export const concernTypesQueryKey = (options?: Options<ConcernTypesData>) =>
  createQueryKey('concernTypes', options)

/**
 * list flagged concern types
 *
 * Returns the active, flagged concern types from the catalog table that the dual-write flipper is currently writing to (ClientConcernType when :client_concerns_dual_write_JAN_2026 is OFF, ReferralConcernType when ON).
 */
export const concernTypesOptions = (options?: Options<ConcernTypesData>) =>
  queryOptions<
    ConcernTypesResponse,
    DefaultError,
    ConcernTypesResponse,
    ReturnType<typeof concernTypesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await concernTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: concernTypesQueryKey(options),
  })

/**
 * list flagged concern types
 *
 * Returns the active, flagged concern types from the catalog table that the dual-write flipper is currently writing to (ClientConcernType when :client_concerns_dual_write_JAN_2026 is OFF, ReferralConcernType when ON).
 */
export const useConcernTypesQuery = (options?: Options<ConcernTypesData>) =>
  useQuery(concernTypesOptions(options))

export const createContractUtilizationFeedbackMutationKey = (
  options?: Partial<Options<CreateContractUtilizationFeedbackData>>
) => createMutationKey('createContractUtilizationFeedback', options)

/**
 * submit feedback
 */
export const createContractUtilizationFeedbackMutation = (
  options?: Partial<Options<CreateContractUtilizationFeedbackData>>
): UseMutationOptions<unknown, DefaultError, Options<CreateContractUtilizationFeedbackData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<CreateContractUtilizationFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createContractUtilizationFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createContractUtilizationFeedbackMutationKey(options),
  }
  return mutationOptions
}

/**
 * submit feedback
 */
export const useCreateContractUtilizationFeedbackMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<unknown, DefaultError, Options<CreateContractUtilizationFeedbackData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...createContractUtilizationFeedbackMutation(), ...mutationOptions })

export const recordContractUtilizationBadgeInteractionMutationKey = (
  options?: Partial<Options<RecordContractUtilizationBadgeInteractionData>>
) => createMutationKey('recordContractUtilizationBadgeInteraction', options)

/**
 * track badge interaction
 */
export const recordContractUtilizationBadgeInteractionMutation = (
  options?: Partial<Options<RecordContractUtilizationBadgeInteractionData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<RecordContractUtilizationBadgeInteractionData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<RecordContractUtilizationBadgeInteractionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordContractUtilizationBadgeInteraction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordContractUtilizationBadgeInteractionMutationKey(options),
  }
  return mutationOptions
}

/**
 * track badge interaction
 */
export const useRecordContractUtilizationBadgeInteractionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        unknown,
        DefaultError,
        Options<RecordContractUtilizationBadgeInteractionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordContractUtilizationBadgeInteractionMutation(), ...mutationOptions })

export const recordContractUtilizationBadgeImpressionMutationKey = (
  options?: Partial<Options<RecordContractUtilizationBadgeImpressionData>>
) => createMutationKey('recordContractUtilizationBadgeImpression', options)

/**
 * track badge shown
 */
export const recordContractUtilizationBadgeImpressionMutation = (
  options?: Partial<Options<RecordContractUtilizationBadgeImpressionData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<RecordContractUtilizationBadgeImpressionData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<RecordContractUtilizationBadgeImpressionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordContractUtilizationBadgeImpression({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordContractUtilizationBadgeImpressionMutationKey(options),
  }
  return mutationOptions
}

/**
 * track badge shown
 */
export const useRecordContractUtilizationBadgeImpressionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        unknown,
        DefaultError,
        Options<RecordContractUtilizationBadgeImpressionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordContractUtilizationBadgeImpressionMutation(), ...mutationOptions })

export const conversationsQueryKey = (options?: Options<ConversationsData>) =>
  createQueryKey('conversations', options)

/**
 * list conversations
 */
export const conversationsOptions = (options?: Options<ConversationsData>) =>
  queryOptions<
    ConversationsResponse,
    ConversationsError,
    ConversationsResponse,
    ReturnType<typeof conversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await conversations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: conversationsQueryKey(options),
  })

/**
 * list conversations
 */
export const useConversationsQuery = (options?: Options<ConversationsData>) =>
  useQuery(conversationsOptions(options))

export const conversationByIdQueryKey = (options: Options<ConversationByIdData>) =>
  createQueryKey('conversationById', options)

/**
 * show conversation
 */
export const conversationByIdOptions = (options: Options<ConversationByIdData>) =>
  queryOptions<
    ConversationByIdResponse,
    DefaultError,
    ConversationByIdResponse,
    ReturnType<typeof conversationByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await conversationById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: conversationByIdQueryKey(options),
  })

/**
 * show conversation
 */
export const useConversationByIdQuery = (options: Options<ConversationByIdData>) =>
  useQuery(conversationByIdOptions(options))

export const costEstimateQueryKey = (options?: Options<CostEstimateData>) =>
  createQueryKey('costEstimate', options)

/**
 * Retrieve the current client's cost estimate
 */
export const costEstimateOptions = (options?: Options<CostEstimateData>) =>
  queryOptions<
    CostEstimateResponse,
    CostEstimateError,
    CostEstimateResponse,
    ReturnType<typeof costEstimateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await costEstimate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: costEstimateQueryKey(options),
  })

/**
 * Retrieve the current client's cost estimate
 */
export const useCostEstimateQuery = (options?: Options<CostEstimateData>) =>
  useQuery(costEstimateOptions(options))

export const acceptCostEstimateMutationKey = (options?: Partial<Options<AcceptCostEstimateData>>) =>
  createMutationKey('acceptCostEstimate', options)

/**
 * Accept the current client's cost estimate
 */
export const acceptCostEstimateMutation = (
  options?: Partial<Options<AcceptCostEstimateData>>
): UseMutationOptions<
  AcceptCostEstimateResponse,
  AcceptCostEstimateError,
  Options<AcceptCostEstimateData>
> => {
  const mutationOptions: UseMutationOptions<
    AcceptCostEstimateResponse,
    AcceptCostEstimateError,
    Options<AcceptCostEstimateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptCostEstimate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: acceptCostEstimateMutationKey(options),
  }
  return mutationOptions
}

/**
 * Accept the current client's cost estimate
 */
export const useAcceptCostEstimateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        AcceptCostEstimateResponse,
        AcceptCostEstimateError,
        Options<AcceptCostEstimateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...acceptCostEstimateMutation(), ...mutationOptions })

export const declineCostEstimateMutationKey = (
  options?: Partial<Options<DeclineCostEstimateData>>
) => createMutationKey('declineCostEstimate', options)

/**
 * Decline the current client's cost estimate
 */
export const declineCostEstimateMutation = (
  options?: Partial<Options<DeclineCostEstimateData>>
): UseMutationOptions<
  DeclineCostEstimateResponse,
  DeclineCostEstimateError,
  Options<DeclineCostEstimateData>
> => {
  const mutationOptions: UseMutationOptions<
    DeclineCostEstimateResponse,
    DeclineCostEstimateError,
    Options<DeclineCostEstimateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await declineCostEstimate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: declineCostEstimateMutationKey(options),
  }
  return mutationOptions
}

/**
 * Decline the current client's cost estimate
 */
export const useDeclineCostEstimateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DeclineCostEstimateResponse,
        DeclineCostEstimateError,
        Options<DeclineCostEstimateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...declineCostEstimateMutation(), ...mutationOptions })

export const dashboardContractOverviewQueryKey = (
  options?: Options<DashboardContractOverviewData>
) => createQueryKey('dashboardContractOverview', options)

/**
 * get dashboard contract overview
 */
export const dashboardContractOverviewOptions = (
  options?: Options<DashboardContractOverviewData>
) =>
  queryOptions<
    DashboardContractOverviewResponse,
    DashboardContractOverviewError,
    DashboardContractOverviewResponse,
    ReturnType<typeof dashboardContractOverviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dashboardContractOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: dashboardContractOverviewQueryKey(options),
  })

/**
 * get dashboard contract overview
 */
export const useDashboardContractOverviewQuery = (
  options?: Options<DashboardContractOverviewData>
) => useQuery(dashboardContractOverviewOptions(options))

export const submitFamilyInterestMutationKey = (
  options?: Partial<Options<SubmitFamilyInterestData>>
) => createMutationKey('submitFamilyInterest', options)

/**
 * Submit a completed Family Interest Form
 */
export const submitFamilyInterestMutation = (
  options?: Partial<Options<SubmitFamilyInterestData>>
): UseMutationOptions<
  SubmitFamilyInterestResponse,
  SubmitFamilyInterestError,
  Options<SubmitFamilyInterestData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitFamilyInterestResponse,
    SubmitFamilyInterestError,
    Options<SubmitFamilyInterestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitFamilyInterest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitFamilyInterestMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit a completed Family Interest Form
 */
export const useSubmitFamilyInterestMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitFamilyInterestResponse,
        SubmitFamilyInterestError,
        Options<SubmitFamilyInterestData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitFamilyInterestMutation(), ...mutationOptions })

export const familyInterestDraftQueryKey = (options?: Options<FamilyInterestDraftData>) =>
  createQueryKey('familyInterestDraft', options)

/**
 * Fetch the current family interest draft
 */
export const familyInterestDraftOptions = (options?: Options<FamilyInterestDraftData>) =>
  queryOptions<
    FamilyInterestDraftResponse,
    FamilyInterestDraftError,
    FamilyInterestDraftResponse,
    ReturnType<typeof familyInterestDraftQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await familyInterestDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: familyInterestDraftQueryKey(options),
  })

/**
 * Fetch the current family interest draft
 */
export const useFamilyInterestDraftQuery = (options?: Options<FamilyInterestDraftData>) =>
  useQuery(familyInterestDraftOptions(options))

export const updateFamilyInterestDraftMutationKey = (
  options?: Partial<Options<UpdateFamilyInterestDraftData>>
) => createMutationKey('updateFamilyInterestDraft', options)

/**
 * Update the current family interest draft
 */
export const updateFamilyInterestDraftMutation = (
  options?: Partial<Options<UpdateFamilyInterestDraftData>>
): UseMutationOptions<
  UpdateFamilyInterestDraftResponse,
  UpdateFamilyInterestDraftError,
  Options<UpdateFamilyInterestDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateFamilyInterestDraftResponse,
    UpdateFamilyInterestDraftError,
    Options<UpdateFamilyInterestDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateFamilyInterestDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateFamilyInterestDraftMutationKey(options),
  }
  return mutationOptions
}

/**
 * Update the current family interest draft
 */
export const useUpdateFamilyInterestDraftMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateFamilyInterestDraftResponse,
        UpdateFamilyInterestDraftError,
        Options<UpdateFamilyInterestDraftData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateFamilyInterestDraftMutation(), ...mutationOptions })

export const familyInterestContextQueryKey = (options?: Options<FamilyInterestContextData>) =>
  createQueryKey('familyInterestContext', options)

/**
 * Fetch org context for the Family Interest Form landing
 */
export const familyInterestContextOptions = (options?: Options<FamilyInterestContextData>) =>
  queryOptions<
    FamilyInterestContextResponse,
    FamilyInterestContextError,
    FamilyInterestContextResponse,
    ReturnType<typeof familyInterestContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await familyInterestContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: familyInterestContextQueryKey(options),
  })

/**
 * Fetch org context for the Family Interest Form landing
 */
export const useFamilyInterestContextQuery = (options?: Options<FamilyInterestContextData>) =>
  useQuery(familyInterestContextOptions(options))

export const familyInterestInstitutionsQueryKey = (
  options?: Options<FamilyInterestInstitutionsData>
) => createQueryKey('familyInterestInstitutions', options)

/**
 * List the org's institutions + grades for the FIF student step
 */
export const familyInterestInstitutionsOptions = (
  options?: Options<FamilyInterestInstitutionsData>
) =>
  queryOptions<
    FamilyInterestInstitutionsResponse2,
    FamilyInterestInstitutionsError,
    FamilyInterestInstitutionsResponse2,
    ReturnType<typeof familyInterestInstitutionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await familyInterestInstitutions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: familyInterestInstitutionsQueryKey(options),
  })

/**
 * List the org's institutions + grades for the FIF student step
 */
export const useFamilyInterestInstitutionsQuery = (
  options?: Options<FamilyInterestInstitutionsData>
) => useQuery(familyInterestInstitutionsOptions(options))

export const familyInterestFeaturedCliniciansQueryKey = (
  options?: Options<FamilyInterestFeaturedCliniciansData>
) => createQueryKey('familyInterestFeaturedClinicians', options)

/**
 * List featured clinicians for the FIF landing preview
 *
 * Returns up to 3 admin-curated, globally featured active providers for the public FIF landing preview. Global selection (not org scoped); soft-deleted and non-provider clinicians never appear even if flagged.
 */
export const familyInterestFeaturedCliniciansOptions = (
  options?: Options<FamilyInterestFeaturedCliniciansData>
) =>
  queryOptions<
    FamilyInterestFeaturedCliniciansResponse,
    FamilyInterestFeaturedCliniciansError,
    FamilyInterestFeaturedCliniciansResponse,
    ReturnType<typeof familyInterestFeaturedCliniciansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await familyInterestFeaturedClinicians({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: familyInterestFeaturedCliniciansQueryKey(options),
  })

/**
 * List featured clinicians for the FIF landing preview
 *
 * Returns up to 3 admin-curated, globally featured active providers for the public FIF landing preview. Global selection (not org scoped); soft-deleted and non-provider clinicians never appear even if flagged.
 */
export const useFamilyInterestFeaturedCliniciansQuery = (
  options?: Options<FamilyInterestFeaturedCliniciansData>
) => useQuery(familyInterestFeaturedCliniciansOptions(options))

export const internalReferralByIdQueryKey = (options: Options<InternalReferralByIdData>) =>
  createQueryKey('internalReferralById', options)

/**
 * Retrieves an internal referral
 */
export const internalReferralByIdOptions = (options: Options<InternalReferralByIdData>) =>
  queryOptions<
    InternalReferralByIdResponse,
    InternalReferralByIdError,
    InternalReferralByIdResponse,
    ReturnType<typeof internalReferralByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalReferralById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: internalReferralByIdQueryKey(options),
  })

/**
 * Retrieves an internal referral
 */
export const useInternalReferralByIdQuery = (options: Options<InternalReferralByIdData>) =>
  useQuery(internalReferralByIdOptions(options))

export const declineInternalReferralMutationKey = (
  options?: Partial<Options<DeclineInternalReferralData>>
) => createMutationKey('declineInternalReferral', options)

/**
 * Declines specific services in an internal referral
 */
export const declineInternalReferralMutation = (
  options?: Partial<Options<DeclineInternalReferralData>>
): UseMutationOptions<
  DeclineInternalReferralResponse,
  DeclineInternalReferralError,
  Options<DeclineInternalReferralData>
> => {
  const mutationOptions: UseMutationOptions<
    DeclineInternalReferralResponse,
    DeclineInternalReferralError,
    Options<DeclineInternalReferralData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await declineInternalReferral({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: declineInternalReferralMutationKey(options),
  }
  return mutationOptions
}

/**
 * Declines specific services in an internal referral
 */
export const useDeclineInternalReferralMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DeclineInternalReferralResponse,
        DeclineInternalReferralError,
        Options<DeclineInternalReferralData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...declineInternalReferralMutation(), ...mutationOptions })

export const createJourneyAvailabilityNoteMutationKey = (
  options?: Partial<Options<CreateJourneyAvailabilityNoteData>>
) => createMutationKey('createJourneyAvailabilityNote', options)

/**
 * Submit availability notes for a journey
 */
export const createJourneyAvailabilityNoteMutation = (
  options?: Partial<Options<CreateJourneyAvailabilityNoteData>>
): UseMutationOptions<
  CreateJourneyAvailabilityNoteResponse,
  CreateJourneyAvailabilityNoteError,
  Options<CreateJourneyAvailabilityNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateJourneyAvailabilityNoteResponse,
    CreateJourneyAvailabilityNoteError,
    Options<CreateJourneyAvailabilityNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createJourneyAvailabilityNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createJourneyAvailabilityNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit availability notes for a journey
 */
export const useCreateJourneyAvailabilityNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateJourneyAvailabilityNoteResponse,
        CreateJourneyAvailabilityNoteError,
        Options<CreateJourneyAvailabilityNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createJourneyAvailabilityNoteMutation(), ...mutationOptions })

export const createJourneySchedulingDeferralMutationKey = (
  options?: Partial<Options<CreateJourneySchedulingDeferralData>>
) => createMutationKey('createJourneySchedulingDeferral', options)

/**
 * Defer scheduling for a journey
 */
export const createJourneySchedulingDeferralMutation = (
  options?: Partial<Options<CreateJourneySchedulingDeferralData>>
): UseMutationOptions<
  CreateJourneySchedulingDeferralResponse,
  CreateJourneySchedulingDeferralError,
  Options<CreateJourneySchedulingDeferralData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateJourneySchedulingDeferralResponse,
    CreateJourneySchedulingDeferralError,
    Options<CreateJourneySchedulingDeferralData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createJourneySchedulingDeferral({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createJourneySchedulingDeferralMutationKey(options),
  }
  return mutationOptions
}

/**
 * Defer scheduling for a journey
 */
export const useCreateJourneySchedulingDeferralMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateJourneySchedulingDeferralResponse,
        CreateJourneySchedulingDeferralError,
        Options<CreateJourneySchedulingDeferralData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createJourneySchedulingDeferralMutation(), ...mutationOptions })

export const journeySchedulingInfoQueryKey = (options: Options<JourneySchedulingInfoData>) =>
  createQueryKey('journeySchedulingInfo', options)

/**
 * Get scheduling info for a journey
 */
export const journeySchedulingInfoOptions = (options: Options<JourneySchedulingInfoData>) =>
  queryOptions<
    JourneySchedulingInfoResponse,
    JourneySchedulingInfoError,
    JourneySchedulingInfoResponse,
    ReturnType<typeof journeySchedulingInfoQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await journeySchedulingInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: journeySchedulingInfoQueryKey(options),
  })

/**
 * Get scheduling info for a journey
 */
export const useJourneySchedulingInfoQuery = (options: Options<JourneySchedulingInfoData>) =>
  useQuery(journeySchedulingInfoOptions(options))

export const journeySlotsQueryKey = (options: Options<JourneySlotsData>) =>
  createQueryKey('journeySlots', options)

/**
 * Get available appointment slots for a journey
 */
export const journeySlotsOptions = (options: Options<JourneySlotsData>) =>
  queryOptions<
    JourneySlotsResponse,
    JourneySlotsError,
    JourneySlotsResponse,
    ReturnType<typeof journeySlotsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await journeySlots({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: journeySlotsQueryKey(options),
  })

/**
 * Get available appointment slots for a journey
 */
export const useJourneySlotsQuery = (options: Options<JourneySlotsData>) =>
  useQuery(journeySlotsOptions(options))

export const updateJourneySlotsMutationKey = (options?: Partial<Options<UpdateJourneySlotsData>>) =>
  createMutationKey('updateJourneySlots', options)

/**
 * Book an appointment slot for a journey
 */
export const updateJourneySlotsMutation = (
  options?: Partial<Options<UpdateJourneySlotsData>>
): UseMutationOptions<
  UpdateJourneySlotsResponse,
  UpdateJourneySlotsError,
  Options<UpdateJourneySlotsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateJourneySlotsResponse,
    UpdateJourneySlotsError,
    Options<UpdateJourneySlotsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateJourneySlots({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateJourneySlotsMutationKey(options),
  }
  return mutationOptions
}

/**
 * Book an appointment slot for a journey
 */
export const useUpdateJourneySlotsMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateJourneySlotsResponse,
        UpdateJourneySlotsError,
        Options<UpdateJourneySlotsData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateJourneySlotsMutation(), ...mutationOptions })

export const kustomerProfileQueryKey = (options: Options<KustomerProfileData>) =>
  createQueryKey('kustomerProfile', options)

/**
 * get Kustomer profile URL for an external ID
 */
export const kustomerProfileOptions = (options: Options<KustomerProfileData>) =>
  queryOptions<
    KustomerProfileResponse,
    KustomerProfileError,
    KustomerProfileResponse,
    ReturnType<typeof kustomerProfileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await kustomerProfile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: kustomerProfileQueryKey(options),
  })

/**
 * get Kustomer profile URL for an external ID
 */
export const useKustomerProfileQuery = (options: Options<KustomerProfileData>) =>
  useQuery(kustomerProfileOptions(options))

export const messagesQueryKey = (options: Options<MessagesData>) =>
  createQueryKey('messages', options)

/**
 * list messages
 */
export const messagesOptions = (options: Options<MessagesData>) =>
  queryOptions<
    MessagesResponse,
    MessagesError,
    MessagesResponse,
    ReturnType<typeof messagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await messages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: messagesQueryKey(options),
  })

/**
 * list messages
 */
export const useMessagesQuery = (options: Options<MessagesData>) =>
  useQuery(messagesOptions(options))

export const createMessageMutationKey = (options?: Partial<Options<CreateMessageData>>) =>
  createMutationKey('createMessage', options)

/**
 * create message
 */
export const createMessageMutation = (
  options?: Partial<Options<CreateMessageData>>
): UseMutationOptions<CreateMessageResponse, CreateMessageError, Options<CreateMessageData>> => {
  const mutationOptions: UseMutationOptions<
    CreateMessageResponse,
    CreateMessageError,
    Options<CreateMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createMessage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createMessageMutationKey(options),
  }
  return mutationOptions
}

/**
 * create message
 */
export const useCreateMessageMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<CreateMessageResponse, CreateMessageError, Options<CreateMessageData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...createMessageMutation(), ...mutationOptions })

export const onboardingAddressQueryKey = (options: Options<OnboardingAddressData>) =>
  createQueryKey('onboardingAddress', options)

/**
 * Read the family's mailing address
 *
 * Returns the family's mailing address for prefilling the FWE v2 address screen. Fields are null when no address is on file yet.
 */
export const onboardingAddressOptions = (options: Options<OnboardingAddressData>) =>
  queryOptions<
    OnboardingAddressResponse2,
    OnboardingAddressError,
    OnboardingAddressResponse2,
    ReturnType<typeof onboardingAddressQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingAddress({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingAddressQueryKey(options),
  })

/**
 * Read the family's mailing address
 *
 * Returns the family's mailing address for prefilling the FWE v2 address screen. Fields are null when no address is on file yet.
 */
export const useOnboardingAddressQuery = (options: Options<OnboardingAddressData>) =>
  useQuery(onboardingAddressOptions(options))

export const saveOnboardingAddressMutationKey = (
  options?: Partial<Options<SaveOnboardingAddressData>>
) => createMutationKey('saveOnboardingAddress', options)

/**
 * Save the family's mailing address
 */
export const saveOnboardingAddressMutation = (
  options?: Partial<Options<SaveOnboardingAddressData>>
): UseMutationOptions<
  SaveOnboardingAddressResponse,
  SaveOnboardingAddressError,
  Options<SaveOnboardingAddressData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingAddressResponse,
    SaveOnboardingAddressError,
    Options<SaveOnboardingAddressData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingAddress({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingAddressMutationKey(options),
  }
  return mutationOptions
}

/**
 * Save the family's mailing address
 */
export const useSaveOnboardingAddressMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingAddressResponse,
        SaveOnboardingAddressError,
        Options<SaveOnboardingAddressData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingAddressMutation(), ...mutationOptions })

export const onboardingAvailabilitiesQueryKey = (options: Options<OnboardingAvailabilitiesData>) =>
  createQueryKey('onboardingAvailabilities', options)

/**
 * Returns the family's stored weekly availability and optional reason
 *
 * FWE v2 wizard waitlist step read. `windows` is the stored set of weekly availability slots for the active referral; `reason` is the optional free-text reason rehydrated from the latest `fwe_waitlist_availability_provided` ClientEvent.
 */
export const onboardingAvailabilitiesOptions = (options: Options<OnboardingAvailabilitiesData>) =>
  queryOptions<
    OnboardingAvailabilitiesResponse,
    DefaultError,
    OnboardingAvailabilitiesResponse,
    ReturnType<typeof onboardingAvailabilitiesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingAvailabilities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingAvailabilitiesQueryKey(options),
  })

/**
 * Returns the family's stored weekly availability and optional reason
 *
 * FWE v2 wizard waitlist step read. `windows` is the stored set of weekly availability slots for the active referral; `reason` is the optional free-text reason rehydrated from the latest `fwe_waitlist_availability_provided` ClientEvent.
 */
export const useOnboardingAvailabilitiesQuery = (options: Options<OnboardingAvailabilitiesData>) =>
  useQuery(onboardingAvailabilitiesOptions(options))

export const saveOnboardingAvailabilitiesMutationKey = (
  options?: Partial<Options<SaveOnboardingAvailabilitiesData>>
) => createMutationKey('saveOnboardingAvailabilities', options)

/**
 * Replaces the family's stored weekly availability
 *
 * Atomically replaces all `onboarding_availability_windows` rows for the most-recent referral and records a `fwe_waitlist_availability_provided` ClientEvent. Emits AVAILABILITIES_PROVIDED on success.
 */
export const saveOnboardingAvailabilitiesMutation = (
  options?: Partial<Options<SaveOnboardingAvailabilitiesData>>
): UseMutationOptions<
  SaveOnboardingAvailabilitiesResponse,
  SaveOnboardingAvailabilitiesError,
  Options<SaveOnboardingAvailabilitiesData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingAvailabilitiesResponse,
    SaveOnboardingAvailabilitiesError,
    Options<SaveOnboardingAvailabilitiesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingAvailabilities({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingAvailabilitiesMutationKey(options),
  }
  return mutationOptions
}

/**
 * Replaces the family's stored weekly availability
 *
 * Atomically replaces all `onboarding_availability_windows` rows for the most-recent referral and records a `fwe_waitlist_availability_provided` ClientEvent. Emits AVAILABILITIES_PROVIDED on success.
 */
export const useSaveOnboardingAvailabilitiesMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingAvailabilitiesResponse,
        SaveOnboardingAvailabilitiesError,
        Options<SaveOnboardingAvailabilitiesData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingAvailabilitiesMutation(), ...mutationOptions })

export const createOnboardingJourneyBookingMutationKey = (
  options?: Partial<Options<CreateOnboardingJourneyBookingData>>
) => createMutationKey('createOnboardingJourneyBooking', options)

/**
 * Books a chosen clinician + slot for the onboarding journey
 */
export const createOnboardingJourneyBookingMutation = (
  options?: Partial<Options<CreateOnboardingJourneyBookingData>>
): UseMutationOptions<
  CreateOnboardingJourneyBookingResponse,
  CreateOnboardingJourneyBookingError,
  Options<CreateOnboardingJourneyBookingData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateOnboardingJourneyBookingResponse,
    CreateOnboardingJourneyBookingError,
    Options<CreateOnboardingJourneyBookingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOnboardingJourneyBooking({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createOnboardingJourneyBookingMutationKey(options),
  }
  return mutationOptions
}

/**
 * Books a chosen clinician + slot for the onboarding journey
 */
export const useCreateOnboardingJourneyBookingMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateOnboardingJourneyBookingResponse,
        CreateOnboardingJourneyBookingError,
        Options<CreateOnboardingJourneyBookingData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createOnboardingJourneyBookingMutation(), ...mutationOptions })

export const onboardingCompleteQueryKey = (options: Options<OnboardingCompleteData>) =>
  createQueryKey('onboardingComplete', options)

/**
 * Booking summary for the terminal complete screen
 *
 * Final step of the FWE v2 wizard. Returns the family's booking summary (matched clinician, first session, and recurring schedule) for the "Your sessions are booked!" screen. All fields are null when the family has no booking yet.
 */
export const onboardingCompleteOptions = (options: Options<OnboardingCompleteData>) =>
  queryOptions<
    OnboardingCompleteResponse,
    OnboardingCompleteError,
    OnboardingCompleteResponse,
    ReturnType<typeof onboardingCompleteQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingComplete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingCompleteQueryKey(options),
  })

/**
 * Booking summary for the terminal complete screen
 *
 * Final step of the FWE v2 wizard. Returns the family's booking summary (matched clinician, first session, and recurring schedule) for the "Your sessions are booked!" screen. All fields are null when the family has no booking yet.
 */
export const useOnboardingCompleteQuery = (options: Options<OnboardingCompleteData>) =>
  useQuery(onboardingCompleteOptions(options))

export const recordFweCompletedMutationKey = (options?: Partial<Options<RecordFweCompletedData>>) =>
  createMutationKey('recordFweCompleted', options)

/**
 * Emit the FWE v2 FWE_COMPLETED terminal event
 *
 * Emits the FWE_COMPLETED CDP event when the family reaches the complete screen (/checkout/booked). Fired once per referral (Redis idempotency guard); mutually exclusive with SESSION_HELD_END_FLOW.
 */
export const recordFweCompletedMutation = (
  options?: Partial<Options<RecordFweCompletedData>>
): UseMutationOptions<
  RecordFweCompletedResponse,
  RecordFweCompletedError,
  Options<RecordFweCompletedData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordFweCompletedResponse,
    RecordFweCompletedError,
    Options<RecordFweCompletedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordFweCompleted({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordFweCompletedMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE v2 FWE_COMPLETED terminal event
 *
 * Emits the FWE_COMPLETED CDP event when the family reaches the complete screen (/checkout/booked). Fired once per referral (Redis idempotency guard); mutually exclusive with SESSION_HELD_END_FLOW.
 */
export const useRecordFweCompletedMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordFweCompletedResponse,
        RecordFweCompletedError,
        Options<RecordFweCompletedData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordFweCompletedMutation(), ...mutationOptions })

export const onboardingConcernsQueryKey = (options: Options<OnboardingConcernsData>) =>
  createQueryKey('onboardingConcerns', options)

/**
 * Get current concerns and the catalog of concern types
 *
 * Returns the client's existing concerns plus the full catalog of available concern types sorted by name.
 */
export const onboardingConcernsOptions = (options: Options<OnboardingConcernsData>) =>
  queryOptions<
    OnboardingConcernsResponse2,
    DefaultError,
    OnboardingConcernsResponse2,
    ReturnType<typeof onboardingConcernsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingConcerns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingConcernsQueryKey(options),
  })

/**
 * Get current concerns and the catalog of concern types
 *
 * Returns the client's existing concerns plus the full catalog of available concern types sorted by name.
 */
export const useOnboardingConcernsQuery = (options: Options<OnboardingConcernsData>) =>
  useQuery(onboardingConcernsOptions(options))

export const saveOnboardingConcernsMutationKey = (
  options?: Partial<Options<SaveOnboardingConcernsData>>
) => createMutationKey('saveOnboardingConcerns', options)

/**
 * Replace the client's concerns with the submitted set
 *
 * Upserts incoming concerns by `(client_id, concern_type_id)` and deletes any persisted rows whose concern_type is missing from the payload.
 */
export const saveOnboardingConcernsMutation = (
  options?: Partial<Options<SaveOnboardingConcernsData>>
): UseMutationOptions<
  SaveOnboardingConcernsResponse,
  SaveOnboardingConcernsError,
  Options<SaveOnboardingConcernsData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingConcernsResponse,
    SaveOnboardingConcernsError,
    Options<SaveOnboardingConcernsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingConcerns({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingConcernsMutationKey(options),
  }
  return mutationOptions
}

/**
 * Replace the client's concerns with the submitted set
 *
 * Upserts incoming concerns by `(client_id, concern_type_id)` and deletes any persisted rows whose concern_type is missing from the payload.
 */
export const useSaveOnboardingConcernsMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingConcernsResponse,
        SaveOnboardingConcernsError,
        Options<SaveOnboardingConcernsData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingConcernsMutation(), ...mutationOptions })

export const onboardingConsentsQueryKey = (options: Options<OnboardingConsentsData>) =>
  createQueryKey('onboardingConsents', options)

/**
 * List the consents the family must acknowledge
 *
 * Step 10 of the FWE v2 wizard. Returns the consent items applicable to this client (state- and role-filtered) and the current acceptance state for each. The React wizard renders titles and bodies from its own i18n bundle (legal_consent.signature_fields_form.*).
 */
export const onboardingConsentsOptions = (options: Options<OnboardingConsentsData>) =>
  queryOptions<
    OnboardingConsentsResponse,
    OnboardingConsentsError,
    OnboardingConsentsResponse,
    ReturnType<typeof onboardingConsentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingConsents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingConsentsQueryKey(options),
  })

/**
 * List the consents the family must acknowledge
 *
 * Step 10 of the FWE v2 wizard. Returns the consent items applicable to this client (state- and role-filtered) and the current acceptance state for each. The React wizard renders titles and bodies from its own i18n bundle (legal_consent.signature_fields_form.*).
 */
export const useOnboardingConsentsQuery = (options: Options<OnboardingConsentsData>) =>
  useQuery(onboardingConsentsOptions(options))

export const saveOnboardingConsentsMutationKey = (
  options?: Partial<Options<SaveOnboardingConsentsData>>
) => createMutationKey('saveOnboardingConsents', options)

/**
 * Submit family consent acknowledgements
 *
 * Step 10 of the FWE v2 wizard. Persists the family's signature, ROI consents, third-party scribe consent, and (for staff or Brookline-eligible clients) the corresponding attestations via the existing ClientConsentForm + LegalSignatureCreator flow. Fires ConsentsSignedPublisher (the Phase 3 milestone trigger). Idempotent: a re-submit within the legal consent's one-year validity window returns the existing signature without re-firing the publisher.
 */
export const saveOnboardingConsentsMutation = (
  options?: Partial<Options<SaveOnboardingConsentsData>>
): UseMutationOptions<
  SaveOnboardingConsentsResponse,
  SaveOnboardingConsentsError,
  Options<SaveOnboardingConsentsData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingConsentsResponse,
    SaveOnboardingConsentsError,
    Options<SaveOnboardingConsentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingConsents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingConsentsMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit family consent acknowledgements
 *
 * Step 10 of the FWE v2 wizard. Persists the family's signature, ROI consents, third-party scribe consent, and (for staff or Brookline-eligible clients) the corresponding attestations via the existing ClientConsentForm + LegalSignatureCreator flow. Fires ConsentsSignedPublisher (the Phase 3 milestone trigger). Idempotent: a re-submit within the legal consent's one-year validity window returns the existing signature without re-firing the publisher.
 */
export const useSaveOnboardingConsentsMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingConsentsResponse,
        SaveOnboardingConsentsError,
        Options<SaveOnboardingConsentsData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingConsentsMutation(), ...mutationOptions })

export const onboardingContextQueryKey = (options: Options<OnboardingContextData>) =>
  createQueryKey('onboardingContext', options)

/**
 * Get wizard navigation context
 *
 * Returns the React wizard's canonical navigation context: where the family stands (current step number / total steps / current step URL) plus `steps`, the family's whole flow in order with skipped screens marked. BE owns step ordering and skip rules; the FE navigates off `steps`.
 */
export const onboardingContextOptions = (options: Options<OnboardingContextData>) =>
  queryOptions<
    OnboardingContextResponse2,
    OnboardingContextError,
    OnboardingContextResponse2,
    ReturnType<typeof onboardingContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingContextQueryKey(options),
  })

/**
 * Get wizard navigation context
 *
 * Returns the React wizard's canonical navigation context: where the family stands (current step number / total steps / current step URL) plus `steps`, the family's whole flow in order with skipped screens marked. BE owns step ordering and skip rules; the FE navigates off `steps`.
 */
export const useOnboardingContextQuery = (options: Options<OnboardingContextData>) =>
  useQuery(onboardingContextOptions(options))

export const onboardingCostEstimateQueryKey = (options: Options<OnboardingCostEstimateData>) =>
  createQueryKey('onboardingCostEstimate', options)

/**
 * Read the cost estimate the family must confirm
 *
 * Step 8 of the FWE v2 wizard. Returns the cost estimate shape consumed by the React wizard (same hash as ClientCostEstimateDecorator#to_h) plus a top-level `status` discriminator: 'ready' when an estimate is persisted, 'unavailable' when eligibility failed (wizard routes past Step 8 to staff confirmation), 'pending' otherwise.
 */
export const onboardingCostEstimateOptions = (options: Options<OnboardingCostEstimateData>) =>
  queryOptions<
    OnboardingCostEstimateResponse2,
    OnboardingCostEstimateError,
    OnboardingCostEstimateResponse2,
    ReturnType<typeof onboardingCostEstimateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingCostEstimate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingCostEstimateQueryKey(options),
  })

/**
 * Read the cost estimate the family must confirm
 *
 * Step 8 of the FWE v2 wizard. Returns the cost estimate shape consumed by the React wizard (same hash as ClientCostEstimateDecorator#to_h) plus a top-level `status` discriminator: 'ready' when an estimate is persisted, 'unavailable' when eligibility failed (wizard routes past Step 8 to staff confirmation), 'pending' otherwise.
 */
export const useOnboardingCostEstimateQuery = (options: Options<OnboardingCostEstimateData>) =>
  useQuery(onboardingCostEstimateOptions(options))

export const acceptOnboardingCostEstimateMutationKey = (
  options?: Partial<Options<AcceptOnboardingCostEstimateData>>
) => createMutationKey('acceptOnboardingCostEstimate', options)

/**
 * Confirm the cost estimate
 *
 * Step 8 of the FWE v2 wizard. Persists cost + auto-pay consent signatures via the existing CostEstimateConfirmer flow and fires CostConfirmedPublisher. Idempotent: a re-submit returns the original confirmation timestamp without creating duplicate signatures or re-firing the publisher.
 */
export const acceptOnboardingCostEstimateMutation = (
  options?: Partial<Options<AcceptOnboardingCostEstimateData>>
): UseMutationOptions<
  AcceptOnboardingCostEstimateResponse,
  AcceptOnboardingCostEstimateError,
  Options<AcceptOnboardingCostEstimateData>
> => {
  const mutationOptions: UseMutationOptions<
    AcceptOnboardingCostEstimateResponse,
    AcceptOnboardingCostEstimateError,
    Options<AcceptOnboardingCostEstimateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptOnboardingCostEstimate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: acceptOnboardingCostEstimateMutationKey(options),
  }
  return mutationOptions
}

/**
 * Confirm the cost estimate
 *
 * Step 8 of the FWE v2 wizard. Persists cost + auto-pay consent signatures via the existing CostEstimateConfirmer flow and fires CostConfirmedPublisher. Idempotent: a re-submit returns the original confirmation timestamp without creating duplicate signatures or re-firing the publisher.
 */
export const useAcceptOnboardingCostEstimateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        AcceptOnboardingCostEstimateResponse,
        AcceptOnboardingCostEstimateError,
        Options<AcceptOnboardingCostEstimateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...acceptOnboardingCostEstimateMutation(), ...mutationOptions })

export const onboardingEligibilityStatusQueryKey = (
  options: Options<OnboardingEligibilityStatusData>
) => createQueryKey('onboardingEligibilityStatus', options)

/**
 * Poll the Apero eligibility outcome
 *
 * React polls every 5-10s after submitting insurance. Reads from a Redis-cached snapshot updated by Onboarding::EligibilityCheckJob — no DB hit per poll. Returns 'pending' before Apero responds, 'confirmed' on eligible result, and 'failed' on Apero error or ineligible result.
 */
export const onboardingEligibilityStatusOptions = (
  options: Options<OnboardingEligibilityStatusData>
) =>
  queryOptions<
    OnboardingEligibilityStatusResponse,
    OnboardingEligibilityStatusError,
    OnboardingEligibilityStatusResponse,
    ReturnType<typeof onboardingEligibilityStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingEligibilityStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingEligibilityStatusQueryKey(options),
  })

/**
 * Poll the Apero eligibility outcome
 *
 * React polls every 5-10s after submitting insurance. Reads from a Redis-cached snapshot updated by Onboarding::EligibilityCheckJob — no DB hit per poll. Returns 'pending' before Apero responds, 'confirmed' on eligible result, and 'failed' on Apero error or ineligible result.
 */
export const useOnboardingEligibilityStatusQuery = (
  options: Options<OnboardingEligibilityStatusData>
) => useQuery(onboardingEligibilityStatusOptions(options))

export const onboardingFeaturedCliniciansQueryKey = (
  options: Options<OnboardingFeaturedCliniciansData>
) => createQueryKey('onboardingFeaturedClinicians', options)

/**
 * List featured clinicians for the welcome screen
 *
 * Returns up to 3 admin-curated "featured" active providers for the public FWE v2 welcome screen. Global selection (not state/org scoped); soft-deleted and non-provider clinicians never appear even if flagged.
 */
export const onboardingFeaturedCliniciansOptions = (
  options: Options<OnboardingFeaturedCliniciansData>
) =>
  queryOptions<
    OnboardingFeaturedCliniciansResponse2,
    OnboardingFeaturedCliniciansError,
    OnboardingFeaturedCliniciansResponse2,
    ReturnType<typeof onboardingFeaturedCliniciansQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingFeaturedClinicians({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingFeaturedCliniciansQueryKey(options),
  })

/**
 * List featured clinicians for the welcome screen
 *
 * Returns up to 3 admin-curated "featured" active providers for the public FWE v2 welcome screen. Global selection (not state/org scoped); soft-deleted and non-provider clinicians never appear even if flagged.
 */
export const useOnboardingFeaturedCliniciansQuery = (
  options: Options<OnboardingFeaturedCliniciansData>
) => useQuery(onboardingFeaturedCliniciansOptions(options))

export const acknowledgeFinancialAidApprovalMutationKey = (
  options?: Partial<Options<AcknowledgeFinancialAidApprovalData>>
) => createMutationKey('acknowledgeFinancialAidApproval', options)

/**
 * Acknowledge the FWE v2 financial-aid-approved re-entry screen
 *
 * Records the durable FINANCIAL_AID_APPROVAL_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial. Idempotent per referral.
 */
export const acknowledgeFinancialAidApprovalMutation = (
  options?: Partial<Options<AcknowledgeFinancialAidApprovalData>>
): UseMutationOptions<
  AcknowledgeFinancialAidApprovalResponse,
  AcknowledgeFinancialAidApprovalError,
  Options<AcknowledgeFinancialAidApprovalData>
> => {
  const mutationOptions: UseMutationOptions<
    AcknowledgeFinancialAidApprovalResponse,
    AcknowledgeFinancialAidApprovalError,
    Options<AcknowledgeFinancialAidApprovalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acknowledgeFinancialAidApproval({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: acknowledgeFinancialAidApprovalMutationKey(options),
  }
  return mutationOptions
}

/**
 * Acknowledge the FWE v2 financial-aid-approved re-entry screen
 *
 * Records the durable FINANCIAL_AID_APPROVAL_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial. Idempotent per referral.
 */
export const useAcknowledgeFinancialAidApprovalMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        AcknowledgeFinancialAidApprovalResponse,
        AcknowledgeFinancialAidApprovalError,
        Options<AcknowledgeFinancialAidApprovalData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...acknowledgeFinancialAidApprovalMutation(), ...mutationOptions })

export const requestFinancialAidMutationKey = (
  options?: Partial<Options<RequestFinancialAidData>>
) => createMutationKey('requestFinancialAid', options)

/**
 * Record the family's FWE v2 insurance-fallback financial aid request
 *
 * Persists the family's financial aid request: stamps the matching financial-need marker on the active referral — UNINSURED (reason: uninsured) or UNDERINSURED (reason: copay_difficult), idempotent per reason — writes an FWE_FINANCIAL_AID_REQUESTED ClientEvent carrying the reason, and emits the FINANCIAL_AID_REQUESTED CDP event for Iterable lifecycle handoff. Approval continues to flow staff-side via FinancialAidProcessor.
 */
export const requestFinancialAidMutation = (
  options?: Partial<Options<RequestFinancialAidData>>
): UseMutationOptions<
  RequestFinancialAidResponse,
  RequestFinancialAidError,
  Options<RequestFinancialAidData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestFinancialAidResponse,
    RequestFinancialAidError,
    Options<RequestFinancialAidData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestFinancialAid({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: requestFinancialAidMutationKey(options),
  }
  return mutationOptions
}

/**
 * Record the family's FWE v2 insurance-fallback financial aid request
 *
 * Persists the family's financial aid request: stamps the matching financial-need marker on the active referral — UNINSURED (reason: uninsured) or UNDERINSURED (reason: copay_difficult), idempotent per reason — writes an FWE_FINANCIAL_AID_REQUESTED ClientEvent carrying the reason, and emits the FINANCIAL_AID_REQUESTED CDP event for Iterable lifecycle handoff. Approval continues to flow staff-side via FinancialAidProcessor.
 */
export const useRequestFinancialAidMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RequestFinancialAidResponse,
        RequestFinancialAidError,
        Options<RequestFinancialAidData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...requestFinancialAidMutation(), ...mutationOptions })

export const onboardingIdentityPreferencesQueryKey = (
  options: Options<OnboardingIdentityPreferencesData>
) => createQueryKey('onboardingIdentityPreferences', options)

/**
 * Return identity + language preference options for the FWE v2 wizard
 *
 * Returns all `Identity` rows grouped by category along with supported language codes, and the client's current selections on their active referral.
 */
export const onboardingIdentityPreferencesOptions = (
  options: Options<OnboardingIdentityPreferencesData>
) =>
  queryOptions<
    OnboardingIdentityPreferencesResponse,
    DefaultError,
    OnboardingIdentityPreferencesResponse,
    ReturnType<typeof onboardingIdentityPreferencesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingIdentityPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingIdentityPreferencesQueryKey(options),
  })

/**
 * Return identity + language preference options for the FWE v2 wizard
 *
 * Returns all `Identity` rows grouped by category along with supported language codes, and the client's current selections on their active referral.
 */
export const useOnboardingIdentityPreferencesQuery = (
  options: Options<OnboardingIdentityPreferencesData>
) => useQuery(onboardingIdentityPreferencesOptions(options))

export const saveOnboardingIdentityPreferencesMutationKey = (
  options?: Partial<Options<SaveOnboardingIdentityPreferencesData>>
) => createMutationKey('saveOnboardingIdentityPreferences', options)

/**
 * Replace identity preferences, and language preferences when supplied
 */
export const saveOnboardingIdentityPreferencesMutation = (
  options?: Partial<Options<SaveOnboardingIdentityPreferencesData>>
): UseMutationOptions<
  SaveOnboardingIdentityPreferencesResponse,
  SaveOnboardingIdentityPreferencesError,
  Options<SaveOnboardingIdentityPreferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingIdentityPreferencesResponse,
    SaveOnboardingIdentityPreferencesError,
    Options<SaveOnboardingIdentityPreferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingIdentityPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingIdentityPreferencesMutationKey(options),
  }
  return mutationOptions
}

/**
 * Replace identity preferences, and language preferences when supplied
 */
export const useSaveOnboardingIdentityPreferencesMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingIdentityPreferencesResponse,
        SaveOnboardingIdentityPreferencesError,
        Options<SaveOnboardingIdentityPreferencesData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingIdentityPreferencesMutation(), ...mutationOptions })

export const recordCarrierLookupViewMutationKey = (
  options?: Partial<Options<RecordCarrierLookupViewData>>
) => createMutationKey('recordCarrierLookupView', options)

/**
 * Emit the FWE_CARRIER_LOOKUP_VIEWED funnel event
 *
 * Emits the FWE_CARRIER_LOOKUP_VIEWED CDP event when the family reaches the "let's find your insurance" carrier picker. Fired once per referral (Redis idempotency guard), so repeat views and Back navigation don't double-count.
 */
export const recordCarrierLookupViewMutation = (
  options?: Partial<Options<RecordCarrierLookupViewData>>
): UseMutationOptions<
  RecordCarrierLookupViewResponse,
  RecordCarrierLookupViewError,
  Options<RecordCarrierLookupViewData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordCarrierLookupViewResponse,
    RecordCarrierLookupViewError,
    Options<RecordCarrierLookupViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordCarrierLookupView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordCarrierLookupViewMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE_CARRIER_LOOKUP_VIEWED funnel event
 *
 * Emits the FWE_CARRIER_LOOKUP_VIEWED CDP event when the family reaches the "let's find your insurance" carrier picker. Fired once per referral (Redis idempotency guard), so repeat views and Back navigation don't double-count.
 */
export const useRecordCarrierLookupViewMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordCarrierLookupViewResponse,
        RecordCarrierLookupViewError,
        Options<RecordCarrierLookupViewData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordCarrierLookupViewMutation(), ...mutationOptions })

export const recordCostConcernsSelectionMutationKey = (
  options?: Partial<Options<RecordCostConcernsSelectionData>>
) => createMutationKey('recordCostConcernsSelection', options)

/**
 * Emit the FWE_COST_CONCERNS_SELECTED funnel event
 *
 * Emits the FWE_COST_CONCERNS_SELECTED CDP event when the family taps "I have concerns about the cost" on a cost-estimate screen and diverts to financial aid. The link is hidden for $0 estimates, so measure its rate against families who could see it. Fired once per referral (Redis idempotency guard).
 */
export const recordCostConcernsSelectionMutation = (
  options?: Partial<Options<RecordCostConcernsSelectionData>>
): UseMutationOptions<
  RecordCostConcernsSelectionResponse,
  RecordCostConcernsSelectionError,
  Options<RecordCostConcernsSelectionData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordCostConcernsSelectionResponse,
    RecordCostConcernsSelectionError,
    Options<RecordCostConcernsSelectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordCostConcernsSelection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordCostConcernsSelectionMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE_COST_CONCERNS_SELECTED funnel event
 *
 * Emits the FWE_COST_CONCERNS_SELECTED CDP event when the family taps "I have concerns about the cost" on a cost-estimate screen and diverts to financial aid. The link is hidden for $0 estimates, so measure its rate against families who could see it. Fired once per referral (Redis idempotency guard).
 */
export const useRecordCostConcernsSelectionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordCostConcernsSelectionResponse,
        RecordCostConcernsSelectionError,
        Options<RecordCostConcernsSelectionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordCostConcernsSelectionMutation(), ...mutationOptions })

export const recordCostEstimateViewMutationKey = (
  options?: Partial<Options<RecordCostEstimateViewData>>
) => createMutationKey('recordCostEstimateView', options)

/**
 * Emit the FWE_COST_ESTIMATE_VIEWED funnel event
 *
 * Emits the FWE_COST_ESTIMATE_VIEWED CDP event when the family is shown a rendered cost estimate (verified, dual-verified, or self-pay screen), carrying the family's coverage type. Fired once per referral (Redis idempotency guard).
 */
export const recordCostEstimateViewMutation = (
  options?: Partial<Options<RecordCostEstimateViewData>>
): UseMutationOptions<
  RecordCostEstimateViewResponse,
  RecordCostEstimateViewError,
  Options<RecordCostEstimateViewData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordCostEstimateViewResponse,
    RecordCostEstimateViewError,
    Options<RecordCostEstimateViewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordCostEstimateView({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordCostEstimateViewMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE_COST_ESTIMATE_VIEWED funnel event
 *
 * Emits the FWE_COST_ESTIMATE_VIEWED CDP event when the family is shown a rendered cost estimate (verified, dual-verified, or self-pay screen), carrying the family's coverage type. Fired once per referral (Redis idempotency guard).
 */
export const useRecordCostEstimateViewMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordCostEstimateViewResponse,
        RecordCostEstimateViewError,
        Options<RecordCostEstimateViewData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordCostEstimateViewMutation(), ...mutationOptions })

export const recordNoInsuranceSelectionMutationKey = (
  options?: Partial<Options<RecordNoInsuranceSelectionData>>
) => createMutationKey('recordNoInsuranceSelection', options)

/**
 * Emit the FWE_NO_INSURANCE_SELECTED funnel event
 *
 * Emits the FWE_NO_INSURANCE_SELECTED CDP event when the family declares they have no insurance on the carrier picker (dropdown row or link). Distinct from INSURANCE_NOT_VERIFIED, which means coverage was claimed but failed verification. Fired once per referral (Redis idempotency guard).
 */
export const recordNoInsuranceSelectionMutation = (
  options?: Partial<Options<RecordNoInsuranceSelectionData>>
): UseMutationOptions<
  RecordNoInsuranceSelectionResponse,
  RecordNoInsuranceSelectionError,
  Options<RecordNoInsuranceSelectionData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordNoInsuranceSelectionResponse,
    RecordNoInsuranceSelectionError,
    Options<RecordNoInsuranceSelectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordNoInsuranceSelection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordNoInsuranceSelectionMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE_NO_INSURANCE_SELECTED funnel event
 *
 * Emits the FWE_NO_INSURANCE_SELECTED CDP event when the family declares they have no insurance on the carrier picker (dropdown row or link). Distinct from INSURANCE_NOT_VERIFIED, which means coverage was claimed but failed verification. Fired once per referral (Redis idempotency guard).
 */
export const useRecordNoInsuranceSelectionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordNoInsuranceSelectionResponse,
        RecordNoInsuranceSelectionError,
        Options<RecordNoInsuranceSelectionData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordNoInsuranceSelectionMutation(), ...mutationOptions })

export const recordInsuranceNotVerifiedMutationKey = (
  options?: Partial<Options<RecordInsuranceNotVerifiedData>>
) => createMutationKey('recordInsuranceNotVerified', options)

/**
 * Emit the INSURANCE_NOT_VERIFIED funnel event
 *
 * Emits the INSURANCE_NOT_VERIFIED CDP event when the family reaches the 'we couldn't verify your insurance' screen after every RTE fallback failed. Fired once per referral (Redis idempotency guard).
 */
export const recordInsuranceNotVerifiedMutation = (
  options?: Partial<Options<RecordInsuranceNotVerifiedData>>
): UseMutationOptions<
  RecordInsuranceNotVerifiedResponse,
  RecordInsuranceNotVerifiedError,
  Options<RecordInsuranceNotVerifiedData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordInsuranceNotVerifiedResponse,
    RecordInsuranceNotVerifiedError,
    Options<RecordInsuranceNotVerifiedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordInsuranceNotVerified({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordInsuranceNotVerifiedMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the INSURANCE_NOT_VERIFIED funnel event
 *
 * Emits the INSURANCE_NOT_VERIFIED CDP event when the family reaches the 'we couldn't verify your insurance' screen after every RTE fallback failed. Fired once per referral (Redis idempotency guard).
 */
export const useRecordInsuranceNotVerifiedMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordInsuranceNotVerifiedResponse,
        RecordInsuranceNotVerifiedError,
        Options<RecordInsuranceNotVerifiedData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordInsuranceNotVerifiedMutation(), ...mutationOptions })

export const submitInsuranceZipCodeLookupMutationKey = (
  options?: Partial<Options<SubmitInsuranceZipCodeLookupData>>
) => createMutationKey('submitInsuranceZipCodeLookup', options)

/**
 * Step 1 of the RTE cascade: cardless Nirvana discover eligibility check
 *
 * FWE v2 wizard step 5. Accepts a 5-digit ZIP code and verifiable payer ID, runs the cardless Nirvana discover flow synchronously, and writes the result to the eligibility cache. Returns 202 + poll_url regardless of the discover outcome — the React wizard polls /eligibility-status to determine next step.
 */
export const submitInsuranceZipCodeLookupMutation = (
  options?: Partial<Options<SubmitInsuranceZipCodeLookupData>>
): UseMutationOptions<
  SubmitInsuranceZipCodeLookupResponse,
  SubmitInsuranceZipCodeLookupError,
  Options<SubmitInsuranceZipCodeLookupData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitInsuranceZipCodeLookupResponse,
    SubmitInsuranceZipCodeLookupError,
    Options<SubmitInsuranceZipCodeLookupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitInsuranceZipCodeLookup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitInsuranceZipCodeLookupMutationKey(options),
  }
  return mutationOptions
}

/**
 * Step 1 of the RTE cascade: cardless Nirvana discover eligibility check
 *
 * FWE v2 wizard step 5. Accepts a 5-digit ZIP code and verifiable payer ID, runs the cardless Nirvana discover flow synchronously, and writes the result to the eligibility cache. Returns 202 + poll_url regardless of the discover outcome — the React wizard polls /eligibility-status to determine next step.
 */
export const useSubmitInsuranceZipCodeLookupMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitInsuranceZipCodeLookupResponse,
        SubmitInsuranceZipCodeLookupError,
        Options<SubmitInsuranceZipCodeLookupData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitInsuranceZipCodeLookupMutation(), ...mutationOptions })

export const createOnboardingInsuranceScanMutationKey = (
  options?: Partial<Options<CreateOnboardingInsuranceScanData>>
) => createMutationKey('createOnboardingInsuranceScan', options)

/**
 * Scan an insurance card via OCR
 *
 * FWE v2 wrapper around the existing InsuranceCardScanner. Attaches the supplied ActiveStorage blob(s) to the client, enqueues the Apero upload job, and returns the OCR'd insurance details for the React wizard to pre-fill the manual entry form.
 */
export const createOnboardingInsuranceScanMutation = (
  options?: Partial<Options<CreateOnboardingInsuranceScanData>>
): UseMutationOptions<
  CreateOnboardingInsuranceScanResponse,
  CreateOnboardingInsuranceScanError,
  Options<CreateOnboardingInsuranceScanData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateOnboardingInsuranceScanResponse,
    CreateOnboardingInsuranceScanError,
    Options<CreateOnboardingInsuranceScanData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOnboardingInsuranceScan({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createOnboardingInsuranceScanMutationKey(options),
  }
  return mutationOptions
}

/**
 * Scan an insurance card via OCR
 *
 * FWE v2 wrapper around the existing InsuranceCardScanner. Attaches the supplied ActiveStorage blob(s) to the client, enqueues the Apero upload job, and returns the OCR'd insurance details for the React wizard to pre-fill the manual entry form.
 */
export const useCreateOnboardingInsuranceScanMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateOnboardingInsuranceScanResponse,
        CreateOnboardingInsuranceScanError,
        Options<CreateOnboardingInsuranceScanData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createOnboardingInsuranceScanMutation(), ...mutationOptions })

export const submitOnboardingInsuranceSelfReportMutationKey = (
  options?: Partial<Options<SubmitOnboardingInsuranceSelfReportData>>
) => createMutationKey('submitOnboardingInsuranceSelfReport', options)

/**
 * Record the family's Allentown auto-pro-bono insurance self-report
 *
 * Records what a family self-reports on the Allentown auto-pro-bono insurance self-report screen (RCM-2313): medicaid proceeds through the real, unmodified insurance verification cascade; commercial/uninsured auto-approves a pro-bono spot with family comms suppressed (RCM-2314) and fires the INSURANCE_SELECTION analytics event. Only enabled for districts with auto_pro_bono set.
 */
export const submitOnboardingInsuranceSelfReportMutation = (
  options?: Partial<Options<SubmitOnboardingInsuranceSelfReportData>>
): UseMutationOptions<
  SubmitOnboardingInsuranceSelfReportResponse,
  SubmitOnboardingInsuranceSelfReportError,
  Options<SubmitOnboardingInsuranceSelfReportData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitOnboardingInsuranceSelfReportResponse,
    SubmitOnboardingInsuranceSelfReportError,
    Options<SubmitOnboardingInsuranceSelfReportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitOnboardingInsuranceSelfReport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitOnboardingInsuranceSelfReportMutationKey(options),
  }
  return mutationOptions
}

/**
 * Record the family's Allentown auto-pro-bono insurance self-report
 *
 * Records what a family self-reports on the Allentown auto-pro-bono insurance self-report screen (RCM-2313): medicaid proceeds through the real, unmodified insurance verification cascade; commercial/uninsured auto-approves a pro-bono spot with family comms suppressed (RCM-2314) and fires the INSURANCE_SELECTION analytics event. Only enabled for districts with auto_pro_bono set.
 */
export const useSubmitOnboardingInsuranceSelfReportMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitOnboardingInsuranceSelfReportResponse,
        SubmitOnboardingInsuranceSelfReportError,
        Options<SubmitOnboardingInsuranceSelfReportData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitOnboardingInsuranceSelfReportMutation(), ...mutationOptions })

export const submitOnboardingInsuranceMutationKey = (
  options?: Partial<Options<SubmitOnboardingInsuranceData>>
) => createMutationKey('submitOnboardingInsurance', options)

/**
 * Submit insurance and trigger an Apero eligibility check
 *
 * Step 5 of the FWE v2 wizard. Persists insurance details via the existing ClientInsuranceForm pathway and enqueues an Apero eligibility check. Returns 202 with a poll_url; the React wizard polls the eligibility-status endpoint for the outcome (both confirmed and failed outcomes advance the workflow).
 */
export const submitOnboardingInsuranceMutation = (
  options?: Partial<Options<SubmitOnboardingInsuranceData>>
): UseMutationOptions<
  SubmitOnboardingInsuranceResponse,
  SubmitOnboardingInsuranceError,
  Options<SubmitOnboardingInsuranceData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitOnboardingInsuranceResponse,
    SubmitOnboardingInsuranceError,
    Options<SubmitOnboardingInsuranceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitOnboardingInsurance({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitOnboardingInsuranceMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit insurance and trigger an Apero eligibility check
 *
 * Step 5 of the FWE v2 wizard. Persists insurance details via the existing ClientInsuranceForm pathway and enqueues an Apero eligibility check. Returns 202 with a poll_url; the React wizard polls the eligibility-status endpoint for the outcome (both confirmed and failed outcomes advance the workflow).
 */
export const useSubmitOnboardingInsuranceMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitOnboardingInsuranceResponse,
        SubmitOnboardingInsuranceError,
        Options<SubmitOnboardingInsuranceData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitOnboardingInsuranceMutation(), ...mutationOptions })

export const onboardingJointConsentsQueryKey = (options: Options<OnboardingJointConsentsData>) =>
  createQueryKey('onboardingJointConsents', options)

/**
 * Fetch the family's joint-custody declaration and secondary guardian info
 *
 * FWE v2 joint-consent wizard step. Returns the current declaration (`joint_custody`, `consent_authority`), the previously-captured secondary guardian (or null), and a `status` summarizing whether the workflow is required, awaiting input, in flight, or resolved. The React wizard uses `status` to decide whether to render the form, the 'session held' state, or skip the step entirely.
 */
export const onboardingJointConsentsOptions = (options: Options<OnboardingJointConsentsData>) =>
  queryOptions<
    OnboardingJointConsentsResponse,
    OnboardingJointConsentsError,
    OnboardingJointConsentsResponse,
    ReturnType<typeof onboardingJointConsentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingJointConsents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingJointConsentsQueryKey(options),
  })

/**
 * Fetch the family's joint-custody declaration and secondary guardian info
 *
 * FWE v2 joint-consent wizard step. Returns the current declaration (`joint_custody`, `consent_authority`), the previously-captured secondary guardian (or null), and a `status` summarizing whether the workflow is required, awaiting input, in flight, or resolved. The React wizard uses `status` to decide whether to render the form, the 'session held' state, or skip the step entirely.
 */
export const useOnboardingJointConsentsQuery = (options: Options<OnboardingJointConsentsData>) =>
  useQuery(onboardingJointConsentsOptions(options))

export const saveOnboardingJointConsentsMutationKey = (
  options?: Partial<Options<SaveOnboardingJointConsentsData>>
) => createMutationKey('saveOnboardingJointConsents', options)

/**
 * Submit the family's joint-custody declaration
 *
 * FWE v2 joint-consent wizard step. Persists the family's declaration into `referrals.custody_type` and `referrals.consent_authority`. When consent_authority is 'joint', upserts the secondary guardian as a ReferralContact, sets the JOINT_CUSTODY marker, completes any open `add_second_guardian_information` task so the running JointConsentWorkflow advances, and starts the workflow when `SecondaryGuardianConsentRequester#required?`. When consent_authority is 'sole' the primary guardian attests unilateral authority — marker and Guardian 2 upsert are skipped, so the workflow naturally does not start. Idempotent: re-POSTing the same payload updates Guardian 2 in place and avoids duplicate marker / ReferralContact / workflow start rows.
 */
export const saveOnboardingJointConsentsMutation = (
  options?: Partial<Options<SaveOnboardingJointConsentsData>>
): UseMutationOptions<
  SaveOnboardingJointConsentsResponse,
  SaveOnboardingJointConsentsError,
  Options<SaveOnboardingJointConsentsData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingJointConsentsResponse,
    SaveOnboardingJointConsentsError,
    Options<SaveOnboardingJointConsentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingJointConsents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingJointConsentsMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit the family's joint-custody declaration
 *
 * FWE v2 joint-consent wizard step. Persists the family's declaration into `referrals.custody_type` and `referrals.consent_authority`. When consent_authority is 'joint', upserts the secondary guardian as a ReferralContact, sets the JOINT_CUSTODY marker, completes any open `add_second_guardian_information` task so the running JointConsentWorkflow advances, and starts the workflow when `SecondaryGuardianConsentRequester#required?`. When consent_authority is 'sole' the primary guardian attests unilateral authority — marker and Guardian 2 upsert are skipped, so the workflow naturally does not start. Idempotent: re-POSTing the same payload updates Guardian 2 in place and avoids duplicate marker / ReferralContact / workflow start rows.
 */
export const useSaveOnboardingJointConsentsMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingJointConsentsResponse,
        SaveOnboardingJointConsentsError,
        Options<SaveOnboardingJointConsentsData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingJointConsentsMutation(), ...mutationOptions })

export const createOnboardingMatchingJourneyMutationKey = (
  options?: Partial<Options<CreateOnboardingMatchingJourneyData>>
) => createMutationKey('createOnboardingMatchingJourney', options)

/**
 * Materializes the matching journey for the family's selected service lines
 *
 * Creates a Journey per tentatively-selected service line (idempotent) and returns the journey id the matching step should render matches for. Backs the FWE v2 'Finding the right fit' loading interstitial (RCM-1914).
 */
export const createOnboardingMatchingJourneyMutation = (
  options?: Partial<Options<CreateOnboardingMatchingJourneyData>>
): UseMutationOptions<
  CreateOnboardingMatchingJourneyResponse,
  CreateOnboardingMatchingJourneyError,
  Options<CreateOnboardingMatchingJourneyData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateOnboardingMatchingJourneyResponse,
    CreateOnboardingMatchingJourneyError,
    Options<CreateOnboardingMatchingJourneyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOnboardingMatchingJourney({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createOnboardingMatchingJourneyMutationKey(options),
  }
  return mutationOptions
}

/**
 * Materializes the matching journey for the family's selected service lines
 *
 * Creates a Journey per tentatively-selected service line (idempotent) and returns the journey id the matching step should render matches for. Backs the FWE v2 'Finding the right fit' loading interstitial (RCM-1914).
 */
export const useCreateOnboardingMatchingJourneyMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateOnboardingMatchingJourneyResponse,
        CreateOnboardingMatchingJourneyError,
        Options<CreateOnboardingMatchingJourneyData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createOnboardingMatchingJourneyMutation(), ...mutationOptions })

export const onboardingMatchQueryKey = (options: Options<OnboardingMatchData>) =>
  createQueryKey('onboardingMatch', options)

/**
 * Match summary for the "We found a match" re-entry screen
 *
 * Waitlist re-entry. Returns the matched clinician's profile and the held first session + recurring schedule for the "We found a match" screen after a coordinator booked a waitlisted family. Booking values are derived from the journey's appointments (these families have no RequestedAppointmentSchedule). All fields are null when no booking exists yet.
 */
export const onboardingMatchOptions = (options: Options<OnboardingMatchData>) =>
  queryOptions<
    OnboardingMatchResponse,
    OnboardingMatchError,
    OnboardingMatchResponse,
    ReturnType<typeof onboardingMatchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingMatch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingMatchQueryKey(options),
  })

/**
 * Match summary for the "We found a match" re-entry screen
 *
 * Waitlist re-entry. Returns the matched clinician's profile and the held first session + recurring schedule for the "We found a match" screen after a coordinator booked a waitlisted family. Booking values are derived from the journey's appointments (these families have no RequestedAppointmentSchedule). All fields are null when no booking exists yet.
 */
export const useOnboardingMatchQuery = (options: Options<OnboardingMatchData>) =>
  useQuery(onboardingMatchOptions(options))

export const onboardingMeetingPreferenceQueryKey = (
  options: Options<OnboardingMeetingPreferenceData>
) => createQueryKey('onboardingMeetingPreference', options)

/**
 * Return the family's meeting-location preference for the active referral
 *
 * Returns the family's current meeting-location preference (`during_school` / `outside_school` / `both`), or null if not yet chosen.
 */
export const onboardingMeetingPreferenceOptions = (
  options: Options<OnboardingMeetingPreferenceData>
) =>
  queryOptions<
    OnboardingMeetingPreferenceResponse,
    DefaultError,
    OnboardingMeetingPreferenceResponse,
    ReturnType<typeof onboardingMeetingPreferenceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingMeetingPreference({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingMeetingPreferenceQueryKey(options),
  })

/**
 * Return the family's meeting-location preference for the active referral
 *
 * Returns the family's current meeting-location preference (`during_school` / `outside_school` / `both`), or null if not yet chosen.
 */
export const useOnboardingMeetingPreferenceQuery = (
  options: Options<OnboardingMeetingPreferenceData>
) => useQuery(onboardingMeetingPreferenceOptions(options))

export const saveOnboardingMeetingPreferenceMutationKey = (
  options?: Partial<Options<SaveOnboardingMeetingPreferenceData>>
) => createMutationKey('saveOnboardingMeetingPreference', options)

/**
 * Persist the meeting-location preference for the active referral
 */
export const saveOnboardingMeetingPreferenceMutation = (
  options?: Partial<Options<SaveOnboardingMeetingPreferenceData>>
): UseMutationOptions<
  SaveOnboardingMeetingPreferenceResponse,
  SaveOnboardingMeetingPreferenceError,
  Options<SaveOnboardingMeetingPreferenceData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingMeetingPreferenceResponse,
    SaveOnboardingMeetingPreferenceError,
    Options<SaveOnboardingMeetingPreferenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingMeetingPreference({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingMeetingPreferenceMutationKey(options),
  }
  return mutationOptions
}

/**
 * Persist the meeting-location preference for the active referral
 */
export const useSaveOnboardingMeetingPreferenceMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingMeetingPreferenceResponse,
        SaveOnboardingMeetingPreferenceError,
        Options<SaveOnboardingMeetingPreferenceData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingMeetingPreferenceMutation(), ...mutationOptions })

export const onboardingPayersQueryKey = (options: Options<OnboardingPayersData>) =>
  createQueryKey('onboardingPayers', options)

/**
 * List payers available in the client's state with eligibility metadata
 *
 * Returns the state-filtered carrier dropdown for the FWE v2 insurance step. State is inferred from the resolved client. Each payer carries its Apero mapping (or null) and a normalized network_status enum so the React form can render in-network indicators and kick off eligibility checks without an extra round trip.
 */
export const onboardingPayersOptions = (options: Options<OnboardingPayersData>) =>
  queryOptions<
    OnboardingPayersResponse,
    OnboardingPayersError,
    OnboardingPayersResponse,
    ReturnType<typeof onboardingPayersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingPayers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingPayersQueryKey(options),
  })

/**
 * List payers available in the client's state with eligibility metadata
 *
 * Returns the state-filtered carrier dropdown for the FWE v2 insurance step. State is inferred from the resolved client. Each payer carries its Apero mapping (or null) and a normalized network_status enum so the React form can render in-network indicators and kick off eligibility checks without an extra round trip.
 */
export const useOnboardingPayersQuery = (options: Options<OnboardingPayersData>) =>
  useQuery(onboardingPayersOptions(options))

export const createOnboardingPaymentMethodSetupIntentMutationKey = (
  options?: Partial<Options<CreateOnboardingPaymentMethodSetupIntentData>>
) => createMutationKey('createOnboardingPaymentMethodSetupIntent', options)

/**
 * Start a Stripe Checkout setup session for the family's payment method
 *
 * Provisions a Stripe Checkout Session in setup mode and returns the client_secret + session id for the React wizard to render Stripe Elements (embedded mode). Idempotent within a 5-minute window: repeated calls for the same client return the same checkout_session_id.
 */
export const createOnboardingPaymentMethodSetupIntentMutation = (
  options?: Partial<Options<CreateOnboardingPaymentMethodSetupIntentData>>
): UseMutationOptions<
  CreateOnboardingPaymentMethodSetupIntentResponse,
  CreateOnboardingPaymentMethodSetupIntentError,
  Options<CreateOnboardingPaymentMethodSetupIntentData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateOnboardingPaymentMethodSetupIntentResponse,
    CreateOnboardingPaymentMethodSetupIntentError,
    Options<CreateOnboardingPaymentMethodSetupIntentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOnboardingPaymentMethodSetupIntent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createOnboardingPaymentMethodSetupIntentMutationKey(options),
  }
  return mutationOptions
}

/**
 * Start a Stripe Checkout setup session for the family's payment method
 *
 * Provisions a Stripe Checkout Session in setup mode and returns the client_secret + session id for the React wizard to render Stripe Elements (embedded mode). Idempotent within a 5-minute window: repeated calls for the same client return the same checkout_session_id.
 */
export const useCreateOnboardingPaymentMethodSetupIntentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateOnboardingPaymentMethodSetupIntentResponse,
        CreateOnboardingPaymentMethodSetupIntentError,
        Options<CreateOnboardingPaymentMethodSetupIntentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createOnboardingPaymentMethodSetupIntentMutation(), ...mutationOptions })

export const acknowledgeRedFlagApprovalMutationKey = (
  options?: Partial<Options<AcknowledgeRedFlagApprovalData>>
) => createMutationKey('acknowledgeRedFlagApproval', options)

/**
 * Acknowledge the FWE v2 red-flag-approved re-entry screen
 *
 * Records the durable FIF_RED_FLAG_APPROVAL_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial. Idempotent per referral.
 */
export const acknowledgeRedFlagApprovalMutation = (
  options?: Partial<Options<AcknowledgeRedFlagApprovalData>>
): UseMutationOptions<
  AcknowledgeRedFlagApprovalResponse,
  AcknowledgeRedFlagApprovalError,
  Options<AcknowledgeRedFlagApprovalData>
> => {
  const mutationOptions: UseMutationOptions<
    AcknowledgeRedFlagApprovalResponse,
    AcknowledgeRedFlagApprovalError,
    Options<AcknowledgeRedFlagApprovalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acknowledgeRedFlagApproval({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: acknowledgeRedFlagApprovalMutationKey(options),
  }
  return mutationOptions
}

/**
 * Acknowledge the FWE v2 red-flag-approved re-entry screen
 *
 * Records the durable FIF_RED_FLAG_APPROVAL_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial. Idempotent per referral.
 */
export const useAcknowledgeRedFlagApprovalMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        AcknowledgeRedFlagApprovalResponse,
        AcknowledgeRedFlagApprovalError,
        Options<AcknowledgeRedFlagApprovalData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...acknowledgeRedFlagApprovalMutation(), ...mutationOptions })

export const submitOnboardingSelfPayMutationKey = (
  options?: Partial<Options<SubmitOnboardingSelfPayData>>
) => createMutationKey('submitOnboardingSelfPay', options)

/**
 * Record the family's FWE v2 self-pay (out-of-pocket) choice
 *
 * Records the family's choice to pay out-of-pocket from the insurance-carrier step: creates the self_pay cost estimate ($145 intake / $120 ongoing) and flags the referral with the SELF_PAID marker, which lets clinician matching bypass the in-network payer hard filter (RCM-1935). Idempotent: re-selecting self-pay returns the existing estimate without creating a duplicate. Returns the estimate so the wizard renders the Pay Out-of-pocket screen.
 */
export const submitOnboardingSelfPayMutation = (
  options?: Partial<Options<SubmitOnboardingSelfPayData>>
): UseMutationOptions<
  SubmitOnboardingSelfPayResponse,
  SubmitOnboardingSelfPayError,
  Options<SubmitOnboardingSelfPayData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitOnboardingSelfPayResponse,
    SubmitOnboardingSelfPayError,
    Options<SubmitOnboardingSelfPayData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitOnboardingSelfPay({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitOnboardingSelfPayMutationKey(options),
  }
  return mutationOptions
}

/**
 * Record the family's FWE v2 self-pay (out-of-pocket) choice
 *
 * Records the family's choice to pay out-of-pocket from the insurance-carrier step: creates the self_pay cost estimate ($145 intake / $120 ongoing) and flags the referral with the SELF_PAID marker, which lets clinician matching bypass the in-network payer hard filter (RCM-1935). Idempotent: re-selecting self-pay returns the existing estimate without creating a duplicate. Returns the estimate so the wizard renders the Pay Out-of-pocket screen.
 */
export const useSubmitOnboardingSelfPayMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitOnboardingSelfPayResponse,
        SubmitOnboardingSelfPayError,
        Options<SubmitOnboardingSelfPayData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitOnboardingSelfPayMutation(), ...mutationOptions })

export const onboardingServiceLinesQueryKey = (options: Options<OnboardingServiceLinesData>) =>
  createQueryKey('onboardingServiceLines', options)

/**
 * Returns selectable service lines and the current tentative selection
 *
 * FWE v2 wizard Step 3 read. `available` is the catalog of externally-referable services; `selected` is the current set of tentative service-line UUIDs stored on `client_selected_preferences`.
 */
export const onboardingServiceLinesOptions = (options: Options<OnboardingServiceLinesData>) =>
  queryOptions<
    OnboardingServiceLinesResponse,
    DefaultError,
    OnboardingServiceLinesResponse,
    ReturnType<typeof onboardingServiceLinesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingServiceLines({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingServiceLinesQueryKey(options),
  })

/**
 * Returns selectable service lines and the current tentative selection
 *
 * FWE v2 wizard Step 3 read. `available` is the catalog of externally-referable services; `selected` is the current set of tentative service-line UUIDs stored on `client_selected_preferences`.
 */
export const useOnboardingServiceLinesQuery = (options: Options<OnboardingServiceLinesData>) =>
  useQuery(onboardingServiceLinesOptions(options))

export const saveOnboardingServiceLinesMutationKey = (
  options?: Partial<Options<SaveOnboardingServiceLinesData>>
) => createMutationKey('saveOnboardingServiceLines', options)

/**
 * Replaces the family's tentative service-line selection
 *
 * Atomically replaces all `client_selected_preferences` rows with `preference_type: service_line` for the most-recent referral. Emits SERVICE_LINES_SELECTED on success.
 */
export const saveOnboardingServiceLinesMutation = (
  options?: Partial<Options<SaveOnboardingServiceLinesData>>
): UseMutationOptions<
  SaveOnboardingServiceLinesResponse,
  SaveOnboardingServiceLinesError,
  Options<SaveOnboardingServiceLinesData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveOnboardingServiceLinesResponse,
    SaveOnboardingServiceLinesError,
    Options<SaveOnboardingServiceLinesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveOnboardingServiceLines({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveOnboardingServiceLinesMutationKey(options),
  }
  return mutationOptions
}

/**
 * Replaces the family's tentative service-line selection
 *
 * Atomically replaces all `client_selected_preferences` rows with `preference_type: service_line` for the most-recent referral. Emits SERVICE_LINES_SELECTED on success.
 */
export const useSaveOnboardingServiceLinesMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveOnboardingServiceLinesResponse,
        SaveOnboardingServiceLinesError,
        Options<SaveOnboardingServiceLinesData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveOnboardingServiceLinesMutation(), ...mutationOptions })

export const onboardingSessionHeldQueryKey = (options: Options<OnboardingSessionHeldData>) =>
  createQueryKey('onboardingSessionHeld', options)

/**
 * Booking summary + hold reason for the session-held terminal screen
 *
 * Terminal step of the FWE v2 held path. Returns the family's booking summary (matched clinician, first session, recurring schedule) plus `pending_reason` — the outstanding staff-verification blocker (school_approval / insurance / guardian_2 / financial_aid). `pending_reason` is null once the hold clears (→ complete screen).
 */
export const onboardingSessionHeldOptions = (options: Options<OnboardingSessionHeldData>) =>
  queryOptions<
    OnboardingSessionHeldResponse,
    OnboardingSessionHeldError,
    OnboardingSessionHeldResponse,
    ReturnType<typeof onboardingSessionHeldQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingSessionHeld({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingSessionHeldQueryKey(options),
  })

/**
 * Booking summary + hold reason for the session-held terminal screen
 *
 * Terminal step of the FWE v2 held path. Returns the family's booking summary (matched clinician, first session, recurring schedule) plus `pending_reason` — the outstanding staff-verification blocker (school_approval / insurance / guardian_2 / financial_aid). `pending_reason` is null once the hold clears (→ complete screen).
 */
export const useOnboardingSessionHeldQuery = (options: Options<OnboardingSessionHeldData>) =>
  useQuery(onboardingSessionHeldOptions(options))

export const recordSessionHeldEndFlowMutationKey = (
  options?: Partial<Options<RecordSessionHeldEndFlowData>>
) => createMutationKey('recordSessionHeldEndFlow', options)

/**
 * Emit the FWE v2 SESSION_HELD_END_FLOW terminal event
 *
 * Emits the SESSION_HELD_END_FLOW CDP event when the family reaches the session-held screen. reason_for_hold is derived backend from PrerequisitesChecker. Fired once per referral (Redis idempotency guard).
 */
export const recordSessionHeldEndFlowMutation = (
  options?: Partial<Options<RecordSessionHeldEndFlowData>>
): UseMutationOptions<
  RecordSessionHeldEndFlowResponse,
  RecordSessionHeldEndFlowError,
  Options<RecordSessionHeldEndFlowData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordSessionHeldEndFlowResponse,
    RecordSessionHeldEndFlowError,
    Options<RecordSessionHeldEndFlowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordSessionHeldEndFlow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordSessionHeldEndFlowMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE v2 SESSION_HELD_END_FLOW terminal event
 *
 * Emits the SESSION_HELD_END_FLOW CDP event when the family reaches the session-held screen. reason_for_hold is derived backend from PrerequisitesChecker. Fired once per referral (Redis idempotency guard).
 */
export const useRecordSessionHeldEndFlowMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordSessionHeldEndFlowResponse,
        RecordSessionHeldEndFlowError,
        Options<RecordSessionHeldEndFlowData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordSessionHeldEndFlowMutation(), ...mutationOptions })

export const recordTimeslotSelectedMutationKey = (
  options?: Partial<Options<RecordTimeslotSelectedData>>
) => createMutationKey('recordTimeslotSelected', options)

/**
 * Emit the FWE v2 TIMESLOT_SELECTED funnel event
 *
 * Emits the TIMESLOT_SELECTED CDP event when the family selects a timeslot (pre-confirm). Emit-only; clinician_name is resolved backend and `filters` passes through the family's selected matching filters when supplied.
 */
export const recordTimeslotSelectedMutation = (
  options?: Partial<Options<RecordTimeslotSelectedData>>
): UseMutationOptions<
  RecordTimeslotSelectedResponse,
  RecordTimeslotSelectedError,
  Options<RecordTimeslotSelectedData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordTimeslotSelectedResponse,
    RecordTimeslotSelectedError,
    Options<RecordTimeslotSelectedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordTimeslotSelected({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordTimeslotSelectedMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE v2 TIMESLOT_SELECTED funnel event
 *
 * Emits the TIMESLOT_SELECTED CDP event when the family selects a timeslot (pre-confirm). Emit-only; clinician_name is resolved backend and `filters` passes through the family's selected matching filters when supplied.
 */
export const useRecordTimeslotSelectedMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordTimeslotSelectedResponse,
        RecordTimeslotSelectedError,
        Options<RecordTimeslotSelectedData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordTimeslotSelectedMutation(), ...mutationOptions })

export const onboardingVerificationStatusQueryKey = (
  options: Options<OnboardingVerificationStatusData>
) => createQueryKey('onboardingVerificationStatus', options)

/**
 * Report whether the session is verified for this student's FWE form
 *
 * Returns the client when the current session was verified for the client this signed_id resolves to. The FWE gate is per-student: a session verified for one child (e.g. a sibling) is NOT considered verified for another child's form, so this returns 401 whenever the session client differs from the signed-id's client (or no session exists).
 */
export const onboardingVerificationStatusOptions = (
  options: Options<OnboardingVerificationStatusData>
) =>
  queryOptions<
    OnboardingVerificationStatusResponse,
    OnboardingVerificationStatusError,
    OnboardingVerificationStatusResponse,
    ReturnType<typeof onboardingVerificationStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingVerificationStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingVerificationStatusQueryKey(options),
  })

/**
 * Report whether the session is verified for this student's FWE form
 *
 * Returns the client when the current session was verified for the client this signed_id resolves to. The FWE gate is per-student: a session verified for one child (e.g. a sibling) is NOT considered verified for another child's form, so this returns 401 whenever the session client differs from the signed-id's client (or no session exists).
 */
export const useOnboardingVerificationStatusQuery = (
  options: Options<OnboardingVerificationStatusData>
) => useQuery(onboardingVerificationStatusOptions(options))

export const verifyFamilyIdentityMutationKey = (
  options?: Partial<Options<VerifyFamilyIdentityData>>
) => createMutationKey('verifyFamilyIdentity', options)

/**
 * Verify a family's identity to start the FWE v2 wizard
 *
 * Validates the submitted first name, last name, and date of birth against the client record, persists the phone number, and transitions the referral into outreach_waiting_for_family. Idempotent: a second successful call no-ops the AASM transition and the FWE_STARTED ClientEvent.
 */
export const verifyFamilyIdentityMutation = (
  options?: Partial<Options<VerifyFamilyIdentityData>>
): UseMutationOptions<
  VerifyFamilyIdentityResponse,
  VerifyFamilyIdentityError,
  Options<VerifyFamilyIdentityData>
> => {
  const mutationOptions: UseMutationOptions<
    VerifyFamilyIdentityResponse,
    VerifyFamilyIdentityError,
    Options<VerifyFamilyIdentityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyFamilyIdentity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: verifyFamilyIdentityMutationKey(options),
  }
  return mutationOptions
}

/**
 * Verify a family's identity to start the FWE v2 wizard
 *
 * Validates the submitted first name, last name, and date of birth against the client record, persists the phone number, and transitions the referral into outreach_waiting_for_family. Idempotent: a second successful call no-ops the AASM transition and the FWE_STARTED ClientEvent.
 */
export const useVerifyFamilyIdentityMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        VerifyFamilyIdentityResponse,
        VerifyFamilyIdentityError,
        Options<VerifyFamilyIdentityData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...verifyFamilyIdentityMutation(), ...mutationOptions })

export const recordWaitlistEndFlowMutationKey = (
  options?: Partial<Options<RecordWaitlistEndFlowData>>
) => createMutationKey('recordWaitlistEndFlow', options)

/**
 * Emit the FWE v2 WAITLIST_END_FLOW terminal event
 *
 * Emits the WAITLIST_END_FLOW CDP event when the family reaches the waitlist-confirmed screen. Fired once per referral (Redis idempotency guard).
 */
export const recordWaitlistEndFlowMutation = (
  options?: Partial<Options<RecordWaitlistEndFlowData>>
): UseMutationOptions<
  RecordWaitlistEndFlowResponse,
  RecordWaitlistEndFlowError,
  Options<RecordWaitlistEndFlowData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordWaitlistEndFlowResponse,
    RecordWaitlistEndFlowError,
    Options<RecordWaitlistEndFlowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordWaitlistEndFlow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordWaitlistEndFlowMutationKey(options),
  }
  return mutationOptions
}

/**
 * Emit the FWE v2 WAITLIST_END_FLOW terminal event
 *
 * Emits the WAITLIST_END_FLOW CDP event when the family reaches the waitlist-confirmed screen. Fired once per referral (Redis idempotency guard).
 */
export const useRecordWaitlistEndFlowMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordWaitlistEndFlowResponse,
        RecordWaitlistEndFlowError,
        Options<RecordWaitlistEndFlowData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordWaitlistEndFlowMutation(), ...mutationOptions })

export const recordWaitlistRequestedMutationKey = (
  options?: Partial<Options<RecordWaitlistRequestedData>>
) => createMutationKey('recordWaitlistRequested', options)

/**
 * Record that the family entered the FWE v2 waitlist flow
 *
 * Emits the WAITLIST_REQUESTED CDP event and records a durable client event when the family enters the waitlist flow. `forced` records whether the family chose the waitlist or was routed there with no clinicians available. `source` records why the family entered the waitlist — 'clinician_match' (from the matching screen) or 'rte_failure' (Plan B: insurance couldn't be verified).
 */
export const recordWaitlistRequestedMutation = (
  options?: Partial<Options<RecordWaitlistRequestedData>>
): UseMutationOptions<
  RecordWaitlistRequestedResponse,
  RecordWaitlistRequestedError,
  Options<RecordWaitlistRequestedData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordWaitlistRequestedResponse,
    RecordWaitlistRequestedError,
    Options<RecordWaitlistRequestedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordWaitlistRequested({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordWaitlistRequestedMutationKey(options),
  }
  return mutationOptions
}

/**
 * Record that the family entered the FWE v2 waitlist flow
 *
 * Emits the WAITLIST_REQUESTED CDP event and records a durable client event when the family enters the waitlist flow. `forced` records whether the family chose the waitlist or was routed there with no clinicians available. `source` records why the family entered the waitlist — 'clinician_match' (from the matching screen) or 'rte_failure' (Plan B: insurance couldn't be verified).
 */
export const useRecordWaitlistRequestedMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordWaitlistRequestedResponse,
        RecordWaitlistRequestedError,
        Options<RecordWaitlistRequestedData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordWaitlistRequestedMutation(), ...mutationOptions })

export const acknowledgeWaitlistMatchMutationKey = (
  options?: Partial<Options<AcknowledgeWaitlistMatchData>>
) => createMutationKey('acknowledgeWaitlistMatch', options)

/**
 * Acknowledge the FWE v2 we-found-a-match re-entry screen
 *
 * Records the durable FWE_WAITLIST_MATCH_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial into Phase 3. Idempotent per referral.
 */
export const acknowledgeWaitlistMatchMutation = (
  options?: Partial<Options<AcknowledgeWaitlistMatchData>>
): UseMutationOptions<
  AcknowledgeWaitlistMatchResponse,
  AcknowledgeWaitlistMatchError,
  Options<AcknowledgeWaitlistMatchData>
> => {
  const mutationOptions: UseMutationOptions<
    AcknowledgeWaitlistMatchResponse,
    AcknowledgeWaitlistMatchError,
    Options<AcknowledgeWaitlistMatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acknowledgeWaitlistMatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: acknowledgeWaitlistMatchMutationKey(options),
  }
  return mutationOptions
}

/**
 * Acknowledge the FWE v2 we-found-a-match re-entry screen
 *
 * Records the durable FWE_WAITLIST_MATCH_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial into Phase 3. Idempotent per referral.
 */
export const useAcknowledgeWaitlistMatchMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        AcknowledgeWaitlistMatchResponse,
        AcknowledgeWaitlistMatchError,
        Options<AcknowledgeWaitlistMatchData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...acknowledgeWaitlistMatchMutation(), ...mutationOptions })

export const onboardingByIdQueryKey = (options: Options<OnboardingByIdData>) =>
  createQueryKey('onboardingById', options)

/**
 * Resolve onboarding client from signed id
 *
 * Foundation endpoint for the FWE v2 wizard. Returns the resolved client for any valid onboarding signed id. Acts as the smoke-test for the Api::V1::Onboarding::BaseController authentication path.
 */
export const onboardingByIdOptions = (options: Options<OnboardingByIdData>) =>
  queryOptions<
    OnboardingByIdResponse,
    OnboardingByIdError,
    OnboardingByIdResponse,
    ReturnType<typeof onboardingByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: onboardingByIdQueryKey(options),
  })

/**
 * Resolve onboarding client from signed id
 *
 * Foundation endpoint for the FWE v2 wizard. Returns the resolved client for any valid onboarding signed id. Acts as the smoke-test for the Api::V1::Onboarding::BaseController authentication path.
 */
export const useOnboardingByIdQuery = (options: Options<OnboardingByIdData>) =>
  useQuery(onboardingByIdOptions(options))

export const organizationInstitutionsQueryKey = (options: Options<OrganizationInstitutionsData>) =>
  createQueryKey('organizationInstitutions', options)

/**
 * list institutions for an organization
 *
 * Returns the active institutions belonging to the organization, each with its institution_grades. Used by the new referral wizard's student step to populate the school and grade dropdowns.
 */
export const organizationInstitutionsOptions = (options: Options<OrganizationInstitutionsData>) =>
  queryOptions<
    OrganizationInstitutionsResponse,
    OrganizationInstitutionsError,
    OrganizationInstitutionsResponse,
    ReturnType<typeof organizationInstitutionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationInstitutions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: organizationInstitutionsQueryKey(options),
  })

/**
 * list institutions for an organization
 *
 * Returns the active institutions belonging to the organization, each with its institution_grades. Used by the new referral wizard's student step to populate the school and grade dropdowns.
 */
export const useOrganizationInstitutionsQuery = (options: Options<OrganizationInstitutionsData>) =>
  useQuery(organizationInstitutionsOptions(options))

export const updateSchoolReferralContactMutationKey = (
  options?: Partial<Options<UpdateSchoolReferralContactData>>
) => createMutationKey('updateSchoolReferralContact', options)

/**
 * assign or clear a school's referral contact
 *
 * Sets (or clears, with a null id) the school's referral contact — the person used to back-fill the referrer on that school's auto-approved FIFs. Admin / program manager only.
 */
export const updateSchoolReferralContactMutation = (
  options?: Partial<Options<UpdateSchoolReferralContactData>>
): UseMutationOptions<
  UpdateSchoolReferralContactResponse,
  UpdateSchoolReferralContactError,
  Options<UpdateSchoolReferralContactData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSchoolReferralContactResponse,
    UpdateSchoolReferralContactError,
    Options<UpdateSchoolReferralContactData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateSchoolReferralContact({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateSchoolReferralContactMutationKey(options),
  }
  return mutationOptions
}

/**
 * assign or clear a school's referral contact
 *
 * Sets (or clears, with a null id) the school's referral contact — the person used to back-fill the referrer on that school's auto-approved FIFs. Admin / program manager only.
 */
export const useUpdateSchoolReferralContactMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateSchoolReferralContactResponse,
        UpdateSchoolReferralContactError,
        Options<UpdateSchoolReferralContactData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateSchoolReferralContactMutation(), ...mutationOptions })

export const resetOrganizationReferralContactsMutationKey = (
  options?: Partial<Options<ResetOrganizationReferralContactsData>>
) => createMutationKey('resetOrganizationReferralContacts', options)

/**
 * reset all schools to the district MPOC default
 *
 * Clears every school's configured referral contact for the organization so they fall back to the district MPOC default. Admin / program manager only.
 */
export const resetOrganizationReferralContactsMutation = (
  options?: Partial<Options<ResetOrganizationReferralContactsData>>
): UseMutationOptions<
  ResetOrganizationReferralContactsResponse,
  DefaultError,
  Options<ResetOrganizationReferralContactsData>
> => {
  const mutationOptions: UseMutationOptions<
    ResetOrganizationReferralContactsResponse,
    DefaultError,
    Options<ResetOrganizationReferralContactsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetOrganizationReferralContacts({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: resetOrganizationReferralContactsMutationKey(options),
  }
  return mutationOptions
}

/**
 * reset all schools to the district MPOC default
 *
 * Clears every school's configured referral contact for the organization so they fall back to the district MPOC default. Admin / program manager only.
 */
export const useResetOrganizationReferralContactsMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ResetOrganizationReferralContactsResponse,
        DefaultError,
        Options<ResetOrganizationReferralContactsData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...resetOrganizationReferralContactsMutation(), ...mutationOptions })

export const organizationStaffQueryKey = (options: Options<OrganizationStaffData>) =>
  createQueryKey('organizationStaff', options)

/**
 * list an organization's staff for the referral-contact picker
 *
 * Active staff eligible to be a school referral contact, plus the district MPOC default(s) a school falls back to when none is configured. Admin / program manager only.
 */
export const organizationStaffOptions = (options: Options<OrganizationStaffData>) =>
  queryOptions<
    OrganizationStaffResponse,
    OrganizationStaffError,
    OrganizationStaffResponse,
    ReturnType<typeof organizationStaffQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationStaff({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: organizationStaffQueryKey(options),
  })

/**
 * list an organization's staff for the referral-contact picker
 *
 * Active staff eligible to be a school referral contact, plus the district MPOC default(s) a school falls back to when none is configured. Admin / program manager only.
 */
export const useOrganizationStaffQuery = (options: Options<OrganizationStaffData>) =>
  useQuery(organizationStaffOptions(options))

export const payersQueryKey = (options?: Options<PayersData>) => createQueryKey('payers', options)

/**
 * list payers
 */
export const payersOptions = (options?: Options<PayersData>) =>
  queryOptions<PayersResponse, DefaultError, PayersResponse, ReturnType<typeof payersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await payers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: payersQueryKey(options),
  })

/**
 * list payers
 */
export const usePayersQuery = (options?: Options<PayersData>) => useQuery(payersOptions(options))

export const dismissProductAnnouncementMutationKey = (
  options?: Partial<Options<DismissProductAnnouncementData>>
) => createMutationKey('dismissProductAnnouncement', options)

/**
 * Dismisses the current product update announcement
 */
export const dismissProductAnnouncementMutation = (
  options?: Partial<Options<DismissProductAnnouncementData>>
): UseMutationOptions<
  DismissProductAnnouncementResponse,
  DefaultError,
  Options<DismissProductAnnouncementData>
> => {
  const mutationOptions: UseMutationOptions<
    DismissProductAnnouncementResponse,
    DefaultError,
    Options<DismissProductAnnouncementData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dismissProductAnnouncement({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: dismissProductAnnouncementMutationKey(options),
  }
  return mutationOptions
}

/**
 * Dismisses the current product update announcement
 */
export const useDismissProductAnnouncementMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DismissProductAnnouncementResponse,
        DefaultError,
        Options<DismissProductAnnouncementData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...dismissProductAnnouncementMutation(), ...mutationOptions })

export const reassignmentsQueryKey = (options?: Options<ReassignmentsData>) =>
  createQueryKey('reassignments', options)

/**
 * list reassignments
 */
export const reassignmentsOptions = (options?: Options<ReassignmentsData>) =>
  queryOptions<
    ReassignmentsResponse,
    ReassignmentsError,
    ReassignmentsResponse,
    ReturnType<typeof reassignmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reassignments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reassignmentsQueryKey(options),
  })

export const reassignmentsInfiniteQueryKey = (
  options?: Options<ReassignmentsData>
): QueryKey<Options<ReassignmentsData>> => createQueryKey('reassignments', options, true)

/**
 * list reassignments
 */
export const reassignmentsInfiniteOptions = (options?: Options<ReassignmentsData>) =>
  infiniteQueryOptions<
    ReassignmentsResponse,
    ReassignmentsError,
    InfiniteData<ReassignmentsResponse>,
    QueryKey<Options<ReassignmentsData>>,
    number | Pick<QueryKey<Options<ReassignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<
          QueryKey<Options<ReassignmentsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await reassignments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: reassignmentsInfiniteQueryKey(options),
    }
  )

/**
 * list reassignments
 */
export const useReassignmentsQuery = (options?: Options<ReassignmentsData>) =>
  useQuery(reassignmentsOptions(options))

export const createReassignmentMutationKey = (options?: Partial<Options<CreateReassignmentData>>) =>
  createMutationKey('createReassignment', options)

/**
 * create reassignment
 */
export const createReassignmentMutation = (
  options?: Partial<Options<CreateReassignmentData>>
): UseMutationOptions<
  CreateReassignmentResponse,
  CreateReassignmentError,
  Options<CreateReassignmentData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateReassignmentResponse,
    CreateReassignmentError,
    Options<CreateReassignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createReassignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createReassignmentMutationKey(options),
  }
  return mutationOptions
}

/**
 * create reassignment
 */
export const useCreateReassignmentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateReassignmentResponse,
        CreateReassignmentError,
        Options<CreateReassignmentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createReassignmentMutation(), ...mutationOptions })

export const reassignmentByIdQueryKey = (options: Options<ReassignmentByIdData>) =>
  createQueryKey('reassignmentById', options)

/**
 * get reassignment details
 */
export const reassignmentByIdOptions = (options: Options<ReassignmentByIdData>) =>
  queryOptions<
    ReassignmentByIdResponse,
    ReassignmentByIdError,
    ReassignmentByIdResponse,
    ReturnType<typeof reassignmentByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reassignmentById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reassignmentByIdQueryKey(options),
  })

/**
 * get reassignment details
 */
export const useReassignmentByIdQuery = (options: Options<ReassignmentByIdData>) =>
  useQuery(reassignmentByIdOptions(options))

export const updateReassignmentMutationKey = (options?: Partial<Options<UpdateReassignmentData>>) =>
  createMutationKey('updateReassignment', options)

/**
 * update reassignment
 */
export const updateReassignmentMutation = (
  options?: Partial<Options<UpdateReassignmentData>>
): UseMutationOptions<
  UpdateReassignmentResponse,
  UpdateReassignmentError,
  Options<UpdateReassignmentData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateReassignmentResponse,
    UpdateReassignmentError,
    Options<UpdateReassignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateReassignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateReassignmentMutationKey(options),
  }
  return mutationOptions
}

/**
 * update reassignment
 */
export const useUpdateReassignmentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateReassignmentResponse,
        UpdateReassignmentError,
        Options<UpdateReassignmentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateReassignmentMutation(), ...mutationOptions })

export const advanceOnboardingMilestoneMutationKey = (
  options?: Partial<Options<AdvanceOnboardingMilestoneData>>
) => createMutationKey('advanceOnboardingMilestone', options)

/**
 * Manually advance a referral's onboarding milestone
 */
export const advanceOnboardingMilestoneMutation = (
  options?: Partial<Options<AdvanceOnboardingMilestoneData>>
): UseMutationOptions<
  AdvanceOnboardingMilestoneResponse,
  AdvanceOnboardingMilestoneError,
  Options<AdvanceOnboardingMilestoneData>
> => {
  const mutationOptions: UseMutationOptions<
    AdvanceOnboardingMilestoneResponse,
    AdvanceOnboardingMilestoneError,
    Options<AdvanceOnboardingMilestoneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await advanceOnboardingMilestone({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: advanceOnboardingMilestoneMutationKey(options),
  }
  return mutationOptions
}

/**
 * Manually advance a referral's onboarding milestone
 */
export const useAdvanceOnboardingMilestoneMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        AdvanceOnboardingMilestoneResponse,
        AdvanceOnboardingMilestoneError,
        Options<AdvanceOnboardingMilestoneData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...advanceOnboardingMilestoneMutation(), ...mutationOptions })

export const referralOnboardingProgressQueryKey = (
  options: Options<ReferralOnboardingProgressData>
) => createQueryKey('referralOnboardingProgress', options)

/**
 * Fetch a referral's onboarding progress
 */
export const referralOnboardingProgressOptions = (
  options: Options<ReferralOnboardingProgressData>
) =>
  queryOptions<
    ReferralOnboardingProgressResponse,
    DefaultError,
    ReferralOnboardingProgressResponse,
    ReturnType<typeof referralOnboardingProgressQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await referralOnboardingProgress({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: referralOnboardingProgressQueryKey(options),
  })

/**
 * Fetch a referral's onboarding progress
 */
export const useReferralOnboardingProgressQuery = (
  options: Options<ReferralOnboardingProgressData>
) => useQuery(referralOnboardingProgressOptions(options))

export const clearReferralDraftMutationKey = (options?: Partial<Options<ClearReferralDraftData>>) =>
  createMutationKey('clearReferralDraft', options)

/**
 * Clear the current referral draft
 */
export const clearReferralDraftMutation = (
  options?: Partial<Options<ClearReferralDraftData>>
): UseMutationOptions<
  ClearReferralDraftResponse,
  DefaultError,
  Options<ClearReferralDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    ClearReferralDraftResponse,
    DefaultError,
    Options<ClearReferralDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearReferralDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: clearReferralDraftMutationKey(options),
  }
  return mutationOptions
}

/**
 * Clear the current referral draft
 */
export const useClearReferralDraftMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<ClearReferralDraftResponse, DefaultError, Options<ClearReferralDraftData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...clearReferralDraftMutation(), ...mutationOptions })

export const referralDraftQueryKey = (options?: Options<ReferralDraftData>) =>
  createQueryKey('referralDraft', options)

/**
 * Fetch the current referral draft
 */
export const referralDraftOptions = (options?: Options<ReferralDraftData>) =>
  queryOptions<
    ReferralDraftResponse,
    DefaultError,
    ReferralDraftResponse,
    ReturnType<typeof referralDraftQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await referralDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: referralDraftQueryKey(options),
  })

/**
 * Fetch the current referral draft
 */
export const useReferralDraftQuery = (options?: Options<ReferralDraftData>) =>
  useQuery(referralDraftOptions(options))

export const updateReferralDraftMutationKey = (
  options?: Partial<Options<UpdateReferralDraftData>>
) => createMutationKey('updateReferralDraft', options)

/**
 * Update the current referral draft
 */
export const updateReferralDraftMutation = (
  options?: Partial<Options<UpdateReferralDraftData>>
): UseMutationOptions<
  UpdateReferralDraftResponse,
  UpdateReferralDraftError,
  Options<UpdateReferralDraftData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateReferralDraftResponse,
    UpdateReferralDraftError,
    Options<UpdateReferralDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateReferralDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateReferralDraftMutationKey(options),
  }
  return mutationOptions
}

/**
 * Update the current referral draft
 */
export const useUpdateReferralDraftMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateReferralDraftResponse,
        UpdateReferralDraftError,
        Options<UpdateReferralDraftData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateReferralDraftMutation(), ...mutationOptions })

export const createReferralMutationKey = (options?: Partial<Options<CreateReferralData>>) =>
  createMutationKey('createReferral', options)

/**
 * Submit the completed referral
 */
export const createReferralMutation = (
  options?: Partial<Options<CreateReferralData>>
): UseMutationOptions<unknown, CreateReferralError, Options<CreateReferralData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    CreateReferralError,
    Options<CreateReferralData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createReferral({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createReferralMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit the completed referral
 */
export const useCreateReferralMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<unknown, CreateReferralError, Options<CreateReferralData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...createReferralMutation(), ...mutationOptions })

export const createSchedulingBookingMutationKey = (
  options?: Partial<Options<CreateSchedulingBookingData>>
) => createMutationKey('createSchedulingBooking', options)

/**
 * Books a selected clinician for a reassignment
 */
export const createSchedulingBookingMutation = (
  options?: Partial<Options<CreateSchedulingBookingData>>
): UseMutationOptions<
  CreateSchedulingBookingResponse,
  CreateSchedulingBookingError,
  Options<CreateSchedulingBookingData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSchedulingBookingResponse,
    CreateSchedulingBookingError,
    Options<CreateSchedulingBookingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSchedulingBooking({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createSchedulingBookingMutationKey(options),
  }
  return mutationOptions
}

/**
 * Books a selected clinician for a reassignment
 */
export const useCreateSchedulingBookingMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateSchedulingBookingResponse,
        CreateSchedulingBookingError,
        Options<CreateSchedulingBookingData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createSchedulingBookingMutation(), ...mutationOptions })

export const schedulingClinicianMatchesQueryKey = (
  options: Options<SchedulingClinicianMatchesData>
) => createQueryKey('schedulingClinicianMatches', options)

/**
 * Lists clinician matches for a scheduling journey
 */
export const schedulingClinicianMatchesOptions = (
  options: Options<SchedulingClinicianMatchesData>
) =>
  queryOptions<
    SchedulingClinicianMatchesResponse,
    SchedulingClinicianMatchesError,
    SchedulingClinicianMatchesResponse,
    ReturnType<typeof schedulingClinicianMatchesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schedulingClinicianMatches({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: schedulingClinicianMatchesQueryKey(options),
  })

/**
 * Lists clinician matches for a scheduling journey
 */
export const useSchedulingClinicianMatchesQuery = (
  options: Options<SchedulingClinicianMatchesData>
) => useQuery(schedulingClinicianMatchesOptions(options))

export const schedulingClinicianMatchQueryKey = (options: Options<SchedulingClinicianMatchData>) =>
  createQueryKey('schedulingClinicianMatch', options)

/**
 * Fetches a clinician profile for a scheduling journey
 */
export const schedulingClinicianMatchOptions = (options: Options<SchedulingClinicianMatchData>) =>
  queryOptions<
    SchedulingClinicianMatchResponse,
    SchedulingClinicianMatchError,
    SchedulingClinicianMatchResponse,
    ReturnType<typeof schedulingClinicianMatchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schedulingClinicianMatch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: schedulingClinicianMatchQueryKey(options),
  })

/**
 * Fetches a clinician profile for a scheduling journey
 */
export const useSchedulingClinicianMatchQuery = (options: Options<SchedulingClinicianMatchData>) =>
  useQuery(schedulingClinicianMatchOptions(options))

export const schedulingContextQueryKey = (options: Options<SchedulingContextData>) =>
  createQueryKey('schedulingContext', options)

/**
 * Resolves the family scheduling experience
 */
export const schedulingContextOptions = (options: Options<SchedulingContextData>) =>
  queryOptions<
    SchedulingContextResponse,
    SchedulingContextError,
    SchedulingContextResponse,
    ReturnType<typeof schedulingContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schedulingContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: schedulingContextQueryKey(options),
  })

/**
 * Resolves the family scheduling experience
 */
export const useSchedulingContextQuery = (options: Options<SchedulingContextData>) =>
  useQuery(schedulingContextOptions(options))

export const saveSchedulingIdentityPreferencesMutationKey = (
  options?: Partial<Options<SaveSchedulingIdentityPreferencesData>>
) => createMutationKey('saveSchedulingIdentityPreferences', options)

/**
 * Saves referral-scoped scheduling identity preferences
 */
export const saveSchedulingIdentityPreferencesMutation = (
  options?: Partial<Options<SaveSchedulingIdentityPreferencesData>>
): UseMutationOptions<
  SaveSchedulingIdentityPreferencesResponse,
  SaveSchedulingIdentityPreferencesError,
  Options<SaveSchedulingIdentityPreferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveSchedulingIdentityPreferencesResponse,
    SaveSchedulingIdentityPreferencesError,
    Options<SaveSchedulingIdentityPreferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveSchedulingIdentityPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveSchedulingIdentityPreferencesMutationKey(options),
  }
  return mutationOptions
}

/**
 * Saves referral-scoped scheduling identity preferences
 */
export const useSaveSchedulingIdentityPreferencesMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveSchedulingIdentityPreferencesResponse,
        SaveSchedulingIdentityPreferencesError,
        Options<SaveSchedulingIdentityPreferencesData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveSchedulingIdentityPreferencesMutation(), ...mutationOptions })

export const saveSchedulingMeetingPreferenceMutationKey = (
  options?: Partial<Options<SaveSchedulingMeetingPreferenceData>>
) => createMutationKey('saveSchedulingMeetingPreference', options)

/**
 * Saves the referral-scoped scheduling meeting preference
 */
export const saveSchedulingMeetingPreferenceMutation = (
  options?: Partial<Options<SaveSchedulingMeetingPreferenceData>>
): UseMutationOptions<
  SaveSchedulingMeetingPreferenceResponse,
  SaveSchedulingMeetingPreferenceError,
  Options<SaveSchedulingMeetingPreferenceData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveSchedulingMeetingPreferenceResponse,
    SaveSchedulingMeetingPreferenceError,
    Options<SaveSchedulingMeetingPreferenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveSchedulingMeetingPreference({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: saveSchedulingMeetingPreferenceMutationKey(options),
  }
  return mutationOptions
}

/**
 * Saves the referral-scoped scheduling meeting preference
 */
export const useSaveSchedulingMeetingPreferenceMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SaveSchedulingMeetingPreferenceResponse,
        SaveSchedulingMeetingPreferenceError,
        Options<SaveSchedulingMeetingPreferenceData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...saveSchedulingMeetingPreferenceMutation(), ...mutationOptions })

export const requestReassignmentSchedulingHelpMutationKey = (
  options?: Partial<Options<RequestReassignmentSchedulingHelpData>>
) => createMutationKey('requestReassignmentSchedulingHelp', options)

/**
 * Requests coordinator help for reassignment scheduling
 */
export const requestReassignmentSchedulingHelpMutation = (
  options?: Partial<Options<RequestReassignmentSchedulingHelpData>>
): UseMutationOptions<
  RequestReassignmentSchedulingHelpResponse,
  RequestReassignmentSchedulingHelpError,
  Options<RequestReassignmentSchedulingHelpData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestReassignmentSchedulingHelpResponse,
    RequestReassignmentSchedulingHelpError,
    Options<RequestReassignmentSchedulingHelpData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestReassignmentSchedulingHelp({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: requestReassignmentSchedulingHelpMutationKey(options),
  }
  return mutationOptions
}

/**
 * Requests coordinator help for reassignment scheduling
 */
export const useRequestReassignmentSchedulingHelpMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RequestReassignmentSchedulingHelpResponse,
        RequestReassignmentSchedulingHelpError,
        Options<RequestReassignmentSchedulingHelpData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...requestReassignmentSchedulingHelpMutation(), ...mutationOptions })

export const reauthorizationEligibilityQueryKey = (
  options: Options<ReauthorizationEligibilityData>
) => createQueryKey('reauthorizationEligibility', options)

/**
 * Check reauthorization eligibility for a session limit
 */
export const reauthorizationEligibilityOptions = (
  options: Options<ReauthorizationEligibilityData>
) =>
  queryOptions<
    ReauthorizationEligibilityResponse,
    ReauthorizationEligibilityError,
    ReauthorizationEligibilityResponse,
    ReturnType<typeof reauthorizationEligibilityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reauthorizationEligibility({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reauthorizationEligibilityQueryKey(options),
  })

/**
 * Check reauthorization eligibility for a session limit
 */
export const useReauthorizationEligibilityQuery = (
  options: Options<ReauthorizationEligibilityData>
) => useQuery(reauthorizationEligibilityOptions(options))

export const reauthorizationReviewSummaryQueryKey = (
  options: Options<ReauthorizationReviewSummaryData>
) => createQueryKey('reauthorizationReviewSummary', options)

/**
 * Fetch reauthorization review summary for MPOC
 */
export const reauthorizationReviewSummaryOptions = (
  options: Options<ReauthorizationReviewSummaryData>
) =>
  queryOptions<
    ReauthorizationReviewSummaryResponse,
    ReauthorizationReviewSummaryError,
    ReauthorizationReviewSummaryResponse,
    ReturnType<typeof reauthorizationReviewSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reauthorizationReviewSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reauthorizationReviewSummaryQueryKey(options),
  })

/**
 * Fetch reauthorization review summary for MPOC
 */
export const useReauthorizationReviewSummaryQuery = (
  options: Options<ReauthorizationReviewSummaryData>
) => useQuery(reauthorizationReviewSummaryOptions(options))

export const decideReauthorizationMutationKey = (
  options?: Partial<Options<DecideReauthorizationData>>
) => createMutationKey('decideReauthorization', options)

/**
 * Submit MPOC approval or denial decision
 */
export const decideReauthorizationMutation = (
  options?: Partial<Options<DecideReauthorizationData>>
): UseMutationOptions<
  DecideReauthorizationResponse,
  DecideReauthorizationError,
  Options<DecideReauthorizationData>
> => {
  const mutationOptions: UseMutationOptions<
    DecideReauthorizationResponse,
    DecideReauthorizationError,
    Options<DecideReauthorizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await decideReauthorization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: decideReauthorizationMutationKey(options),
  }
  return mutationOptions
}

/**
 * Submit MPOC approval or denial decision
 */
export const useDecideReauthorizationMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DecideReauthorizationResponse,
        DecideReauthorizationError,
        Options<DecideReauthorizationData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...decideReauthorizationMutation(), ...mutationOptions })

export const clientInfoUpdateScheduleQueryKey = (options?: Options<ClientInfoUpdateScheduleData>) =>
  createQueryKey('clientInfoUpdateSchedule', options)

/**
 * Get schedule configuration
 */
export const clientInfoUpdateScheduleOptions = (options?: Options<ClientInfoUpdateScheduleData>) =>
  queryOptions<
    ClientInfoUpdateScheduleResponse,
    ClientInfoUpdateScheduleError,
    ClientInfoUpdateScheduleResponse,
    ReturnType<typeof clientInfoUpdateScheduleQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientInfoUpdateSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: clientInfoUpdateScheduleQueryKey(options),
  })

/**
 * Get schedule configuration
 */
export const useClientInfoUpdateScheduleQuery = (options?: Options<ClientInfoUpdateScheduleData>) =>
  useQuery(clientInfoUpdateScheduleOptions(options))

export const updateClientInfoUpdateScheduleMutationKey = (
  options?: Partial<Options<UpdateClientInfoUpdateScheduleData>>
) => createMutationKey('updateClientInfoUpdateSchedule', options)

/**
 * Update schedule configuration
 */
export const updateClientInfoUpdateScheduleMutation = (
  options?: Partial<Options<UpdateClientInfoUpdateScheduleData>>
): UseMutationOptions<
  UpdateClientInfoUpdateScheduleResponse,
  UpdateClientInfoUpdateScheduleError,
  Options<UpdateClientInfoUpdateScheduleData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateClientInfoUpdateScheduleResponse,
    UpdateClientInfoUpdateScheduleError,
    Options<UpdateClientInfoUpdateScheduleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateClientInfoUpdateSchedule({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateClientInfoUpdateScheduleMutationKey(options),
  }
  return mutationOptions
}

/**
 * Update schedule configuration
 */
export const useUpdateClientInfoUpdateScheduleMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateClientInfoUpdateScheduleResponse,
        UpdateClientInfoUpdateScheduleError,
        Options<UpdateClientInfoUpdateScheduleData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateClientInfoUpdateScheduleMutation(), ...mutationOptions })

export const triggerClientInfoUpdateMutationKey = (
  options?: Partial<Options<TriggerClientInfoUpdateData>>
) => createMutationKey('triggerClientInfoUpdate', options)

/**
 * Manually trigger update requests
 */
export const triggerClientInfoUpdateMutation = (
  options?: Partial<Options<TriggerClientInfoUpdateData>>
): UseMutationOptions<
  TriggerClientInfoUpdateResponse,
  TriggerClientInfoUpdateError,
  Options<TriggerClientInfoUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TriggerClientInfoUpdateResponse,
    TriggerClientInfoUpdateError,
    Options<TriggerClientInfoUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerClientInfoUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: triggerClientInfoUpdateMutationKey(options),
  }
  return mutationOptions
}

/**
 * Manually trigger update requests
 */
export const useTriggerClientInfoUpdateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        TriggerClientInfoUpdateResponse,
        TriggerClientInfoUpdateError,
        Options<TriggerClientInfoUpdateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...triggerClientInfoUpdateMutation(), ...mutationOptions })

export const surveyResponsesQueryKey = (options?: Options<SurveyResponsesData>) =>
  createQueryKey('surveyResponses', options)

/**
 * list all survey responses
 */
export const surveyResponsesOptions = (options?: Options<SurveyResponsesData>) =>
  queryOptions<
    SurveyResponsesResponse,
    DefaultError,
    SurveyResponsesResponse,
    ReturnType<typeof surveyResponsesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await surveyResponses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: surveyResponsesQueryKey(options),
  })

/**
 * list all survey responses
 */
export const useSurveyResponsesQuery = (options?: Options<SurveyResponsesData>) =>
  useQuery(surveyResponsesOptions(options))

export const surveyResponseByIdQueryKey = (options: Options<SurveyResponseByIdData>) =>
  createQueryKey('surveyResponseById', options)

/**
 * get survey response by ID
 */
export const surveyResponseByIdOptions = (options: Options<SurveyResponseByIdData>) =>
  queryOptions<
    SurveyResponseByIdResponse,
    SurveyResponseByIdError,
    SurveyResponseByIdResponse,
    ReturnType<typeof surveyResponseByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await surveyResponseById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: surveyResponseByIdQueryKey(options),
  })

/**
 * get survey response by ID
 */
export const useSurveyResponseByIdQuery = (options: Options<SurveyResponseByIdData>) =>
  useQuery(surveyResponseByIdOptions(options))

export const surveySchemasQueryKey = (options?: Options<SurveySchemasData>) =>
  createQueryKey('surveySchemas', options)

/**
 * list all survey schemas
 */
export const surveySchemasOptions = (options?: Options<SurveySchemasData>) =>
  queryOptions<
    SurveySchemasResponse,
    DefaultError,
    SurveySchemasResponse,
    ReturnType<typeof surveySchemasQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await surveySchemas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: surveySchemasQueryKey(options),
  })

/**
 * list all survey schemas
 */
export const useSurveySchemasQuery = (options?: Options<SurveySchemasData>) =>
  useQuery(surveySchemasOptions(options))

export const surveySchemaByIdQueryKey = (options: Options<SurveySchemaByIdData>) =>
  createQueryKey('surveySchemaById', options)

/**
 * get survey schema by ID
 */
export const surveySchemaByIdOptions = (options: Options<SurveySchemaByIdData>) =>
  queryOptions<
    SurveySchemaByIdResponse,
    SurveySchemaByIdError,
    SurveySchemaByIdResponse,
    ReturnType<typeof surveySchemaByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await surveySchemaById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: surveySchemaByIdQueryKey(options),
  })

/**
 * get survey schema by ID
 */
export const useSurveySchemaByIdQuery = (options: Options<SurveySchemaByIdData>) =>
  useQuery(surveySchemaByIdOptions(options))

export const deleteSurveyMutationKey = (options?: Partial<Options<DeleteSurveyData>>) =>
  createMutationKey('deleteSurvey', options)

/**
 * delete a survey
 */
export const deleteSurveyMutation = (
  options?: Partial<Options<DeleteSurveyData>>
): UseMutationOptions<DeleteSurveyResponse, DefaultError, Options<DeleteSurveyData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteSurveyResponse,
    DefaultError,
    Options<DeleteSurveyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteSurvey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: deleteSurveyMutationKey(options),
  }
  return mutationOptions
}

/**
 * delete a survey
 */
export const useDeleteSurveyMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<DeleteSurveyResponse, DefaultError, Options<DeleteSurveyData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...deleteSurveyMutation(), ...mutationOptions })

export const surveyByIdQueryKey = (options: Options<SurveyByIdData>) =>
  createQueryKey('surveyById', options)

/**
 * get SurveyJS form by ID
 */
export const surveyByIdOptions = (options: Options<SurveyByIdData>) =>
  queryOptions<
    SurveyByIdResponse,
    SurveyByIdError,
    SurveyByIdResponse,
    ReturnType<typeof surveyByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await surveyById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: surveyByIdQueryKey(options),
  })

/**
 * get SurveyJS form by ID
 */
export const useSurveyByIdQuery = (options: Options<SurveyByIdData>) =>
  useQuery(surveyByIdOptions(options))

export const updateSurveyMutationKey = (options?: Partial<Options<UpdateSurveyData>>) =>
  createMutationKey('updateSurvey', options)

/**
 * update a survey
 */
export const updateSurveyMutation = (
  options?: Partial<Options<UpdateSurveyData>>
): UseMutationOptions<UpdateSurveyResponse, UpdateSurveyError, Options<UpdateSurveyData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateSurveyResponse,
    UpdateSurveyError,
    Options<UpdateSurveyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateSurvey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateSurveyMutationKey(options),
  }
  return mutationOptions
}

/**
 * update a survey
 */
export const useUpdateSurveyMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<UpdateSurveyResponse, UpdateSurveyError, Options<UpdateSurveyData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...updateSurveyMutation(), ...mutationOptions })

export const surveysQueryKey = (options?: Options<SurveysData>) =>
  createQueryKey('surveys', options)

/**
 * list all surveys
 */
export const surveysOptions = (options?: Options<SurveysData>) =>
  queryOptions<SurveysResponse, DefaultError, SurveysResponse, ReturnType<typeof surveysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await surveys({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: surveysQueryKey(options),
  })

/**
 * list all surveys
 */
export const useSurveysQuery = (options?: Options<SurveysData>) => useQuery(surveysOptions(options))

export const createSurveyMutationKey = (options?: Partial<Options<CreateSurveyData>>) =>
  createMutationKey('createSurvey', options)

/**
 * create a new survey
 */
export const createSurveyMutation = (
  options?: Partial<Options<CreateSurveyData>>
): UseMutationOptions<CreateSurveyResponse, CreateSurveyError, Options<CreateSurveyData>> => {
  const mutationOptions: UseMutationOptions<
    CreateSurveyResponse,
    CreateSurveyError,
    Options<CreateSurveyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSurvey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createSurveyMutationKey(options),
  }
  return mutationOptions
}

/**
 * create a new survey
 */
export const useCreateSurveyMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<CreateSurveyResponse, CreateSurveyError, Options<CreateSurveyData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...createSurveyMutation(), ...mutationOptions })

export const respondToSurveyQueryKey = (options?: Options<RespondToSurveyData>) =>
  createQueryKey('respondToSurvey', options)

/**
 * get survey by name for responding
 */
export const respondToSurveyOptions = (options?: Options<RespondToSurveyData>) =>
  queryOptions<
    RespondToSurveyResponse,
    RespondToSurveyError,
    RespondToSurveyResponse,
    ReturnType<typeof respondToSurveyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await respondToSurvey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: respondToSurveyQueryKey(options),
  })

/**
 * get survey by name for responding
 */
export const useRespondToSurveyQuery = (options?: Options<RespondToSurveyData>) =>
  useQuery(respondToSurveyOptions(options))

export const submitSurveyResponseCallbackMutationKey = (
  options?: Partial<Options<SubmitSurveyResponseCallbackData>>
) => createMutationKey('submitSurveyResponseCallback', options)

/**
 * submit survey response
 */
export const submitSurveyResponseCallbackMutation = (
  options?: Partial<Options<SubmitSurveyResponseCallbackData>>
): UseMutationOptions<
  SubmitSurveyResponseCallbackResponse,
  SubmitSurveyResponseCallbackError,
  Options<SubmitSurveyResponseCallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitSurveyResponseCallbackResponse,
    SubmitSurveyResponseCallbackError,
    Options<SubmitSurveyResponseCallbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitSurveyResponseCallback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: submitSurveyResponseCallbackMutationKey(options),
  }
  return mutationOptions
}

/**
 * submit survey response
 */
export const useSubmitSurveyResponseCallbackMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SubmitSurveyResponseCallbackResponse,
        SubmitSurveyResponseCallbackError,
        Options<SubmitSurveyResponseCallbackData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...submitSurveyResponseCallbackMutation(), ...mutationOptions })

export const taskInsuranceVerificationContextQueryKey = (
  options: Options<TaskInsuranceVerificationContextData>
) => createQueryKey('taskInsuranceVerificationContext', options)

/**
 * get insurance verification context for a task
 */
export const taskInsuranceVerificationContextOptions = (
  options: Options<TaskInsuranceVerificationContextData>
) =>
  queryOptions<
    TaskInsuranceVerificationContextResponse,
    TaskInsuranceVerificationContextError,
    TaskInsuranceVerificationContextResponse,
    ReturnType<typeof taskInsuranceVerificationContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskInsuranceVerificationContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: taskInsuranceVerificationContextQueryKey(options),
  })

/**
 * get insurance verification context for a task
 */
export const useTaskInsuranceVerificationContextQuery = (
  options: Options<TaskInsuranceVerificationContextData>
) => useQuery(taskInsuranceVerificationContextOptions(options))

export const taskResolveVerifyInsuranceMutationKey = (
  options?: Partial<Options<TaskResolveVerifyInsuranceData>>
) => createMutationKey('taskResolveVerifyInsurance', options)

/**
 * resolve a verify-insurance task
 */
export const taskResolveVerifyInsuranceMutation = (
  options?: Partial<Options<TaskResolveVerifyInsuranceData>>
): UseMutationOptions<
  TaskResolveVerifyInsuranceResponse,
  TaskResolveVerifyInsuranceError,
  Options<TaskResolveVerifyInsuranceData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskResolveVerifyInsuranceResponse,
    TaskResolveVerifyInsuranceError,
    Options<TaskResolveVerifyInsuranceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await taskResolveVerifyInsurance({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: taskResolveVerifyInsuranceMutationKey(options),
  }
  return mutationOptions
}

/**
 * resolve a verify-insurance task
 */
export const useTaskResolveVerifyInsuranceMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        TaskResolveVerifyInsuranceResponse,
        TaskResolveVerifyInsuranceError,
        Options<TaskResolveVerifyInsuranceData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...taskResolveVerifyInsuranceMutation(), ...mutationOptions })

export const taskResolveMedicaidMcoMappingMutationKey = (
  options?: Partial<Options<TaskResolveMedicaidMcoMappingData>>
) => createMutationKey('taskResolveMedicaidMcoMapping', options)

/**
 * resolve a Medicaid MCO Mapping task
 */
export const taskResolveMedicaidMcoMappingMutation = (
  options?: Partial<Options<TaskResolveMedicaidMcoMappingData>>
): UseMutationOptions<
  TaskResolveMedicaidMcoMappingResponse,
  TaskResolveMedicaidMcoMappingError,
  Options<TaskResolveMedicaidMcoMappingData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskResolveMedicaidMcoMappingResponse,
    TaskResolveMedicaidMcoMappingError,
    Options<TaskResolveMedicaidMcoMappingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await taskResolveMedicaidMcoMapping({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: taskResolveMedicaidMcoMappingMutationKey(options),
  }
  return mutationOptions
}

/**
 * resolve a Medicaid MCO Mapping task
 */
export const useTaskResolveMedicaidMcoMappingMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        TaskResolveMedicaidMcoMappingResponse,
        TaskResolveMedicaidMcoMappingError,
        Options<TaskResolveMedicaidMcoMappingData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...taskResolveMedicaidMcoMappingMutation(), ...mutationOptions })

export const tasksQueryKey = (options?: Options<TasksData>) => createQueryKey('tasks', options)

/**
 * list tasks
 */
export const tasksOptions = (options?: Options<TasksData>) =>
  queryOptions<TasksResponse2, DefaultError, TasksResponse2, ReturnType<typeof tasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: tasksQueryKey(options),
  })

export const tasksInfiniteQueryKey = (options?: Options<TasksData>): QueryKey<Options<TasksData>> =>
  createQueryKey('tasks', options, true)

/**
 * list tasks
 */
export const tasksInfiniteOptions = (options?: Options<TasksData>) =>
  infiniteQueryOptions<
    TasksResponse2,
    DefaultError,
    InfiniteData<TasksResponse2>,
    QueryKey<Options<TasksData>>,
    number | Pick<QueryKey<Options<TasksData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<QueryKey<Options<TasksData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await tasks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: tasksInfiniteQueryKey(options),
    }
  )

/**
 * list tasks
 */
export const useTasksQuery = (options?: Options<TasksData>) => useQuery(tasksOptions(options))

export const myTasksQueryKey = (options?: Options<MyTasksData>) =>
  createQueryKey('myTasks', options)

/**
 * get my tasks
 */
export const myTasksOptions = (options?: Options<MyTasksData>) =>
  queryOptions<MyTasksResponse, MyTasksError, MyTasksResponse, ReturnType<typeof myTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await myTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: myTasksQueryKey(options),
  })

export const myTasksInfiniteQueryKey = (
  options?: Options<MyTasksData>
): QueryKey<Options<MyTasksData>> => createQueryKey('myTasks', options, true)

/**
 * get my tasks
 */
export const myTasksInfiniteOptions = (options?: Options<MyTasksData>) =>
  infiniteQueryOptions<
    MyTasksResponse,
    MyTasksError,
    InfiniteData<MyTasksResponse>,
    QueryKey<Options<MyTasksData>>,
    number | Pick<QueryKey<Options<MyTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-expect-error
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-expect-error
        const page: Pick<QueryKey<Options<MyTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await myTasks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: myTasksInfiniteQueryKey(options),
    }
  )

/**
 * get my tasks
 */
export const useMyTasksQuery = (options?: Options<MyTasksData>) => useQuery(myTasksOptions(options))

export const taskByIdQueryKey = (options: Options<TaskByIdData>) =>
  createQueryKey('taskById', options)

/**
 * get task
 */
export const taskByIdOptions = (options: Options<TaskByIdData>) =>
  queryOptions<
    TaskByIdResponse,
    DefaultError,
    TaskByIdResponse,
    ReturnType<typeof taskByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: taskByIdQueryKey(options),
  })

/**
 * get task
 */
export const useTaskByIdQuery = (options: Options<TaskByIdData>) =>
  useQuery(taskByIdOptions(options))

export const claimTaskMutationKey = (options?: Partial<Options<ClaimTaskData>>) =>
  createMutationKey('claimTask', options)

/**
 * start a task
 */
export const claimTaskMutation = (
  options?: Partial<Options<ClaimTaskData>>
): UseMutationOptions<ClaimTaskResponse, ClaimTaskError, Options<ClaimTaskData>> => {
  const mutationOptions: UseMutationOptions<
    ClaimTaskResponse,
    ClaimTaskError,
    Options<ClaimTaskData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await claimTask({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: claimTaskMutationKey(options),
  }
  return mutationOptions
}

/**
 * start a task
 */
export const useClaimTaskMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<ClaimTaskResponse, ClaimTaskError, Options<ClaimTaskData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...claimTaskMutation(), ...mutationOptions })

export const releaseTaskMutationKey = (options?: Partial<Options<ReleaseTaskData>>) =>
  createMutationKey('releaseTask', options)

/**
 * release a task
 */
export const releaseTaskMutation = (
  options?: Partial<Options<ReleaseTaskData>>
): UseMutationOptions<ReleaseTaskResponse, ReleaseTaskError, Options<ReleaseTaskData>> => {
  const mutationOptions: UseMutationOptions<
    ReleaseTaskResponse,
    ReleaseTaskError,
    Options<ReleaseTaskData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await releaseTask({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: releaseTaskMutationKey(options),
  }
  return mutationOptions
}

/**
 * release a task
 */
export const useReleaseTaskMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<ReleaseTaskResponse, ReleaseTaskError, Options<ReleaseTaskData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...releaseTaskMutation(), ...mutationOptions })

export const assignTaskMutationKey = (options?: Partial<Options<AssignTaskData>>) =>
  createMutationKey('assignTask', options)

/**
 * assign a task
 */
export const assignTaskMutation = (
  options?: Partial<Options<AssignTaskData>>
): UseMutationOptions<AssignTaskResponse, AssignTaskError, Options<AssignTaskData>> => {
  const mutationOptions: UseMutationOptions<
    AssignTaskResponse,
    AssignTaskError,
    Options<AssignTaskData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assignTask({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: assignTaskMutationKey(options),
  }
  return mutationOptions
}

/**
 * assign a task
 */
export const useAssignTaskMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<AssignTaskResponse, AssignTaskError, Options<AssignTaskData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...assignTaskMutation(), ...mutationOptions })

export const recordJointConsentTaskEscalationOutcomeMutationKey = (
  options?: Partial<Options<RecordJointConsentTaskEscalationOutcomeData>>
) => createMutationKey('recordJointConsentTaskEscalationOutcome', options)

/**
 * record a joint consent escalation outcome
 */
export const recordJointConsentTaskEscalationOutcomeMutation = (
  options?: Partial<Options<RecordJointConsentTaskEscalationOutcomeData>>
): UseMutationOptions<
  RecordJointConsentTaskEscalationOutcomeResponse,
  RecordJointConsentTaskEscalationOutcomeError,
  Options<RecordJointConsentTaskEscalationOutcomeData>
> => {
  const mutationOptions: UseMutationOptions<
    RecordJointConsentTaskEscalationOutcomeResponse,
    RecordJointConsentTaskEscalationOutcomeError,
    Options<RecordJointConsentTaskEscalationOutcomeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordJointConsentTaskEscalationOutcome({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: recordJointConsentTaskEscalationOutcomeMutationKey(options),
  }
  return mutationOptions
}

/**
 * record a joint consent escalation outcome
 */
export const useRecordJointConsentTaskEscalationOutcomeMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RecordJointConsentTaskEscalationOutcomeResponse,
        RecordJointConsentTaskEscalationOutcomeError,
        Options<RecordJointConsentTaskEscalationOutcomeData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...recordJointConsentTaskEscalationOutcomeMutation(), ...mutationOptions })

export const taskScheduleIntakeContextQueryKey = (
  options: Options<TaskScheduleIntakeContextData>
) => createQueryKey('taskScheduleIntakeContext', options)

/**
 * get schedule intake context for a task
 */
export const taskScheduleIntakeContextOptions = (options: Options<TaskScheduleIntakeContextData>) =>
  queryOptions<
    TaskScheduleIntakeContextResponse,
    TaskScheduleIntakeContextError,
    TaskScheduleIntakeContextResponse,
    ReturnType<typeof taskScheduleIntakeContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskScheduleIntakeContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: taskScheduleIntakeContextQueryKey(options),
  })

/**
 * get schedule intake context for a task
 */
export const useTaskScheduleIntakeContextQuery = (
  options: Options<TaskScheduleIntakeContextData>
) => useQuery(taskScheduleIntakeContextOptions(options))

export const taskReassignmentSchedulingContextQueryKey = (
  options: Options<TaskReassignmentSchedulingContextData>
) => createQueryKey('taskReassignmentSchedulingContext', options)

/**
 * get reassignment scheduling context for a task
 */
export const taskReassignmentSchedulingContextOptions = (
  options: Options<TaskReassignmentSchedulingContextData>
) =>
  queryOptions<
    TaskReassignmentSchedulingContextResponse,
    TaskReassignmentSchedulingContextError,
    TaskReassignmentSchedulingContextResponse,
    ReturnType<typeof taskReassignmentSchedulingContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskReassignmentSchedulingContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: taskReassignmentSchedulingContextQueryKey(options),
  })

/**
 * get reassignment scheduling context for a task
 */
export const useTaskReassignmentSchedulingContextQuery = (
  options: Options<TaskReassignmentSchedulingContextData>
) => useQuery(taskReassignmentSchedulingContextOptions(options))

export const taskSchedulingContextQueryKey = (options: Options<TaskSchedulingContextData>) =>
  createQueryKey('taskSchedulingContext', options)

/**
 * get scheduling context for a task
 */
export const taskSchedulingContextOptions = (options: Options<TaskSchedulingContextData>) =>
  queryOptions<
    TaskSchedulingContextResponse,
    TaskSchedulingContextError,
    TaskSchedulingContextResponse,
    ReturnType<typeof taskSchedulingContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskSchedulingContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: taskSchedulingContextQueryKey(options),
  })

/**
 * get scheduling context for a task
 */
export const useTaskSchedulingContextQuery = (options: Options<TaskSchedulingContextData>) =>
  useQuery(taskSchedulingContextOptions(options))

export const completeTaskMutationKey = (options?: Partial<Options<CompleteTaskData>>) =>
  createMutationKey('completeTask', options)

/**
 * complete a task
 */
export const completeTaskMutation = (
  options?: Partial<Options<CompleteTaskData>>
): UseMutationOptions<CompleteTaskResponse, CompleteTaskError, Options<CompleteTaskData>> => {
  const mutationOptions: UseMutationOptions<
    CompleteTaskResponse,
    CompleteTaskError,
    Options<CompleteTaskData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeTask({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: completeTaskMutationKey(options),
  }
  return mutationOptions
}

/**
 * complete a task
 */
export const useCompleteTaskMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<CompleteTaskResponse, CompleteTaskError, Options<CompleteTaskData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...completeTaskMutation(), ...mutationOptions })

export const reauthorizationReviewContextQueryKey = (
  options: Options<ReauthorizationReviewContextData>
) => createQueryKey('reauthorizationReviewContext', options)

/**
 * get reauthorization review context for a task
 */
export const reauthorizationReviewContextOptions = (
  options: Options<ReauthorizationReviewContextData>
) =>
  queryOptions<
    ReauthorizationReviewContextResponse,
    ReauthorizationReviewContextError,
    ReauthorizationReviewContextResponse,
    ReturnType<typeof reauthorizationReviewContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reauthorizationReviewContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: reauthorizationReviewContextQueryKey(options),
  })

/**
 * get reauthorization review context for a task
 */
export const useReauthorizationReviewContextQuery = (
  options: Options<ReauthorizationReviewContextData>
) => useQuery(reauthorizationReviewContextOptions(options))

export const decideClinicalReauthorizationMutationKey = (
  options?: Partial<Options<DecideClinicalReauthorizationData>>
) => createMutationKey('decideClinicalReauthorization', options)

/**
 * record a clinical supervisor's approve/deny decision on a reauthorization
 */
export const decideClinicalReauthorizationMutation = (
  options?: Partial<Options<DecideClinicalReauthorizationData>>
): UseMutationOptions<
  DecideClinicalReauthorizationResponse,
  DecideClinicalReauthorizationError,
  Options<DecideClinicalReauthorizationData>
> => {
  const mutationOptions: UseMutationOptions<
    DecideClinicalReauthorizationResponse,
    DecideClinicalReauthorizationError,
    Options<DecideClinicalReauthorizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await decideClinicalReauthorization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: decideClinicalReauthorizationMutationKey(options),
  }
  return mutationOptions
}

/**
 * record a clinical supervisor's approve/deny decision on a reauthorization
 */
export const useDecideClinicalReauthorizationMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DecideClinicalReauthorizationResponse,
        DecideClinicalReauthorizationError,
        Options<DecideClinicalReauthorizationData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...decideClinicalReauthorizationMutation(), ...mutationOptions })

export const taskEventsQueryKey = (options: Options<TaskEventsData>) =>
  createQueryKey('taskEvents', options)

/**
 * list task events (history)
 */
export const taskEventsOptions = (options: Options<TaskEventsData>) =>
  queryOptions<
    TaskEventsResponse,
    TaskEventsError,
    TaskEventsResponse,
    ReturnType<typeof taskEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: taskEventsQueryKey(options),
  })

/**
 * list task events (history)
 */
export const useTaskEventsQuery = (options: Options<TaskEventsData>) =>
  useQuery(taskEventsOptions(options))

export const createTaskNoteMutationKey = (options?: Partial<Options<CreateTaskNoteData>>) =>
  createMutationKey('createTaskNote', options)

/**
 * add a note to a task
 */
export const createTaskNoteMutation = (
  options?: Partial<Options<CreateTaskNoteData>>
): UseMutationOptions<CreateTaskNoteResponse, CreateTaskNoteError, Options<CreateTaskNoteData>> => {
  const mutationOptions: UseMutationOptions<
    CreateTaskNoteResponse,
    CreateTaskNoteError,
    Options<CreateTaskNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTaskNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createTaskNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * add a note to a task
 */
export const useCreateTaskNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<CreateTaskNoteResponse, CreateTaskNoteError, Options<CreateTaskNoteData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...createTaskNoteMutation(), ...mutationOptions })

export const createReferrerTourCompletionMutationKey = (
  options?: Partial<Options<CreateReferrerTourCompletionData>>
) => createMutationKey('createReferrerTourCompletion', options)

/**
 * mark the first-login onboarding tour as finished
 */
export const createReferrerTourCompletionMutation = (
  options?: Partial<Options<CreateReferrerTourCompletionData>>
): UseMutationOptions<unknown, DefaultError, Options<CreateReferrerTourCompletionData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<CreateReferrerTourCompletionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createReferrerTourCompletion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createReferrerTourCompletionMutationKey(options),
  }
  return mutationOptions
}

/**
 * mark the first-login onboarding tour as finished
 */
export const useCreateReferrerTourCompletionMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<unknown, DefaultError, Options<CreateReferrerTourCompletionData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...createReferrerTourCompletionMutation(), ...mutationOptions })

export const usersQueryKey = (options?: Options<UsersData>) => createQueryKey('users', options)

/**
 * list internal users
 */
export const usersOptions = (options?: Options<UsersData>) =>
  queryOptions<UsersResponse, UsersError, UsersResponse, ReturnType<typeof usersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await users({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: usersQueryKey(options),
  })

/**
 * list internal users
 */
export const useUsersQuery = (options?: Options<UsersData>) => useQuery(usersOptions(options))

export const currentUserQueryKey = (options?: Options<CurrentUserData>) =>
  createQueryKey('currentUser', options)

/**
 * get current user information
 */
export const currentUserOptions = (options?: Options<CurrentUserData>) =>
  queryOptions<
    CurrentUserResponse2,
    CurrentUserError,
    CurrentUserResponse2,
    ReturnType<typeof currentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: currentUserQueryKey(options),
  })

/**
 * get current user information
 */
export const useCurrentUserQuery = (options?: Options<CurrentUserData>) =>
  useQuery(currentUserOptions(options))

export const currentUserProfileQueryKey = (options?: Options<CurrentUserProfileData>) =>
  createQueryKey('currentUserProfile', options)

/**
 * get current user profile fields
 *
 * Returns first_name, last_name, email, phone_number, and title for the signed-in user. Used to pre-fill contact cards (e.g. the referral wizard's school emergency contact step).
 */
export const currentUserProfileOptions = (options?: Options<CurrentUserProfileData>) =>
  queryOptions<
    CurrentUserProfileResponse,
    CurrentUserProfileError,
    CurrentUserProfileResponse,
    ReturnType<typeof currentUserProfileQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currentUserProfile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: currentUserProfileQueryKey(options),
  })

/**
 * get current user profile fields
 *
 * Returns first_name, last_name, email, phone_number, and title for the signed-in user. Used to pre-fill contact cards (e.g. the referral wizard's school emergency contact step).
 */
export const useCurrentUserProfileQuery = (options?: Options<CurrentUserProfileData>) =>
  useQuery(currentUserProfileOptions(options))

export const getCurrentClientQueryKey = (options?: Options<GetCurrentClientData>) =>
  createQueryKey('getCurrentClient', options)

/**
 * get current verified client information
 *
 * Returns the current verified client from the session. Used by client-facing pages to check verification status.
 */
export const getCurrentClientOptions = (options?: Options<GetCurrentClientData>) =>
  queryOptions<
    GetCurrentClientResponse,
    GetCurrentClientError,
    GetCurrentClientResponse,
    ReturnType<typeof getCurrentClientQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentClient({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCurrentClientQueryKey(options),
  })

/**
 * get current verified client information
 *
 * Returns the current verified client from the session. Used by client-facing pages to check verification status.
 */
export const useGetCurrentClientQuery = (options?: Options<GetCurrentClientData>) =>
  useQuery(getCurrentClientOptions(options))

export const verifyClientMutationKey = (options?: Partial<Options<VerifyClientData>>) =>
  createMutationKey('verifyClient', options)

/**
 * Verify client identity
 *
 * Verify client identity using personal details. Sets client session on success.
 */
export const verifyClientMutation = (
  options?: Partial<Options<VerifyClientData>>
): UseMutationOptions<VerifyClientResponse, VerifyClientError, Options<VerifyClientData>> => {
  const mutationOptions: UseMutationOptions<
    VerifyClientResponse,
    VerifyClientError,
    Options<VerifyClientData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyClient({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: verifyClientMutationKey(options),
  }
  return mutationOptions
}

/**
 * Verify client identity
 *
 * Verify client identity using personal details. Sets client session on success.
 */
export const useVerifyClientMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<VerifyClientResponse, VerifyClientError, Options<VerifyClientData>>,
      'mutationFn'
    >
  >
) => useMutation({ ...verifyClientMutation(), ...mutationOptions })

export const updateUserPhoneNumberMutationKey = (
  options?: Partial<Options<UpdateUserPhoneNumberData>>
) => createMutationKey('updateUserPhoneNumber', options)

/**
 * update a user's phone number
 *
 * Updates a single user's phone number — used by the 'Save to profile' prompt when assigning a school referral contact who has no phone on file. Admins and program managers for any user, district admins for users within their own district, or a user updating their own phone number.
 */
export const updateUserPhoneNumberMutation = (
  options?: Partial<Options<UpdateUserPhoneNumberData>>
): UseMutationOptions<
  UpdateUserPhoneNumberResponse,
  UpdateUserPhoneNumberError,
  Options<UpdateUserPhoneNumberData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateUserPhoneNumberResponse,
    UpdateUserPhoneNumberError,
    Options<UpdateUserPhoneNumberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUserPhoneNumber({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateUserPhoneNumberMutationKey(options),
  }
  return mutationOptions
}

/**
 * update a user's phone number
 *
 * Updates a single user's phone number — used by the 'Save to profile' prompt when assigning a school referral contact who has no phone on file. Admins and program managers for any user, district admins for users within their own district, or a user updating their own phone number.
 */
export const useUpdateUserPhoneNumberMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateUserPhoneNumberResponse,
        UpdateUserPhoneNumberError,
        Options<UpdateUserPhoneNumberData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateUserPhoneNumberMutation(), ...mutationOptions })

export const wheelhouseClaimsQueryKey = (options?: Options<WheelhouseClaimsData>) =>
  createQueryKey('wheelhouseClaims', options)

/**
 * list claims pending review
 */
export const wheelhouseClaimsOptions = (options?: Options<WheelhouseClaimsData>) =>
  queryOptions<
    WheelhouseClaimsResponse,
    DefaultError,
    WheelhouseClaimsResponse,
    ReturnType<typeof wheelhouseClaimsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseClaims({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseClaimsQueryKey(options),
  })

/**
 * list claims pending review
 */
export const useWheelhouseClaimsQuery = (options?: Options<WheelhouseClaimsData>) =>
  useQuery(wheelhouseClaimsOptions(options))

export const wheelhouseClaimQueryKey = (options: Options<WheelhouseClaimData>) =>
  createQueryKey('wheelhouseClaim', options)

/**
 * fetch a claim
 */
export const wheelhouseClaimOptions = (options: Options<WheelhouseClaimData>) =>
  queryOptions<
    WheelhouseClaimResponse,
    DefaultError,
    WheelhouseClaimResponse,
    ReturnType<typeof wheelhouseClaimQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseClaim({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseClaimQueryKey(options),
  })

/**
 * fetch a claim
 */
export const useWheelhouseClaimQuery = (options: Options<WheelhouseClaimData>) =>
  useQuery(wheelhouseClaimOptions(options))

export const updateWheelhouseClaimMutationKey = (
  options?: Partial<Options<UpdateWheelhouseClaimData>>
) => createMutationKey('updateWheelhouseClaim', options)

/**
 * edit a claim's service fields
 */
export const updateWheelhouseClaimMutation = (
  options?: Partial<Options<UpdateWheelhouseClaimData>>
): UseMutationOptions<
  UpdateWheelhouseClaimResponse,
  DefaultError,
  Options<UpdateWheelhouseClaimData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseClaimResponse,
    DefaultError,
    Options<UpdateWheelhouseClaimData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseClaim({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseClaimMutationKey(options),
  }
  return mutationOptions
}

/**
 * edit a claim's service fields
 */
export const useUpdateWheelhouseClaimMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseClaimResponse,
        DefaultError,
        Options<UpdateWheelhouseClaimData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseClaimMutation(), ...mutationOptions })

export const signWheelhouseClaimMutationKey = (
  options?: Partial<Options<SignWheelhouseClaimData>>
) => createMutationKey('signWheelhouseClaim', options)

/**
 * sign and submit a claim
 */
export const signWheelhouseClaimMutation = (
  options?: Partial<Options<SignWheelhouseClaimData>>
): UseMutationOptions<
  SignWheelhouseClaimResponse,
  SignWheelhouseClaimError,
  Options<SignWheelhouseClaimData>
> => {
  const mutationOptions: UseMutationOptions<
    SignWheelhouseClaimResponse,
    SignWheelhouseClaimError,
    Options<SignWheelhouseClaimData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await signWheelhouseClaim({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: signWheelhouseClaimMutationKey(options),
  }
  return mutationOptions
}

/**
 * sign and submit a claim
 */
export const useSignWheelhouseClaimMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        SignWheelhouseClaimResponse,
        SignWheelhouseClaimError,
        Options<SignWheelhouseClaimData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...signWheelhouseClaimMutation(), ...mutationOptions })

export const rejectWheelhouseClaimMutationKey = (
  options?: Partial<Options<RejectWheelhouseClaimData>>
) => createMutationKey('rejectWheelhouseClaim', options)

/**
 * skip (reject) a claim
 */
export const rejectWheelhouseClaimMutation = (
  options?: Partial<Options<RejectWheelhouseClaimData>>
): UseMutationOptions<
  RejectWheelhouseClaimResponse,
  DefaultError,
  Options<RejectWheelhouseClaimData>
> => {
  const mutationOptions: UseMutationOptions<
    RejectWheelhouseClaimResponse,
    DefaultError,
    Options<RejectWheelhouseClaimData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await rejectWheelhouseClaim({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: rejectWheelhouseClaimMutationKey(options),
  }
  return mutationOptions
}

/**
 * skip (reject) a claim
 */
export const useRejectWheelhouseClaimMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        RejectWheelhouseClaimResponse,
        DefaultError,
        Options<RejectWheelhouseClaimData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...rejectWheelhouseClaimMutation(), ...mutationOptions })

export const wheelhouseClientsQueryKey = (options?: Options<WheelhouseClientsData>) =>
  createQueryKey('wheelhouseClients', options)

/**
 * list the provider's students
 */
export const wheelhouseClientsOptions = (options?: Options<WheelhouseClientsData>) =>
  queryOptions<
    WheelhouseClientsResponse,
    WheelhouseClientsError,
    WheelhouseClientsResponse,
    ReturnType<typeof wheelhouseClientsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseClients({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseClientsQueryKey(options),
  })

/**
 * list the provider's students
 */
export const useWheelhouseClientsQuery = (options?: Options<WheelhouseClientsData>) =>
  useQuery(wheelhouseClientsOptions(options))

export const wheelhouseClientQueryKey = (options: Options<WheelhouseClientData>) =>
  createQueryKey('wheelhouseClient', options)

/**
 * show a single student's detail record
 */
export const wheelhouseClientOptions = (options: Options<WheelhouseClientData>) =>
  queryOptions<
    WheelhouseClientResponse,
    WheelhouseClientError,
    WheelhouseClientResponse,
    ReturnType<typeof wheelhouseClientQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseClient({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseClientQueryKey(options),
  })

/**
 * show a single student's detail record
 */
export const useWheelhouseClientQuery = (options: Options<WheelhouseClientData>) =>
  useQuery(wheelhouseClientOptions(options))

export const wheelhouseClientDocumentsQueryKey = (
  options: Options<WheelhouseClientDocumentsData>
) => createQueryKey('wheelhouseClientDocuments', options)

/**
 * list a student's documents
 */
export const wheelhouseClientDocumentsOptions = (options: Options<WheelhouseClientDocumentsData>) =>
  queryOptions<
    WheelhouseClientDocumentsResponse,
    WheelhouseClientDocumentsError,
    WheelhouseClientDocumentsResponse,
    ReturnType<typeof wheelhouseClientDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseClientDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseClientDocumentsQueryKey(options),
  })

/**
 * list a student's documents
 */
export const useWheelhouseClientDocumentsQuery = (
  options: Options<WheelhouseClientDocumentsData>
) => useQuery(wheelhouseClientDocumentsOptions(options))

export const createWheelhouseDocumentMutationKey = (
  options?: Partial<Options<CreateWheelhouseDocumentData>>
) => createMutationKey('createWheelhouseDocument', options)

/**
 * request a document
 */
export const createWheelhouseDocumentMutation = (
  options?: Partial<Options<CreateWheelhouseDocumentData>>
): UseMutationOptions<
  CreateWheelhouseDocumentResponse,
  CreateWheelhouseDocumentError,
  Options<CreateWheelhouseDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWheelhouseDocumentResponse,
    CreateWheelhouseDocumentError,
    Options<CreateWheelhouseDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWheelhouseDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createWheelhouseDocumentMutationKey(options),
  }
  return mutationOptions
}

/**
 * request a document
 */
export const useCreateWheelhouseDocumentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateWheelhouseDocumentResponse,
        CreateWheelhouseDocumentError,
        Options<CreateWheelhouseDocumentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createWheelhouseDocumentMutation(), ...mutationOptions })

export const wheelhouseDocumentQueryKey = (options: Options<WheelhouseDocumentData>) =>
  createQueryKey('wheelhouseDocument', options)

/**
 * fetch a document
 */
export const wheelhouseDocumentOptions = (options: Options<WheelhouseDocumentData>) =>
  queryOptions<
    WheelhouseDocumentResponse,
    WheelhouseDocumentError,
    WheelhouseDocumentResponse,
    ReturnType<typeof wheelhouseDocumentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseDocumentQueryKey(options),
  })

/**
 * fetch a document
 */
export const useWheelhouseDocumentQuery = (options: Options<WheelhouseDocumentData>) =>
  useQuery(wheelhouseDocumentOptions(options))

export const updateWheelhouseDocumentMutationKey = (
  options?: Partial<Options<UpdateWheelhouseDocumentData>>
) => createMutationKey('updateWheelhouseDocument', options)

/**
 * edit a generated document
 */
export const updateWheelhouseDocumentMutation = (
  options?: Partial<Options<UpdateWheelhouseDocumentData>>
): UseMutationOptions<
  UpdateWheelhouseDocumentResponse,
  UpdateWheelhouseDocumentError,
  Options<UpdateWheelhouseDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseDocumentResponse,
    UpdateWheelhouseDocumentError,
    Options<UpdateWheelhouseDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseDocumentMutationKey(options),
  }
  return mutationOptions
}

/**
 * edit a generated document
 */
export const useUpdateWheelhouseDocumentMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseDocumentResponse,
        UpdateWheelhouseDocumentError,
        Options<UpdateWheelhouseDocumentData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseDocumentMutation(), ...mutationOptions })

export const wheelhouseEncountersQueryKey = (options?: Options<WheelhouseEncountersData>) =>
  createQueryKey('wheelhouseEncounters', options)

/**
 * list the provider's encounters
 */
export const wheelhouseEncountersOptions = (options?: Options<WheelhouseEncountersData>) =>
  queryOptions<
    WheelhouseEncountersResponse,
    WheelhouseEncountersError,
    WheelhouseEncountersResponse,
    ReturnType<typeof wheelhouseEncountersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseEncounters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseEncountersQueryKey(options),
  })

/**
 * list the provider's encounters
 */
export const useWheelhouseEncountersQuery = (options?: Options<WheelhouseEncountersData>) =>
  useQuery(wheelhouseEncountersOptions(options))

export const createWheelhouseEncounterMutationKey = (
  options?: Partial<Options<CreateWheelhouseEncounterData>>
) => createMutationKey('createWheelhouseEncounter', options)

/**
 * start a session (encounter + draft note)
 */
export const createWheelhouseEncounterMutation = (
  options?: Partial<Options<CreateWheelhouseEncounterData>>
): UseMutationOptions<
  CreateWheelhouseEncounterResponse,
  CreateWheelhouseEncounterError,
  Options<CreateWheelhouseEncounterData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWheelhouseEncounterResponse,
    CreateWheelhouseEncounterError,
    Options<CreateWheelhouseEncounterData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWheelhouseEncounter({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createWheelhouseEncounterMutationKey(options),
  }
  return mutationOptions
}

/**
 * start a session (encounter + draft note)
 */
export const useCreateWheelhouseEncounterMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateWheelhouseEncounterResponse,
        CreateWheelhouseEncounterError,
        Options<CreateWheelhouseEncounterData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createWheelhouseEncounterMutation(), ...mutationOptions })

export const wheelhouseEncounterQueryKey = (options: Options<WheelhouseEncounterData>) =>
  createQueryKey('wheelhouseEncounter', options)

/**
 * show an encounter with its note
 */
export const wheelhouseEncounterOptions = (options: Options<WheelhouseEncounterData>) =>
  queryOptions<
    WheelhouseEncounterResponse,
    WheelhouseEncounterError,
    WheelhouseEncounterResponse,
    ReturnType<typeof wheelhouseEncounterQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseEncounter({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseEncounterQueryKey(options),
  })

/**
 * show an encounter with its note
 */
export const useWheelhouseEncounterQuery = (options: Options<WheelhouseEncounterData>) =>
  useQuery(wheelhouseEncounterOptions(options))

export const updateWheelhouseEncounterMutationKey = (
  options?: Partial<Options<UpdateWheelhouseEncounterData>>
) => createMutationKey('updateWheelhouseEncounter', options)

/**
 * autosave session metadata
 */
export const updateWheelhouseEncounterMutation = (
  options?: Partial<Options<UpdateWheelhouseEncounterData>>
): UseMutationOptions<
  UpdateWheelhouseEncounterResponse,
  UpdateWheelhouseEncounterError,
  Options<UpdateWheelhouseEncounterData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseEncounterResponse,
    UpdateWheelhouseEncounterError,
    Options<UpdateWheelhouseEncounterData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseEncounter({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseEncounterMutationKey(options),
  }
  return mutationOptions
}

/**
 * autosave session metadata
 */
export const useUpdateWheelhouseEncounterMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseEncounterResponse,
        UpdateWheelhouseEncounterError,
        Options<UpdateWheelhouseEncounterData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseEncounterMutation(), ...mutationOptions })

export const enhanceWheelhouseNoteMutationKey = (
  options?: Partial<Options<EnhanceWheelhouseNoteData>>
) => createMutationKey('enhanceWheelhouseNote', options)

/**
 * enhance the draft note into a SOAP suggestion with AI
 */
export const enhanceWheelhouseNoteMutation = (
  options?: Partial<Options<EnhanceWheelhouseNoteData>>
): UseMutationOptions<
  EnhanceWheelhouseNoteResponse,
  EnhanceWheelhouseNoteError,
  Options<EnhanceWheelhouseNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    EnhanceWheelhouseNoteResponse,
    EnhanceWheelhouseNoteError,
    Options<EnhanceWheelhouseNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await enhanceWheelhouseNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: enhanceWheelhouseNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * enhance the draft note into a SOAP suggestion with AI
 */
export const useEnhanceWheelhouseNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        EnhanceWheelhouseNoteResponse,
        EnhanceWheelhouseNoteError,
        Options<EnhanceWheelhouseNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...enhanceWheelhouseNoteMutation(), ...mutationOptions })

export const wheelhouseGoalObservationsQueryKey = (
  options: Options<WheelhouseGoalObservationsData>
) => createQueryKey('wheelhouseGoalObservations', options)

/**
 * list observations for a goal
 */
export const wheelhouseGoalObservationsOptions = (
  options: Options<WheelhouseGoalObservationsData>
) =>
  queryOptions<
    WheelhouseGoalObservationsResponse,
    DefaultError,
    WheelhouseGoalObservationsResponse,
    ReturnType<typeof wheelhouseGoalObservationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseGoalObservations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseGoalObservationsQueryKey(options),
  })

/**
 * list observations for a goal
 */
export const useWheelhouseGoalObservationsQuery = (
  options: Options<WheelhouseGoalObservationsData>
) => useQuery(wheelhouseGoalObservationsOptions(options))

export const createWheelhouseGoalObservationMutationKey = (
  options?: Partial<Options<CreateWheelhouseGoalObservationData>>
) => createMutationKey('createWheelhouseGoalObservation', options)

/**
 * log an observation
 */
export const createWheelhouseGoalObservationMutation = (
  options?: Partial<Options<CreateWheelhouseGoalObservationData>>
): UseMutationOptions<
  CreateWheelhouseGoalObservationResponse,
  CreateWheelhouseGoalObservationError,
  Options<CreateWheelhouseGoalObservationData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWheelhouseGoalObservationResponse,
    CreateWheelhouseGoalObservationError,
    Options<CreateWheelhouseGoalObservationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWheelhouseGoalObservation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createWheelhouseGoalObservationMutationKey(options),
  }
  return mutationOptions
}

/**
 * log an observation
 */
export const useCreateWheelhouseGoalObservationMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateWheelhouseGoalObservationResponse,
        CreateWheelhouseGoalObservationError,
        Options<CreateWheelhouseGoalObservationData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createWheelhouseGoalObservationMutation(), ...mutationOptions })

export const updateWheelhouseGoalObservationMutationKey = (
  options?: Partial<Options<UpdateWheelhouseGoalObservationData>>
) => createMutationKey('updateWheelhouseGoalObservation', options)

/**
 * update an observation
 */
export const updateWheelhouseGoalObservationMutation = (
  options?: Partial<Options<UpdateWheelhouseGoalObservationData>>
): UseMutationOptions<
  UpdateWheelhouseGoalObservationResponse,
  UpdateWheelhouseGoalObservationError,
  Options<UpdateWheelhouseGoalObservationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseGoalObservationResponse,
    UpdateWheelhouseGoalObservationError,
    Options<UpdateWheelhouseGoalObservationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseGoalObservation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseGoalObservationMutationKey(options),
  }
  return mutationOptions
}

/**
 * update an observation
 */
export const useUpdateWheelhouseGoalObservationMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseGoalObservationResponse,
        UpdateWheelhouseGoalObservationError,
        Options<UpdateWheelhouseGoalObservationData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseGoalObservationMutation(), ...mutationOptions })

export const wheelhouseClientGoalsQueryKey = (options: Options<WheelhouseClientGoalsData>) =>
  createQueryKey('wheelhouseClientGoals', options)

/**
 * list a student's goals
 */
export const wheelhouseClientGoalsOptions = (options: Options<WheelhouseClientGoalsData>) =>
  queryOptions<
    WheelhouseClientGoalsResponse,
    DefaultError,
    WheelhouseClientGoalsResponse,
    ReturnType<typeof wheelhouseClientGoalsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseClientGoals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseClientGoalsQueryKey(options),
  })

/**
 * list a student's goals
 */
export const useWheelhouseClientGoalsQuery = (options: Options<WheelhouseClientGoalsData>) =>
  useQuery(wheelhouseClientGoalsOptions(options))

export const createWheelhouseGoalMutationKey = (
  options?: Partial<Options<CreateWheelhouseGoalData>>
) => createMutationKey('createWheelhouseGoal', options)

/**
 * create a goal
 */
export const createWheelhouseGoalMutation = (
  options?: Partial<Options<CreateWheelhouseGoalData>>
): UseMutationOptions<
  CreateWheelhouseGoalResponse,
  DefaultError,
  Options<CreateWheelhouseGoalData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWheelhouseGoalResponse,
    DefaultError,
    Options<CreateWheelhouseGoalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWheelhouseGoal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createWheelhouseGoalMutationKey(options),
  }
  return mutationOptions
}

/**
 * create a goal
 */
export const useCreateWheelhouseGoalMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateWheelhouseGoalResponse,
        DefaultError,
        Options<CreateWheelhouseGoalData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createWheelhouseGoalMutation(), ...mutationOptions })

export const wheelhouseGoalQueryKey = (options: Options<WheelhouseGoalData>) =>
  createQueryKey('wheelhouseGoal', options)

/**
 * fetch a goal
 */
export const wheelhouseGoalOptions = (options: Options<WheelhouseGoalData>) =>
  queryOptions<
    WheelhouseGoalResponse,
    WheelhouseGoalError,
    WheelhouseGoalResponse,
    ReturnType<typeof wheelhouseGoalQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseGoal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseGoalQueryKey(options),
  })

/**
 * fetch a goal
 */
export const useWheelhouseGoalQuery = (options: Options<WheelhouseGoalData>) =>
  useQuery(wheelhouseGoalOptions(options))

export const updateWheelhouseGoalMutationKey = (
  options?: Partial<Options<UpdateWheelhouseGoalData>>
) => createMutationKey('updateWheelhouseGoal', options)

/**
 * update a goal
 */
export const updateWheelhouseGoalMutation = (
  options?: Partial<Options<UpdateWheelhouseGoalData>>
): UseMutationOptions<
  UpdateWheelhouseGoalResponse,
  UpdateWheelhouseGoalError,
  Options<UpdateWheelhouseGoalData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseGoalResponse,
    UpdateWheelhouseGoalError,
    Options<UpdateWheelhouseGoalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseGoal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseGoalMutationKey(options),
  }
  return mutationOptions
}

/**
 * update a goal
 */
export const useUpdateWheelhouseGoalMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseGoalResponse,
        UpdateWheelhouseGoalError,
        Options<UpdateWheelhouseGoalData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseGoalMutation(), ...mutationOptions })

export const wheelhouseNoteTemplatesQueryKey = (options?: Options<WheelhouseNoteTemplatesData>) =>
  createQueryKey('wheelhouseNoteTemplates', options)

/**
 * list the provider's templates
 */
export const wheelhouseNoteTemplatesOptions = (options?: Options<WheelhouseNoteTemplatesData>) =>
  queryOptions<
    WheelhouseNoteTemplatesResponse,
    WheelhouseNoteTemplatesError,
    WheelhouseNoteTemplatesResponse,
    ReturnType<typeof wheelhouseNoteTemplatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseNoteTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseNoteTemplatesQueryKey(options),
  })

/**
 * list the provider's templates
 */
export const useWheelhouseNoteTemplatesQuery = (options?: Options<WheelhouseNoteTemplatesData>) =>
  useQuery(wheelhouseNoteTemplatesOptions(options))

export const createWheelhouseNoteTemplateMutationKey = (
  options?: Partial<Options<CreateWheelhouseNoteTemplateData>>
) => createMutationKey('createWheelhouseNoteTemplate', options)

/**
 * create a template
 */
export const createWheelhouseNoteTemplateMutation = (
  options?: Partial<Options<CreateWheelhouseNoteTemplateData>>
): UseMutationOptions<
  CreateWheelhouseNoteTemplateResponse,
  CreateWheelhouseNoteTemplateError,
  Options<CreateWheelhouseNoteTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWheelhouseNoteTemplateResponse,
    CreateWheelhouseNoteTemplateError,
    Options<CreateWheelhouseNoteTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWheelhouseNoteTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createWheelhouseNoteTemplateMutationKey(options),
  }
  return mutationOptions
}

/**
 * create a template
 */
export const useCreateWheelhouseNoteTemplateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateWheelhouseNoteTemplateResponse,
        CreateWheelhouseNoteTemplateError,
        Options<CreateWheelhouseNoteTemplateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createWheelhouseNoteTemplateMutation(), ...mutationOptions })

export const archiveWheelhouseNoteTemplateMutationKey = (
  options?: Partial<Options<ArchiveWheelhouseNoteTemplateData>>
) => createMutationKey('archiveWheelhouseNoteTemplate', options)

/**
 * archive (soft-delete) a template
 */
export const archiveWheelhouseNoteTemplateMutation = (
  options?: Partial<Options<ArchiveWheelhouseNoteTemplateData>>
): UseMutationOptions<
  ArchiveWheelhouseNoteTemplateResponse,
  DefaultError,
  Options<ArchiveWheelhouseNoteTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    ArchiveWheelhouseNoteTemplateResponse,
    DefaultError,
    Options<ArchiveWheelhouseNoteTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveWheelhouseNoteTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: archiveWheelhouseNoteTemplateMutationKey(options),
  }
  return mutationOptions
}

/**
 * archive (soft-delete) a template
 */
export const useArchiveWheelhouseNoteTemplateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        ArchiveWheelhouseNoteTemplateResponse,
        DefaultError,
        Options<ArchiveWheelhouseNoteTemplateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...archiveWheelhouseNoteTemplateMutation(), ...mutationOptions })

export const updateWheelhouseNoteTemplateMutationKey = (
  options?: Partial<Options<UpdateWheelhouseNoteTemplateData>>
) => createMutationKey('updateWheelhouseNoteTemplate', options)

/**
 * rename or edit a template
 */
export const updateWheelhouseNoteTemplateMutation = (
  options?: Partial<Options<UpdateWheelhouseNoteTemplateData>>
): UseMutationOptions<
  UpdateWheelhouseNoteTemplateResponse,
  UpdateWheelhouseNoteTemplateError,
  Options<UpdateWheelhouseNoteTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseNoteTemplateResponse,
    UpdateWheelhouseNoteTemplateError,
    Options<UpdateWheelhouseNoteTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseNoteTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseNoteTemplateMutationKey(options),
  }
  return mutationOptions
}

/**
 * rename or edit a template
 */
export const useUpdateWheelhouseNoteTemplateMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseNoteTemplateResponse,
        UpdateWheelhouseNoteTemplateError,
        Options<UpdateWheelhouseNoteTemplateData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseNoteTemplateMutation(), ...mutationOptions })

export const createWheelhouseNoteMutationKey = (
  options?: Partial<Options<CreateWheelhouseNoteData>>
) => createMutationKey('createWheelhouseNote', options)

/**
 * add a note to an encounter
 */
export const createWheelhouseNoteMutation = (
  options?: Partial<Options<CreateWheelhouseNoteData>>
): UseMutationOptions<
  CreateWheelhouseNoteResponse,
  CreateWheelhouseNoteError,
  Options<CreateWheelhouseNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWheelhouseNoteResponse,
    CreateWheelhouseNoteError,
    Options<CreateWheelhouseNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWheelhouseNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: createWheelhouseNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * add a note to an encounter
 */
export const useCreateWheelhouseNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CreateWheelhouseNoteResponse,
        CreateWheelhouseNoteError,
        Options<CreateWheelhouseNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...createWheelhouseNoteMutation(), ...mutationOptions })

export const deleteWheelhouseNoteMutationKey = (
  options?: Partial<Options<DeleteWheelhouseNoteData>>
) => createMutationKey('deleteWheelhouseNote', options)

/**
 * delete a draft note
 */
export const deleteWheelhouseNoteMutation = (
  options?: Partial<Options<DeleteWheelhouseNoteData>>
): UseMutationOptions<
  DeleteWheelhouseNoteResponse,
  DefaultError,
  Options<DeleteWheelhouseNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteWheelhouseNoteResponse,
    DefaultError,
    Options<DeleteWheelhouseNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteWheelhouseNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: deleteWheelhouseNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * delete a draft note
 */
export const useDeleteWheelhouseNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        DeleteWheelhouseNoteResponse,
        DefaultError,
        Options<DeleteWheelhouseNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...deleteWheelhouseNoteMutation(), ...mutationOptions })

export const updateWheelhouseNoteMutationKey = (
  options?: Partial<Options<UpdateWheelhouseNoteData>>
) => createMutationKey('updateWheelhouseNote', options)

/**
 * autosave a note's body
 */
export const updateWheelhouseNoteMutation = (
  options?: Partial<Options<UpdateWheelhouseNoteData>>
): UseMutationOptions<
  UpdateWheelhouseNoteResponse,
  UpdateWheelhouseNoteError,
  Options<UpdateWheelhouseNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWheelhouseNoteResponse,
    UpdateWheelhouseNoteError,
    Options<UpdateWheelhouseNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWheelhouseNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: updateWheelhouseNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * autosave a note's body
 */
export const useUpdateWheelhouseNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        UpdateWheelhouseNoteResponse,
        UpdateWheelhouseNoteError,
        Options<UpdateWheelhouseNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...updateWheelhouseNoteMutation(), ...mutationOptions })

export const completeWheelhouseNoteMutationKey = (
  options?: Partial<Options<CompleteWheelhouseNoteData>>
) => createMutationKey('completeWheelhouseNote', options)

/**
 * complete (attest) a note
 */
export const completeWheelhouseNoteMutation = (
  options?: Partial<Options<CompleteWheelhouseNoteData>>
): UseMutationOptions<
  CompleteWheelhouseNoteResponse,
  CompleteWheelhouseNoteError,
  Options<CompleteWheelhouseNoteData>
> => {
  const mutationOptions: UseMutationOptions<
    CompleteWheelhouseNoteResponse,
    CompleteWheelhouseNoteError,
    Options<CompleteWheelhouseNoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeWheelhouseNote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
    mutationKey: completeWheelhouseNoteMutationKey(options),
  }
  return mutationOptions
}

/**
 * complete (attest) a note
 */
export const useCompleteWheelhouseNoteMutation = (
  mutationOptions?: Partial<
    Omit<
      UseMutationOptions<
        CompleteWheelhouseNoteResponse,
        CompleteWheelhouseNoteError,
        Options<CompleteWheelhouseNoteData>
      >,
      'mutationFn'
    >
  >
) => useMutation({ ...completeWheelhouseNoteMutation(), ...mutationOptions })

export const wheelhouseSessionQueryKey = (options?: Options<WheelhouseSessionData>) =>
  createQueryKey('wheelhouseSession', options)

/**
 * show the signed-in provider's identity and school
 */
export const wheelhouseSessionOptions = (options?: Options<WheelhouseSessionData>) =>
  queryOptions<
    WheelhouseSessionResponse,
    WheelhouseSessionError,
    WheelhouseSessionResponse,
    ReturnType<typeof wheelhouseSessionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await wheelhouseSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: wheelhouseSessionQueryKey(options),
  })

/**
 * show the signed-in provider's identity and school
 */
export const useWheelhouseSessionQuery = (options?: Options<WheelhouseSessionData>) =>
  useQuery(wheelhouseSessionOptions(options))
